(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirece63"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirece63"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jHdY8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e56cde68d4df089d$export$2e2bcd8739ae039);

var $bvJM2 = parcelRequire("bvJM2");
// Returns the number of full stop in given string.
const $e56cde68d4df089d$var$countFullstops = (str)=>str.replace(/[^.]/g, "").length;
var $e56cde68d4df089d$export$2e2bcd8739ae039 = {
    name: "number",
    props: {
        from: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        to: {
            type: [
                Number,
                String
            ],
            required: true,
            default: 0
        },
        format: {
            type: Function,
            default: (num)=>parseInt(num)
        },
        duration: {
            type: Number,
            default: 1 // Duration of animation in seconds
        },
        easing: {
            type: String,
            default: "Power1.easeOut"
        },
        delay: {
            type: Number,
            default: 0 // Delay the animation in seconds
        },
        tag: {
            type: String,
            default: "span"
        },
        animationPaused: Boolean // Stops animation before start
    },
    data () {
        return {
            fromProp: this.from
        };
    },
    computed: {
        tweenedNumber () {
            return this.format(this.fromProp);
        }
    },
    methods: {
        tween (value) {
            const vm = this;
            const tLite = (0, $bvJM2.TweenLite).to(vm.$data, vm.duration, {
                fromProp: value,
                paused: vm.animationPaused,
                ease: vm.easeCheck(),
                onStart: ()=>vm.$emit("start"),
                onComplete: ()=>vm.$emit("complete"),
                onUpdate: ()=>vm.$emit("update"),
                delay: vm.delay // In seconds
            });
            vm.tween.tLite = tLite;
        },
        play () {
            this.tween.tLite.play();
        },
        pause () {
            this.tween.tLite.pause();
        },
        restart () {
            this.tween.tLite.restart();
        },
        easeCheck () {
            const vm = this;
            if ($e56cde68d4df089d$var$countFullstops(vm.easing) !== 1) throw new Error('Invalid ease type. (eg. easing="Power1.easeOut")');
            return vm.easing;
        }
    },
    watch: {
        to (newValue) {
            this.tween(newValue);
        }
    },
    mounted () {
        this.tween(this.to);
    }
};

});
parcelRegister("bvJM2", function(module, exports) {

$parcel$export(module.exports, "TweenLite", () => Tween);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});


parcelRegister("g7H9T", function(module, exports) {

$parcel$export(module.exports, "render", () => $bbcec72e1f7ee6f1$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $bvAw5 = parcelRequire("bvAw5");
var $ltDz5 = parcelRequire("ltDz5");
function $bbcec72e1f7ee6f1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $bvAw5.openBlock)(), (0, $bvAw5.createBlock)((0, $bvAw5.resolveDynamicComponent)($props.tag), null, {
        default: (0, $bvAw5.withCtx)(()=>[
                (0, $bvAw5.createTextVNode)((0, $ltDz5.toDisplayString)($options.tweenedNumber), 1)
            ]),
        _: 1
    });
}

});
parcelRegister("ey4ci", function(module, exports) {
$parcel$export(module.exports, "createApp", () => (parcelRequire("k72mp")).createApp);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("k72mp")).vModelText);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("k72mp")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("k72mp")).withModifiers);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("bvAw5")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("bvAw5")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("bvAw5")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("bvAw5")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("bvAw5")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("bvAw5")).createVNode);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("bvAw5")).Fragment);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("bvAw5")).initCustomFormatter);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("ltDz5")).normalizeClass);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("bvAw5")).openBlock);
$parcel$export(module.exports, "reactive", () => (parcelRequire("uDJ7A")).reactive);
$parcel$export(module.exports, "renderList", () => (parcelRequire("bvAw5")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("bvAw5")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("bvAw5")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("bvAw5")).resolveDynamicComponent);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("bvAw5")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("bvAw5")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("ltDz5")).toDisplayString);
parcelRequire("k72mp");
var $bvAw5 = parcelRequire("bvAw5");parcelRequire("ltDz5");
function $a9777f2bcb9d7de1$var$initDev() {
    (0, $bvAw5.initCustomFormatter)();
}
const $a9777f2bcb9d7de1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("k72mp", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("bvAw5")).BaseTransition);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("bvAw5")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("ltDz5")).camelize);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("bvAw5")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("bvAw5")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("bvAw5")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("bvAw5")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("bvAw5")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("bvAw5")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("bvAw5")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("bvAw5")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("bvAw5")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("bvAw5")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("bvAw5")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("bvAw5")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("bvAw5")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("bvAw5")).initCustomFormatter);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("bvAw5")).isRuntimeOnly);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("bvAw5")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("ltDz5")).normalizeClass);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("bvAw5")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("bvAw5")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("bvAw5")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("bvAw5")).openBlock);
$parcel$export(module.exports, "reactive", () => (parcelRequire("uDJ7A")).reactive);
$parcel$export(module.exports, "renderList", () => (parcelRequire("bvAw5")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("bvAw5")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("bvAw5")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("bvAw5")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("bvAw5")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("bvAw5")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("bvAw5")).Static);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("uDJ7A")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("bvAw5")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("bvAw5")).warn);
$parcel$export(module.exports, "watchPostEffect", () => (parcelRequire("bvAw5")).watchPostEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("bvAw5")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("bvAw5")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("ltDz5")).toDisplayString);

$parcel$export(module.exports, "vModelText", () => $ea464ad56f9ba249$export$f1f88689f5728478);
$parcel$export(module.exports, "withModifiers", () => $ea464ad56f9ba249$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $ea464ad56f9ba249$export$f691a8759658f782);
$parcel$export(module.exports, "createApp", () => $ea464ad56f9ba249$export$4e373c34abfa8c68);

var $bvAw5 = parcelRequire("bvAw5");
var $ltDz5 = parcelRequire("ltDz5");
var $uDJ7A = parcelRequire("uDJ7A");parcelRequire("ltDz5");

var $ltDz5 = parcelRequire("ltDz5");
const $ea464ad56f9ba249$var$svgNS = "http://www.w3.org/2000/svg";
const $ea464ad56f9ba249$var$doc = typeof document !== "undefined" ? document : null;
const $ea464ad56f9ba249$var$templateContainer = $ea464ad56f9ba249$var$doc && /*#__PURE__*/ $ea464ad56f9ba249$var$doc.createElement("template");
const $ea464ad56f9ba249$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $ea464ad56f9ba249$var$doc.createElementNS($ea464ad56f9ba249$var$svgNS, tag) : $ea464ad56f9ba249$var$doc.createElement(tag, is ? {
            is: is
        } : undefined);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$ea464ad56f9ba249$var$doc.createTextNode(text),
    createComment: (text)=>$ea464ad56f9ba249$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$ea464ad56f9ba249$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    cloneNode (el) {
        const cloned = el.cloneNode(true);
        // #3072
        // - in `patchDOMProp`, we store the actual value in the `el._value` property.
        // - normally, elements using `:value` bindings will not be hoisted, but if
        //   the bound value is a constant, e.g. `:value="true"` - they do get
        //   hoisted.
        // - in production, hoisted nodes are cloned when subsequent inserts, but
        //   cloneNode() does not copy the custom property we attached.
        // - This may need to account for other custom DOM properties we attach to
        //   elements in addition to `_value` in the future.
        if (`_value` in el) cloned._value = el._value;
        return cloned;
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        // <parent> before | first ... last | anchor </parent>
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        // #5308 can only take cached path if:
        // - has a single root node
        // - nextSibling info is still available
        if (start && (start === end || start.nextSibling)) // cached
        while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            // fresh insert
            $ea464ad56f9ba249$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $ea464ad56f9ba249$var$templateContainer.content;
            if (isSVG) {
                // remove outer svg wrapper
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
// compiler should normalize class + :class bindings on the same element
// into a single binding ['staticClass', dynamic]
function $ea464ad56f9ba249$var$patchClass(el, value, isSVG) {
    // directly setting className should be faster than setAttribute in theory
    // if this is an element during a transition, take the temporary transition
    // classes into account.
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $ea464ad56f9ba249$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $ltDz5.isString)(next);
    if (next && !isCssString) {
        for(const key in next)$ea464ad56f9ba249$var$setStyle(style, key, next[key]);
        if (prev && !(0, $ltDz5.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $ea464ad56f9ba249$var$setStyle(style, key, "");
        }
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        // indicates that the `display` of the element is controlled by `v-show`,
        // so we always keep the current `display` value regardless of the `style`
        // value, thus handing over control to `v-show`.
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $ea464ad56f9ba249$var$importantRE = /\s*!important$/;
function $ea464ad56f9ba249$var$setStyle(style, name, val) {
    if ((0, $ltDz5.isArray)(val)) val.forEach((v)=>$ea464ad56f9ba249$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) // custom property definition
        style.setProperty(name, val);
        else {
            const prefixed = $ea464ad56f9ba249$var$autoPrefix(style, name);
            if ($ea464ad56f9ba249$var$importantRE.test(val)) // !important
            style.setProperty((0, $ltDz5.hyphenate)(prefixed), val.replace($ea464ad56f9ba249$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $ea464ad56f9ba249$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $ea464ad56f9ba249$var$prefixCache = {};
function $ea464ad56f9ba249$var$autoPrefix(style, rawName) {
    const cached = $ea464ad56f9ba249$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $ltDz5.camelize)(rawName);
    if (name !== "filter" && name in style) return $ea464ad56f9ba249$var$prefixCache[rawName] = name;
    name = (0, $ltDz5.capitalize)(name);
    for(let i = 0; i < $ea464ad56f9ba249$var$prefixes.length; i++){
        const prefixed = $ea464ad56f9ba249$var$prefixes[i] + name;
        if (prefixed in style) return $ea464ad56f9ba249$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $ea464ad56f9ba249$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $ea464ad56f9ba249$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($ea464ad56f9ba249$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($ea464ad56f9ba249$var$xlinkNS, key, value);
    } else {
        // note we are only checking boolean attributes that don't have a
        // corresponding dom prop of the same name here.
        const isBoolean = (0, $ltDz5.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $ltDz5.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
// __UNSAFE__
// functions. The user is responsible for using them with only trusted content.
function $ea464ad56f9ba249$var$patchDOMProp(el, key, value, // the following args are passed only due to potential innerHTML/textContent
// overriding existing VNodes, in which case the old tree must be properly
// unmounted.
prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    if (key === "value" && el.tagName !== "PROGRESS" && // custom elements may use _value internally
    !el.tagName.includes("-")) {
        // store value as _value as well since
        // non-string values will be stringified.
        el._value = value;
        const newValue = value == null ? "" : value;
        if (el.value !== newValue || // #4956: always set for OPTION elements because its value falls back to
        // textContent if no value attribute is present. And setting .value for
        // OPTION has no side effect
        el.tagName === "OPTION") el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") // e.g. <select multiple> compiles to { multiple: '' }
        value = (0, $ltDz5.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            // e.g. <div :id="null">
            value = "";
            needRemove = true;
        } else if (type === "number") {
            // e.g. <img :width="null">
            // the value of some IDL attr must be greater than 0, e.g. input.size = 0 -> error
            value = 0;
            needRemove = true;
        }
    }
    // some properties perform value validation and throw,
    // some properties has getter, no setter, will error in 'use strict'
    // eg. <select :type="null"></select> <select :willValidate="null"></select>
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
// Async edge case fix requires storing an event listener's attach timestamp.
const [$ea464ad56f9ba249$var$_getNow, $ea464ad56f9ba249$var$skipTimestampCheck] = /*#__PURE__*/ (()=>{
    let _getNow = Date.now;
    let skipTimestampCheck = false;
    if (typeof window !== "undefined") {
        // Determine what event timestamp the browser is using. Annoyingly, the
        // timestamp can either be hi-res (relative to page load) or low-res
        // (relative to UNIX epoch), so in order to compare time we have to use the
        // same timestamp type when saving the flush timestamp.
        if (Date.now() > document.createEvent("Event").timeStamp) // if the low-res timestamp which is bigger than the event timestamp
        // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listeners as well.
        _getNow = performance.now.bind(performance);
        // #3485: Firefox <= 53 has incorrect Event.timeStamp implementation
        // and does not fire microtasks in between event propagation, so safe to exclude.
        const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
        skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
    }
    return [
        _getNow,
        skipTimestampCheck
    ];
})();
// To avoid the overhead of repeatedly calling performance.now(), we cache
// and use the same timestamp for all event listeners attached in the same tick.
let $ea464ad56f9ba249$var$cachedNow = 0;
const $ea464ad56f9ba249$var$p = /*#__PURE__*/ Promise.resolve();
const $ea464ad56f9ba249$var$reset = ()=>{
    $ea464ad56f9ba249$var$cachedNow = 0;
};
const $ea464ad56f9ba249$var$getNow = ()=>$ea464ad56f9ba249$var$cachedNow || ($ea464ad56f9ba249$var$p.then($ea464ad56f9ba249$var$reset), $ea464ad56f9ba249$var$cachedNow = $ea464ad56f9ba249$var$_getNow());
function $ea464ad56f9ba249$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $ea464ad56f9ba249$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $ea464ad56f9ba249$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    // vei = vue event invokers
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) // patch
    existingInvoker.value = nextValue;
    else {
        const [name, options] = $ea464ad56f9ba249$var$parseName(rawName);
        if (nextValue) {
            // add
            const invoker = invokers[rawName] = $ea464ad56f9ba249$var$createInvoker(nextValue, instance);
            $ea464ad56f9ba249$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            // remove
            $ea464ad56f9ba249$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = undefined;
        }
    }
}
const $ea464ad56f9ba249$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $ea464ad56f9ba249$var$parseName(name) {
    let options;
    if ($ea464ad56f9ba249$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($ea464ad56f9ba249$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    return [
        (0, $ltDz5.hyphenate)(name.slice(2)),
        options
    ];
}
function $ea464ad56f9ba249$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        // async edge case #6566: inner click event triggers patch, event handler
        // attached to outer element during patch, and triggered again. This
        // happens because browsers fire microtask ticks between event propagation.
        // the solution is simple: we save the timestamp when a handler is attached,
        // and the handler would only fire if the event passed to it was fired
        // AFTER it was attached.
        const timeStamp = e.timeStamp || $ea464ad56f9ba249$var$_getNow();
        if ($ea464ad56f9ba249$var$skipTimestampCheck || timeStamp >= invoker.attached - 1) (0, $bvAw5.callWithAsyncErrorHandling)($ea464ad56f9ba249$var$patchStopImmediatePropagation(e, invoker.value), instance, 5 /* NATIVE_EVENT_HANDLER */ , [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $ea464ad56f9ba249$var$getNow();
    return invoker;
}
function $ea464ad56f9ba249$var$patchStopImmediatePropagation(e, value) {
    if ((0, $ltDz5.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e)=>!e._stopped && fn && fn(e));
    } else return value;
}
const $ea464ad56f9ba249$var$nativeOnRE = /^on[a-z]/;
const $ea464ad56f9ba249$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $ea464ad56f9ba249$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $ea464ad56f9ba249$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $ltDz5.isOn)(key)) // ignore v-model listeners
    {
        if (!(0, $ltDz5.isModelListener)(key)) $ea464ad56f9ba249$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $ea464ad56f9ba249$var$shouldSetAsProp(el, key, nextValue, isSVG)) $ea464ad56f9ba249$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        // special case for <input v-model type="checkbox"> with
        // :true-value & :false-value
        // store value as dom properties since non-string values will be
        // stringified.
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $ea464ad56f9ba249$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $ea464ad56f9ba249$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        // most keys must be set as attribute on svg elements to work
        // ...except innerHTML & textContent
        if (key === "innerHTML" || key === "textContent") return true;
        // or native onclick with function values
        if (key in el && $ea464ad56f9ba249$var$nativeOnRE.test(key) && (0, $ltDz5.isFunction)(value)) return true;
        return false;
    }
    // these are enumerated attrs, however their corresponding DOM properties
    // are actually booleans - this leads to setting it with a string "false"
    // value leading it to be coerced to `true`, so we need to always treat
    // them as attributes.
    // Note that `contentEditable` doesn't have this problem: its DOM
    // property is also enumerated string values.
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    // #1787, #2840 form property on form elements is readonly and must be set as
    // attribute.
    if (key === "form") return false;
    // #1526 <input list> must be set as attribute
    if (key === "list" && el.tagName === "INPUT") return false;
    // #2766 <textarea type> must be set as attribute
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    // native onclick with string value, must be set as attribute
    if ($ea464ad56f9ba249$var$nativeOnRE.test(key) && (0, $ltDz5.isString)(value)) return false;
    return key in el;
}
function $ea464ad56f9ba249$export$a00e2346eabbdbef(options, hydrate) {
    const Comp = (0, $bvAw5.defineComponent)(options);
    class VueCustomElement extends $ea464ad56f9ba249$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $ea464ad56f9ba249$export$6debb2e68f212638 = (options)=>{
    // @ts-ignore
    return $ea464ad56f9ba249$export$a00e2346eabbdbef(options, $ea464ad56f9ba249$export$fa8d919ba61d84db);
};
const $ea464ad56f9ba249$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $ea464ad56f9ba249$export$b337c1a55163dbe3 extends $ea464ad56f9ba249$var$BaseClass {
    constructor(_def, _props = {}, hydrate){
        super();
        this._def = _def;
        this._props = _props;
        /**
         * @internal
         */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate) hydrate(this._createVNode(), this.shadowRoot);
        else this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) this._resolveDef();
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $bvAw5.nextTick)(()=>{
            if (!this._connected) {
                $ea464ad56f9ba249$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
     * resolve inner component definition (handle possible async component)
     */ _resolveDef() {
        if (this._resolved) return;
        this._resolved = true;
        // set initial attrs
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        // watch future attr changes
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def)=>{
            const { props: props, styles: styles } = def;
            const hasOptions = !(0, $ltDz5.isArray)(props);
            const rawKeys = props ? hasOptions ? Object.keys(props) : props : [];
            // cast Number-type props set before resolve
            let numberProps;
            if (hasOptions) for(const key in this._props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    this._props[key] = (0, $ltDz5.toNumber)(this._props[key]);
                    (numberProps || (numberProps = Object.create(null)))[key] = true;
                }
            }
            this._numberProps = numberProps;
            // check if there are props set pre-upgrade or connect
            for (const key of Object.keys(this))if (key[0] !== "_") this._setProp(key, this[key], true, false);
            // defining getter/setters on prototype
            for (const key of rawKeys.map((0, $ltDz5.camelize)))Object.defineProperty(this, key, {
                get () {
                    return this._getProp(key);
                },
                set (val) {
                    this._setProp(key, val);
                }
            });
            // apply CSS
            this._applyStyles(styles);
            // initial render
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then(resolve);
        else resolve(this._def);
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        if (this._numberProps && this._numberProps[key]) value = (0, $ltDz5.toNumber)(value);
        this._setProp((0, $ltDz5.camelize)(key), value, false);
    }
    /**
     * @internal
     */ _getProp(key) {
        return this._props[key];
    }
    /**
     * @internal
     */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            // reflect
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $ltDz5.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $ltDz5.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $ltDz5.hyphenate)(key));
            }
        }
    }
    _update() {
        $ea464ad56f9ba249$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $bvAw5.createVNode)(this._def, (0, $ltDz5.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            // intercept emit
            instance.emit = (event, ...args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            // locate nearest Vue custom element parent for provide/inject
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $ea464ad56f9ba249$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $ea464ad56f9ba249$export$9300d5b90d56e3d1(name = "$style") {
    /* istanbul ignore else */ {
        const instance = (0, $bvAw5.getCurrentInstance)();
        if (!instance) return 0, $ltDz5.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $ltDz5.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $ltDz5.EMPTY_OBJ;
        return mod;
    }
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $ea464ad56f9ba249$export$ef28b76f07940108(getter) {
    const instance = (0, $bvAw5.getCurrentInstance)();
    /* istanbul ignore next */ if (!instance) return;
    const setVars = ()=>$ea464ad56f9ba249$var$setVarsOnVNode(instance.subTree, getter(instance.proxy));
    (0, $bvAw5.watchPostEffect)(setVars);
    (0, $bvAw5.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $bvAw5.onUnmounted)(()=>ob.disconnect());
    });
}
function $ea464ad56f9ba249$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $ea464ad56f9ba249$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    // drill down HOCs until it's a non-component vnode
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 /* ELEMENT */  && vnode.el) $ea464ad56f9ba249$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $bvAw5.Fragment)) vnode.children.forEach((c)=>$ea464ad56f9ba249$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $bvAw5.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $ea464ad56f9ba249$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $ea464ad56f9ba249$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $ea464ad56f9ba249$var$TRANSITION = "transition";
const $ea464ad56f9ba249$var$ANIMATION = "animation";
// DOM Transition is a higher-order-component based on the platform-agnostic
// base Transition component, with DOM-specific logic.
const $ea464ad56f9ba249$export$be58926105124dd4 = (props, { slots: slots })=>(0, $bvAw5.h)((0, $bvAw5.BaseTransition), $ea464ad56f9ba249$var$resolveTransitionProps(props), slots);
$ea464ad56f9ba249$export$be58926105124dd4.displayName = "Transition";
const $ea464ad56f9ba249$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $ea464ad56f9ba249$var$TransitionPropsValidators = $ea464ad56f9ba249$export$be58926105124dd4.props = /*#__PURE__*/ (0, $ltDz5.extend)({}, (0, $bvAw5.BaseTransition).props, $ea464ad56f9ba249$var$DOMTransitionPropsValidators);
/**
 * #3227 Incoming hooks may be merged into arrays when wrapping Transition
 * with custom HOCs.
 */ const $ea464ad56f9ba249$var$callHook = (hook, args = [])=>{
    if ((0, $ltDz5.isArray)(hook)) hook.forEach((h)=>h(...args));
    else if (hook) hook(...args);
};
/**
 * Check if a hook expects a callback (2nd arg), which means the user
 * intends to explicitly control the end of the transition.
 */ const $ea464ad56f9ba249$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $ltDz5.isArray)(hook) ? hook.some((h)=>h.length > 1) : hook.length > 1 : false;
};
function $ea464ad56f9ba249$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $ea464ad56f9ba249$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $ea464ad56f9ba249$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $ea464ad56f9ba249$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $ea464ad56f9ba249$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $ea464ad56f9ba249$var$removeTransitionClass(el, leaveFromClass);
        $ea464ad56f9ba249$var$removeTransitionClass(el, leaveToClass);
        $ea464ad56f9ba249$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $ea464ad56f9ba249$var$callHook(hook, [
                el,
                resolve
            ]);
            $ea464ad56f9ba249$var$nextFrame(()=>{
                $ea464ad56f9ba249$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $ea464ad56f9ba249$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$ea464ad56f9ba249$var$hasExplicitCallback(hook)) $ea464ad56f9ba249$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $ltDz5.extend)(baseProps, {
        onBeforeEnter (el) {
            $ea464ad56f9ba249$var$callHook(onBeforeEnter, [
                el
            ]);
            $ea464ad56f9ba249$var$addTransitionClass(el, enterFromClass);
            $ea464ad56f9ba249$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $ea464ad56f9ba249$var$callHook(onBeforeAppear, [
                el
            ]);
            $ea464ad56f9ba249$var$addTransitionClass(el, appearFromClass);
            $ea464ad56f9ba249$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $ea464ad56f9ba249$var$addTransitionClass(el, leaveFromClass);
            // force reflow so *-leave-from classes immediately take effect (#2593)
            $ea464ad56f9ba249$var$forceReflow();
            $ea464ad56f9ba249$var$addTransitionClass(el, leaveActiveClass);
            $ea464ad56f9ba249$var$nextFrame(()=>{
                if (!el._isLeaving) // cancelled
                return;
                $ea464ad56f9ba249$var$removeTransitionClass(el, leaveFromClass);
                $ea464ad56f9ba249$var$addTransitionClass(el, leaveToClass);
                if (!$ea464ad56f9ba249$var$hasExplicitCallback(onLeave)) $ea464ad56f9ba249$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $ea464ad56f9ba249$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $ea464ad56f9ba249$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $ea464ad56f9ba249$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $ea464ad56f9ba249$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $ea464ad56f9ba249$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $ltDz5.isObject)(duration)) return [
        $ea464ad56f9ba249$var$NumberOf(duration.enter),
        $ea464ad56f9ba249$var$NumberOf(duration.leave)
    ];
    else {
        const n = $ea464ad56f9ba249$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $ea464ad56f9ba249$var$NumberOf(val) {
    const res = (0, $ltDz5.toNumber)(val);
    return res;
}
function $ea464ad56f9ba249$var$validateDuration(val) {
    if (typeof val !== "number") (0, $bvAw5.warn)(`<transition> explicit duration is not a valid number - ` + `got ${JSON.stringify(val)}.`);
    else if (isNaN(val)) (0, $bvAw5.warn)(`<transition> explicit duration is NaN - ` + "the duration expression might be incorrect.");
}
function $ea464ad56f9ba249$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = new Set())).add(cls);
}
function $ea464ad56f9ba249$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = undefined;
    }
}
function $ea464ad56f9ba249$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $ea464ad56f9ba249$var$endId = 0;
function $ea464ad56f9ba249$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$ea464ad56f9ba249$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $ea464ad56f9ba249$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $ea464ad56f9ba249$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties($ea464ad56f9ba249$var$TRANSITION + "Delay");
    const transitionDurations = getStyleProperties($ea464ad56f9ba249$var$TRANSITION + "Duration");
    const transitionTimeout = $ea464ad56f9ba249$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties($ea464ad56f9ba249$var$ANIMATION + "Delay");
    const animationDurations = getStyleProperties($ea464ad56f9ba249$var$ANIMATION + "Duration");
    const animationTimeout = $ea464ad56f9ba249$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    /* istanbul ignore if */ if (expectedType === $ea464ad56f9ba249$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $ea464ad56f9ba249$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $ea464ad56f9ba249$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $ea464ad56f9ba249$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $ea464ad56f9ba249$var$TRANSITION : $ea464ad56f9ba249$var$ANIMATION : null;
        propCount = type ? type === $ea464ad56f9ba249$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $ea464ad56f9ba249$var$TRANSITION && /\b(transform|all)(,|$)/.test(styles[$ea464ad56f9ba249$var$TRANSITION + "Property"]);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $ea464ad56f9ba249$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$ea464ad56f9ba249$var$toMs(d) + $ea464ad56f9ba249$var$toMs(delays[i])));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
// numbers in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down
// (i.e. acting as a floor function) causing unexpected behaviors
function $ea464ad56f9ba249$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1000;
}
// synchronously force layout to put elements into a certain state
function $ea464ad56f9ba249$var$forceReflow() {
    return document.body.offsetHeight;
}
const $ea464ad56f9ba249$var$positionMap = new WeakMap();
const $ea464ad56f9ba249$var$newPositionMap = new WeakMap();
const $ea464ad56f9ba249$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /*#__PURE__*/ (0, $ltDz5.extend)({}, $ea464ad56f9ba249$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $bvAw5.getCurrentInstance)();
        const state = (0, $bvAw5.useTransitionState)();
        let prevChildren;
        let children;
        (0, $bvAw5.onUpdated)(()=>{
            // children is guaranteed to exist after initial render
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$ea464ad56f9ba249$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            // we divide the work into three loops to avoid mixing DOM reads and writes
            // in each iteration - which helps prevent layout thrashing.
            prevChildren.forEach($ea464ad56f9ba249$var$callPendingCbs);
            prevChildren.forEach($ea464ad56f9ba249$var$recordPosition);
            const movedChildren = prevChildren.filter($ea464ad56f9ba249$var$applyTranslation);
            // force reflow to put everything in position
            $ea464ad56f9ba249$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $ea464ad56f9ba249$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $ea464ad56f9ba249$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $uDJ7A.toRaw)(props);
            const cssTransitionProps = $ea464ad56f9ba249$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $bvAw5.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $bvAw5.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $bvAw5.setTransitionHooks)(child, (0, $bvAw5.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $bvAw5.setTransitionHooks)(child, (0, $bvAw5.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $ea464ad56f9ba249$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $bvAw5.createVNode)(tag, null, children);
        };
    }
};
const $ea464ad56f9ba249$export$19ffa8f511f7bc2e = $ea464ad56f9ba249$var$TransitionGroupImpl;
function $ea464ad56f9ba249$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $ea464ad56f9ba249$var$recordPosition(c) {
    $ea464ad56f9ba249$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $ea464ad56f9ba249$var$applyTranslation(c) {
    const oldPos = $ea464ad56f9ba249$var$positionMap.get(c);
    const newPos = $ea464ad56f9ba249$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $ea464ad56f9ba249$var$hasCSSTransform(el, root, moveClass) {
    // Detect whether an element with the move class applied has
    // CSS transitions. Since the element may be inside an entering
    // transition at this very moment, we make a clone of it and remove
    // all other transition classes applied to ensure only the move class
    // is applied.
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $ea464ad56f9ba249$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $ea464ad56f9ba249$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $ltDz5.isArray)(fn) ? (value)=>(0, $ltDz5.invokeArrayFns)(fn, value) : fn;
};
function $ea464ad56f9ba249$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $ea464ad56f9ba249$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
// We are exporting the v-model runtime directly as vnode hooks so that it can
// be tree-shaken in case v-model is never used.
const $ea464ad56f9ba249$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $ea464ad56f9ba249$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $ltDz5.toNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $ea464ad56f9ba249$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $ea464ad56f9ba249$var$addEventListener(el, "compositionstart", $ea464ad56f9ba249$var$onCompositionStart);
            $ea464ad56f9ba249$var$addEventListener(el, "compositionend", $ea464ad56f9ba249$var$onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            $ea464ad56f9ba249$var$addEventListener(el, "change", $ea464ad56f9ba249$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
        // avoid clearing unresolved text. #2302
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $ltDz5.toNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $ea464ad56f9ba249$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
        $ea464ad56f9ba249$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $ea464ad56f9ba249$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $ltDz5.isArray)(modelValue)) {
                const index = (0, $ltDz5.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $ltDz5.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($ea464ad56f9ba249$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $ea464ad56f9ba249$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
        $ea464ad56f9ba249$var$setChecked(el, binding, vnode);
    }
};
function $ea464ad56f9ba249$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $ltDz5.isArray)(value)) el.checked = (0, $ltDz5.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $ltDz5.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $ltDz5.looseEqual)(value, $ea464ad56f9ba249$var$getCheckboxValue(el, true));
}
const $ea464ad56f9ba249$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $ltDz5.looseEqual)(value, vnode.props.value);
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
        $ea464ad56f9ba249$var$addEventListener(el, "change", ()=>{
            el._assign($ea464ad56f9ba249$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $ltDz5.looseEqual)(value, vnode.props.value);
    }
};
const $ea464ad56f9ba249$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $ltDz5.isSet)(value);
        $ea464ad56f9ba249$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $ltDz5.toNumber)($ea464ad56f9ba249$var$getValue(o)) : $ea464ad56f9ba249$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $ea464ad56f9ba249$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $ea464ad56f9ba249$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $ea464ad56f9ba249$var$setSelected(el, value);
    }
};
function $ea464ad56f9ba249$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $ltDz5.isArray)(value) && !(0, $ltDz5.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $ea464ad56f9ba249$var$getValue(option);
        if (isMultiple) {
            if ((0, $ltDz5.isArray)(value)) option.selected = (0, $ltDz5.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $ltDz5.looseEqual)($ea464ad56f9ba249$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
// retrieve raw value set via :value bindings
function $ea464ad56f9ba249$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
function $ea464ad56f9ba249$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $ea464ad56f9ba249$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $ea464ad56f9ba249$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $ea464ad56f9ba249$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $ea464ad56f9ba249$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $ea464ad56f9ba249$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $ea464ad56f9ba249$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $ea464ad56f9ba249$export$87d227567b51ca39;
        case "TEXTAREA":
            return $ea464ad56f9ba249$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $ea464ad56f9ba249$export$8847c2e532b35714;
                case "radio":
                    return $ea464ad56f9ba249$export$b4356c59b38b7aa9;
                default:
                    return $ea464ad56f9ba249$export$f1f88689f5728478;
            }
    }
}
function $ea464ad56f9ba249$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $ea464ad56f9ba249$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $ea464ad56f9ba249$var$initVModelForSSR() {
    $ea464ad56f9ba249$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $ea464ad56f9ba249$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $ltDz5.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $ea464ad56f9ba249$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $ltDz5.isArray)(value)) {
            if (vnode.props && (0, $ltDz5.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $ltDz5.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $ea464ad56f9ba249$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $ea464ad56f9ba249$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $ea464ad56f9ba249$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $ea464ad56f9ba249$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$ea464ad56f9ba249$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
/**
 * @private
 */ const $ea464ad56f9ba249$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $ea464ad56f9ba249$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
// Kept for 2.x compat.
// Note: IE11 compat for `spacebar` and `del` is removed for now.
const $ea464ad56f9ba249$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
/**
 * @private
 */ const $ea464ad56f9ba249$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $ltDz5.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $ea464ad56f9ba249$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $ea464ad56f9ba249$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $ea464ad56f9ba249$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $ea464ad56f9ba249$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $ea464ad56f9ba249$var$setDisplay(el, false);
            });
        } else $ea464ad56f9ba249$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $ea464ad56f9ba249$var$setDisplay(el, value);
    }
};
function $ea464ad56f9ba249$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $ea464ad56f9ba249$var$initVShowForSSR() {
    $ea464ad56f9ba249$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $ea464ad56f9ba249$var$rendererOptions = /*#__PURE__*/ (0, $ltDz5.extend)({
    patchProp: $ea464ad56f9ba249$var$patchProp
}, $ea464ad56f9ba249$var$nodeOps);
// lazy create the renderer - this makes core renderer logic tree-shakable
// in case the user only imports reactivity utilities from Vue.
let $ea464ad56f9ba249$var$renderer;
let $ea464ad56f9ba249$var$enabledHydration = false;
function $ea464ad56f9ba249$var$ensureRenderer() {
    return $ea464ad56f9ba249$var$renderer || ($ea464ad56f9ba249$var$renderer = (0, $bvAw5.createRenderer)($ea464ad56f9ba249$var$rendererOptions));
}
function $ea464ad56f9ba249$var$ensureHydrationRenderer() {
    $ea464ad56f9ba249$var$renderer = $ea464ad56f9ba249$var$enabledHydration ? $ea464ad56f9ba249$var$renderer : (0, $bvAw5.createHydrationRenderer)($ea464ad56f9ba249$var$rendererOptions);
    $ea464ad56f9ba249$var$enabledHydration = true;
    return $ea464ad56f9ba249$var$renderer;
}
// use explicit type casts here to avoid import() calls in rolled-up d.ts
const $ea464ad56f9ba249$export$b3890eb0ae9dca99 = (...args)=>{
    $ea464ad56f9ba249$var$ensureRenderer().render(...args);
};
const $ea464ad56f9ba249$export$fa8d919ba61d84db = (...args)=>{
    $ea464ad56f9ba249$var$ensureHydrationRenderer().hydrate(...args);
};
const $ea464ad56f9ba249$export$4e373c34abfa8c68 = (...args)=>{
    const app = $ea464ad56f9ba249$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $ea464ad56f9ba249$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $ltDz5.isFunction)(component) && !component.render && !component.template) // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's
        // rendered by the server, the template should not contain any user data.
        component.template = container.innerHTML;
        // clear content before mounting
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $ea464ad56f9ba249$export$35800275c0037383 = (...args)=>{
    const app = $ea464ad56f9ba249$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $ea464ad56f9ba249$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $ea464ad56f9ba249$var$injectNativeTagCheck(app) {
    // Inject `isNativeTag`
    // this is used for component name validation (dev only)
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $ltDz5.isHTMLTag)(tag) || (0, $ltDz5.isSVGTag)(tag),
        writable: false
    });
}
// dev only
function $ea464ad56f9ba249$var$injectCompilerOptionsCheck(app) {
    if ((0, $bvAw5.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $bvAw5.warn)(`The \`isCustomElement\` config option is deprecated. Use ` + `\`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using ` + `a build of Vue.js that includes the runtime compiler (aka "full build"). ` + `Since you are using the runtime-only build, \`compilerOptions\` ` + `must be passed to \`@vue/compiler-dom\` in the build setup instead.\n` + `- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.\n` + `- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n` + `- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $bvAw5.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $bvAw5.warn)(msg);
            }
        });
    }
}
function $ea464ad56f9ba249$var$normalizeContainer(container) {
    if ((0, $ltDz5.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $ea464ad56f9ba249$var$ssrDirectiveInitialized = false;
/**
 * @internal
 */ const $ea464ad56f9ba249$export$800b28255aa678d9 = ()=>{
    if (!$ea464ad56f9ba249$var$ssrDirectiveInitialized) {
        $ea464ad56f9ba249$var$ssrDirectiveInitialized = true;
        $ea464ad56f9ba249$var$initVModelForSSR();
        $ea464ad56f9ba249$var$initVShowForSSR();
    }
};

});
parcelRegister("bvAw5", function(module, exports) {

$parcel$export(module.exports, "warn", () => $860eea622cdf5973$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $860eea622cdf5973$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $860eea622cdf5973$export$bdd553fddd433dcb);
$parcel$export(module.exports, "Fragment", () => $860eea622cdf5973$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $860eea622cdf5973$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $860eea622cdf5973$export$694b237e827a3d23);
$parcel$export(module.exports, "createVNode", () => $860eea622cdf5973$export$bf5c4cf060303d58);
$parcel$export(module.exports, "openBlock", () => $860eea622cdf5973$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "watchPostEffect", () => $860eea622cdf5973$export$b7f27ea67102d543);
$parcel$export(module.exports, "useTransitionState", () => $860eea622cdf5973$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $860eea622cdf5973$export$6d1641039221b5cb);
$parcel$export(module.exports, "getCurrentInstance", () => $860eea622cdf5973$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $860eea622cdf5973$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $860eea622cdf5973$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $860eea622cdf5973$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $860eea622cdf5973$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $860eea622cdf5973$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "onUpdated", () => $860eea622cdf5973$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $860eea622cdf5973$export$13348a43ccacfe58);
$parcel$export(module.exports, "withDirectives", () => $860eea622cdf5973$export$49729353e7c1e6c5);
$parcel$export(module.exports, "resolveComponent", () => $860eea622cdf5973$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $860eea622cdf5973$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $860eea622cdf5973$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $860eea622cdf5973$export$4abee4c34694ada1);
$parcel$export(module.exports, "createBlock", () => $860eea622cdf5973$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "createTextVNode", () => $860eea622cdf5973$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "createRenderer", () => $860eea622cdf5973$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $860eea622cdf5973$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $860eea622cdf5973$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $860eea622cdf5973$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createCommentVNode", () => $860eea622cdf5973$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $860eea622cdf5973$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $860eea622cdf5973$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $860eea622cdf5973$export$aed4979be6a60047);
$parcel$export(module.exports, "reactive", () => (parcelRequire("uDJ7A")).reactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("uDJ7A")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("ltDz5")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("ltDz5")).normalizeClass);

var $uDJ7A = parcelRequire("uDJ7A");

var $ltDz5 = parcelRequire("ltDz5");
const $860eea622cdf5973$var$stack = [];
function $860eea622cdf5973$var$pushWarningContext(vnode) {
    $860eea622cdf5973$var$stack.push(vnode);
}
function $860eea622cdf5973$var$popWarningContext() {
    $860eea622cdf5973$var$stack.pop();
}
function $860eea622cdf5973$export$c106dd0671a0fc2d(msg, ...args) {
    // avoid props formatting or warn handler tracking deps that might be mutated
    // during patch, leading to infinite recursion.
    (0, $uDJ7A.pauseTracking)();
    const instance = $860eea622cdf5973$var$stack.length ? $860eea622cdf5973$var$stack[$860eea622cdf5973$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $860eea622cdf5973$var$getComponentTrace();
    if (appWarnHandler) $860eea622cdf5973$export$b22fcaf88446e9bf(appWarnHandler, instance, 11 /* APP_WARN_HANDLER */ , [
        msg + args.join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$860eea622cdf5973$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        /* istanbul ignore if */ if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`\n`, ...$860eea622cdf5973$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $uDJ7A.resetTracking)();
}
function $860eea622cdf5973$var$getComponentTrace() {
    let currentVNode = $860eea622cdf5973$var$stack[$860eea622cdf5973$var$stack.length - 1];
    if (!currentVNode) return [];
    // we can't just use the stack because it will be incomplete during updates
    // that did not start from the root. Re-construct the parent chain using
    // instance parent pointers.
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
/* istanbul ignore next */ function $860eea622cdf5973$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `\n`
        ], ...$860eea622cdf5973$var$formatTraceEntry(entry));
    });
    return logs;
}
function $860eea622cdf5973$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$860eea622cdf5973$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$860eea622cdf5973$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
/* istanbul ignore next */ function $860eea622cdf5973$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$860eea622cdf5973$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
/* istanbul ignore next */ function $860eea622cdf5973$var$formatProp(key, value, raw) {
    if ((0, $ltDz5.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $uDJ7A.isRef)(value)) {
        value = $860eea622cdf5973$var$formatProp(key, (0, $uDJ7A.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $ltDz5.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $uDJ7A.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
const $860eea622cdf5973$var$ErrorTypeStrings = {
    ["sp" /* SERVER_PREFETCH */ ]: "serverPrefetch hook",
    ["bc" /* BEFORE_CREATE */ ]: "beforeCreate hook",
    ["c" /* CREATED */ ]: "created hook",
    ["bm" /* BEFORE_MOUNT */ ]: "beforeMount hook",
    ["m" /* MOUNTED */ ]: "mounted hook",
    ["bu" /* BEFORE_UPDATE */ ]: "beforeUpdate hook",
    ["u" /* UPDATED */ ]: "updated",
    ["bum" /* BEFORE_UNMOUNT */ ]: "beforeUnmount hook",
    ["um" /* UNMOUNTED */ ]: "unmounted hook",
    ["a" /* ACTIVATED */ ]: "activated hook",
    ["da" /* DEACTIVATED */ ]: "deactivated hook",
    ["ec" /* ERROR_CAPTURED */ ]: "errorCaptured hook",
    ["rtc" /* RENDER_TRACKED */ ]: "renderTracked hook",
    ["rtg" /* RENDER_TRIGGERED */ ]: "renderTriggered hook",
    [0 /* SETUP_FUNCTION */ ]: "setup function",
    [1 /* RENDER_FUNCTION */ ]: "render function",
    [2 /* WATCH_GETTER */ ]: "watcher getter",
    [3 /* WATCH_CALLBACK */ ]: "watcher callback",
    [4 /* WATCH_CLEANUP */ ]: "watcher cleanup function",
    [5 /* NATIVE_EVENT_HANDLER */ ]: "native event handler",
    [6 /* COMPONENT_EVENT_HANDLER */ ]: "component event handler",
    [7 /* VNODE_HOOK */ ]: "vnode hook",
    [8 /* DIRECTIVE_HOOK */ ]: "directive hook",
    [9 /* TRANSITION_HOOK */ ]: "transition hook",
    [10 /* APP_ERROR_HANDLER */ ]: "app errorHandler",
    [11 /* APP_WARN_HANDLER */ ]: "app warnHandler",
    [12 /* FUNCTION_REF */ ]: "ref function",
    [13 /* ASYNC_COMPONENT_LOADER */ ]: "async component loader",
    [14 /* SCHEDULER */ ]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $860eea622cdf5973$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $860eea622cdf5973$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $860eea622cdf5973$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $ltDz5.isFunction)(fn)) {
        const res = $860eea622cdf5973$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $ltDz5.isPromise)(res)) res.catch((err)=>{
            $860eea622cdf5973$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($860eea622cdf5973$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $860eea622cdf5973$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        // the exposed instance is the render proxy to keep it consistent with 2.x
        const exposedInstance = instance.proxy;
        // in production the hook receives only the error code
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        // app-level handling
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $860eea622cdf5973$export$b22fcaf88446e9bf(appErrorHandler, null, 10 /* APP_ERROR_HANDLER */ , [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $860eea622cdf5973$var$logError(err, type, contextVNode, throwInDev);
}
function $860eea622cdf5973$var$logError(err, type, contextVNode, throwInDev = true) {
    // recover in prod to reduce the impact on end-user
    console.error(err);
}
let $860eea622cdf5973$var$isFlushing = false;
let $860eea622cdf5973$var$isFlushPending = false;
const $860eea622cdf5973$var$queue = [];
let $860eea622cdf5973$var$flushIndex = 0;
const $860eea622cdf5973$var$pendingPreFlushCbs = [];
let $860eea622cdf5973$var$activePreFlushCbs = null;
let $860eea622cdf5973$var$preFlushIndex = 0;
const $860eea622cdf5973$var$pendingPostFlushCbs = [];
let $860eea622cdf5973$var$activePostFlushCbs = null;
let $860eea622cdf5973$var$postFlushIndex = 0;
const $860eea622cdf5973$var$resolvedPromise = /*#__PURE__*/ Promise.resolve();
let $860eea622cdf5973$var$currentFlushPromise = null;
let $860eea622cdf5973$var$currentPreFlushParentJob = null;
const $860eea622cdf5973$var$RECURSION_LIMIT = 100;
function $860eea622cdf5973$export$bdd553fddd433dcb(fn) {
    const p = $860eea622cdf5973$var$currentFlushPromise || $860eea622cdf5973$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
// #2768
// Use binary-search to find a suitable position in the queue,
// so that the queue maintains the increasing order of job's id,
// which can prevent the job from being skipped and also can avoid repeated patching.
function $860eea622cdf5973$var$findInsertionIndex(id) {
    // the start index should be `flushIndex + 1`
    let start = $860eea622cdf5973$var$flushIndex + 1;
    let end = $860eea622cdf5973$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $860eea622cdf5973$var$getId($860eea622cdf5973$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $860eea622cdf5973$var$queueJob(job) {
    // the dedupe search uses the startIndex argument of Array.includes()
    // by default the search index includes the current job that is being run
    // so it cannot recursively trigger itself again.
    // if the job is a watch() callback, the search will start with a +1 index to
    // allow it recursively trigger itself - it is the user's responsibility to
    // ensure it doesn't end up in an infinite loop.
    if ((!$860eea622cdf5973$var$queue.length || !$860eea622cdf5973$var$queue.includes(job, $860eea622cdf5973$var$isFlushing && job.allowRecurse ? $860eea622cdf5973$var$flushIndex + 1 : $860eea622cdf5973$var$flushIndex)) && job !== $860eea622cdf5973$var$currentPreFlushParentJob) {
        if (job.id == null) $860eea622cdf5973$var$queue.push(job);
        else $860eea622cdf5973$var$queue.splice($860eea622cdf5973$var$findInsertionIndex(job.id), 0, job);
        $860eea622cdf5973$var$queueFlush();
    }
}
function $860eea622cdf5973$var$queueFlush() {
    if (!$860eea622cdf5973$var$isFlushing && !$860eea622cdf5973$var$isFlushPending) {
        $860eea622cdf5973$var$isFlushPending = true;
        $860eea622cdf5973$var$currentFlushPromise = $860eea622cdf5973$var$resolvedPromise.then($860eea622cdf5973$var$flushJobs);
    }
}
function $860eea622cdf5973$var$invalidateJob(job) {
    const i = $860eea622cdf5973$var$queue.indexOf(job);
    if (i > $860eea622cdf5973$var$flushIndex) $860eea622cdf5973$var$queue.splice(i, 1);
}
function $860eea622cdf5973$var$queueCb(cb, activeQueue, pendingQueue, index) {
    if (!(0, $ltDz5.isArray)(cb)) {
        if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index + 1 : index)) pendingQueue.push(cb);
    } else // if cb is an array, it is a component lifecycle hook which can only be
    // triggered by a job, which is already deduped in the main queue, so
    // we can skip duplicate check here to improve perf
    pendingQueue.push(...cb);
    $860eea622cdf5973$var$queueFlush();
}
function $860eea622cdf5973$var$queuePreFlushCb(cb) {
    $860eea622cdf5973$var$queueCb(cb, $860eea622cdf5973$var$activePreFlushCbs, $860eea622cdf5973$var$pendingPreFlushCbs, $860eea622cdf5973$var$preFlushIndex);
}
function $860eea622cdf5973$export$59536a0199721cab(cb) {
    $860eea622cdf5973$var$queueCb(cb, $860eea622cdf5973$var$activePostFlushCbs, $860eea622cdf5973$var$pendingPostFlushCbs, $860eea622cdf5973$var$postFlushIndex);
}
function $860eea622cdf5973$var$flushPreFlushCbs(seen, parentJob = null) {
    if ($860eea622cdf5973$var$pendingPreFlushCbs.length) {
        $860eea622cdf5973$var$currentPreFlushParentJob = parentJob;
        $860eea622cdf5973$var$activePreFlushCbs = [
            ...new Set($860eea622cdf5973$var$pendingPreFlushCbs)
        ];
        $860eea622cdf5973$var$pendingPreFlushCbs.length = 0;
        for($860eea622cdf5973$var$preFlushIndex = 0; $860eea622cdf5973$var$preFlushIndex < $860eea622cdf5973$var$activePreFlushCbs.length; $860eea622cdf5973$var$preFlushIndex++)$860eea622cdf5973$var$activePreFlushCbs[$860eea622cdf5973$var$preFlushIndex]();
        $860eea622cdf5973$var$activePreFlushCbs = null;
        $860eea622cdf5973$var$preFlushIndex = 0;
        $860eea622cdf5973$var$currentPreFlushParentJob = null;
        // recursively flush until it drains
        $860eea622cdf5973$var$flushPreFlushCbs(seen, parentJob);
    }
}
function $860eea622cdf5973$var$flushPostFlushCbs(seen) {
    // flush any pre cbs queued during the flush (e.g. pre watchers)
    $860eea622cdf5973$var$flushPreFlushCbs();
    if ($860eea622cdf5973$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($860eea622cdf5973$var$pendingPostFlushCbs)
        ];
        $860eea622cdf5973$var$pendingPostFlushCbs.length = 0;
        // #1947 already has active queue, nested flushPostFlushCbs call
        if ($860eea622cdf5973$var$activePostFlushCbs) {
            $860eea622cdf5973$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $860eea622cdf5973$var$activePostFlushCbs = deduped;
        $860eea622cdf5973$var$activePostFlushCbs.sort((a, b)=>$860eea622cdf5973$var$getId(a) - $860eea622cdf5973$var$getId(b));
        for($860eea622cdf5973$var$postFlushIndex = 0; $860eea622cdf5973$var$postFlushIndex < $860eea622cdf5973$var$activePostFlushCbs.length; $860eea622cdf5973$var$postFlushIndex++)$860eea622cdf5973$var$activePostFlushCbs[$860eea622cdf5973$var$postFlushIndex]();
        $860eea622cdf5973$var$activePostFlushCbs = null;
        $860eea622cdf5973$var$postFlushIndex = 0;
    }
}
const $860eea622cdf5973$var$getId = (job)=>job.id == null ? Infinity : job.id;
function $860eea622cdf5973$var$flushJobs(seen) {
    $860eea622cdf5973$var$isFlushPending = false;
    $860eea622cdf5973$var$isFlushing = true;
    $860eea622cdf5973$var$flushPreFlushCbs(seen);
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child so its render effect will have smaller
    //    priority number)
    // 2. If a component is unmounted during a parent component's update,
    //    its update can be skipped.
    $860eea622cdf5973$var$queue.sort((a, b)=>$860eea622cdf5973$var$getId(a) - $860eea622cdf5973$var$getId(b));
    // conditional usage of checkRecursiveUpdate must be determined out of
    // try ... catch block since Rollup by default de-optimizes treeshaking
    // inside try-catch. This can leave all warning code unshaked. Although
    // they would get eventually shaken by a minifier like terser, some minifiers
    // would fail to do that (e.g. https://github.com/evanw/esbuild/issues/1610)
    const check = (0, $ltDz5.NOOP);
    try {
        for($860eea622cdf5973$var$flushIndex = 0; $860eea622cdf5973$var$flushIndex < $860eea622cdf5973$var$queue.length; $860eea622cdf5973$var$flushIndex++){
            const job = $860eea622cdf5973$var$queue[$860eea622cdf5973$var$flushIndex];
            if (job && job.active !== false) // console.log(`running:`, job.id)
            $860eea622cdf5973$export$b22fcaf88446e9bf(job, null, 14 /* SCHEDULER */ );
        }
    } finally{
        $860eea622cdf5973$var$flushIndex = 0;
        $860eea622cdf5973$var$queue.length = 0;
        $860eea622cdf5973$var$flushPostFlushCbs(seen);
        $860eea622cdf5973$var$isFlushing = false;
        $860eea622cdf5973$var$currentFlushPromise = null;
        // some postFlushCb queued jobs!
        // keep flushing until it drains.
        if ($860eea622cdf5973$var$queue.length || $860eea622cdf5973$var$pendingPreFlushCbs.length || $860eea622cdf5973$var$pendingPostFlushCbs.length) $860eea622cdf5973$var$flushJobs(seen);
    }
}
function $860eea622cdf5973$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $860eea622cdf5973$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $860eea622cdf5973$var$getComponentName(instance.type);
            $860eea622cdf5973$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. ` + `This means you have a reactive effect that is mutating its own ` + `dependencies and thus recursively triggering itself. Possible sources ` + `include component template, render function, updated hook or ` + `watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
/* eslint-disable no-restricted-globals */ let $860eea622cdf5973$var$isHmrUpdating = false;
const $860eea622cdf5973$var$hmrDirtyComponents = new Set();
const $860eea622cdf5973$var$map = new Map();
function $860eea622cdf5973$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $860eea622cdf5973$var$map.get(id);
    if (!record) {
        $860eea622cdf5973$var$createRecord(id, instance.type);
        record = $860eea622cdf5973$var$map.get(id);
    }
    record.instances.add(instance);
}
function $860eea622cdf5973$var$unregisterHMR(instance) {
    $860eea622cdf5973$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $860eea622cdf5973$var$createRecord(id, initialDef) {
    if ($860eea622cdf5973$var$map.has(id)) return false;
    $860eea622cdf5973$var$map.set(id, {
        initialDef: $860eea622cdf5973$var$normalizeClassComponent(initialDef),
        instances: new Set()
    });
    return true;
}
function $860eea622cdf5973$var$normalizeClassComponent(component) {
    return $860eea622cdf5973$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $860eea622cdf5973$var$rerender(id, newRender) {
    const record = $860eea622cdf5973$var$map.get(id);
    if (!record) return;
    // update initial record (for not-yet-rendered component)
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $860eea622cdf5973$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        // this flag forces child components with slot content to update
        $860eea622cdf5973$var$isHmrUpdating = true;
        instance.update();
        $860eea622cdf5973$var$isHmrUpdating = false;
    });
}
function $860eea622cdf5973$var$reload(id, newComp) {
    const record = $860eea622cdf5973$var$map.get(id);
    if (!record) return;
    newComp = $860eea622cdf5973$var$normalizeClassComponent(newComp);
    // update initial def (for not-yet-rendered components)
    $860eea622cdf5973$var$updateComponentDef(record.initialDef, newComp);
    // create a snapshot which avoids the set being mutated during updates
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $860eea622cdf5973$var$normalizeClassComponent(instance.type);
        if (!$860eea622cdf5973$var$hmrDirtyComponents.has(oldComp)) {
            // 1. Update existing comp definition to match new one
            if (oldComp !== record.initialDef) $860eea622cdf5973$var$updateComponentDef(oldComp, newComp);
            // 2. mark definition dirty. This forces the renderer to replace the
            // component on patch.
            $860eea622cdf5973$var$hmrDirtyComponents.add(oldComp);
        }
        // 3. invalidate options resolution cache
        instance.appContext.optionsCache.delete(instance.type);
        // 4. actually update
        if (instance.ceReload) {
            // custom element
            $860eea622cdf5973$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $860eea622cdf5973$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            // 4. Force the parent instance to re-render. This will cause all updated
            // components to be unmounted and re-mounted. Queue the update so that we
            // don't end up forcing the same parent to re-render multiple times.
            $860eea622cdf5973$var$queueJob(instance.parent.update);
            // instance is the inner component of an async custom element
            // invoke to reset styles
            if (instance.parent.type.__asyncLoader && instance.parent.ceReload) instance.parent.ceReload(newComp.styles);
        } else if (instance.appContext.reload) // root instance mounted via createApp() has a reload method
        instance.appContext.reload();
        else if (typeof window !== "undefined") // root instance inside tree created via raw render(). Force reload.
        window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    // 5. make sure to cleanup dirty hmr components after update
    $860eea622cdf5973$export$59536a0199721cab(()=>{
        for (const instance of instances)$860eea622cdf5973$var$hmrDirtyComponents.delete($860eea622cdf5973$var$normalizeClassComponent(instance.type));
    });
}
function $860eea622cdf5973$var$updateComponentDef(oldComp, newComp) {
    (0, $ltDz5.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $860eea622cdf5973$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. ` + `Full reload required.`);
        }
    };
}
let $860eea622cdf5973$export$6922d3b3a607469e;
let $860eea622cdf5973$var$buffer = [];
let $860eea622cdf5973$var$devtoolsNotInstalled = false;
function $860eea622cdf5973$var$emit(event, ...args) {
    if ($860eea622cdf5973$export$6922d3b3a607469e) $860eea622cdf5973$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$860eea622cdf5973$var$devtoolsNotInstalled) $860eea622cdf5973$var$buffer.push({
        event: event,
        args: args
    });
}
function $860eea622cdf5973$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $860eea622cdf5973$export$6922d3b3a607469e = hook;
    if ($860eea622cdf5973$export$6922d3b3a607469e) {
        $860eea622cdf5973$export$6922d3b3a607469e.enabled = true;
        $860eea622cdf5973$var$buffer.forEach(({ event: event, args: args })=>$860eea622cdf5973$export$6922d3b3a607469e.emit(event, ...args));
        $860eea622cdf5973$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $860eea622cdf5973$export$b0c258b32c26c785(newHook, target);
        });
        // clear buffer after 3s - the user probably doesn't have devtools installed
        // at all, and keeping the buffer will cause memory leaks (#4738)
        setTimeout(()=>{
            if (!$860eea622cdf5973$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $860eea622cdf5973$var$devtoolsNotInstalled = true;
                $860eea622cdf5973$var$buffer = [];
            }
        }, 3000);
    } else {
        // non-browser env, assume not installed
        $860eea622cdf5973$var$devtoolsNotInstalled = true;
        $860eea622cdf5973$var$buffer = [];
    }
}
function $860eea622cdf5973$var$devtoolsInitApp(app, version) {
    $860eea622cdf5973$var$emit("app:init" /* APP_INIT */ , app, version, {
        Fragment: $860eea622cdf5973$export$ffb0004e005737fa,
        Text: $860eea622cdf5973$export$5f1af8db9871e1d6,
        Comment: $860eea622cdf5973$export$4d299b491347818a,
        Static: $860eea622cdf5973$export$c1b9a1d3af45b7b6
    });
}
function $860eea622cdf5973$var$devtoolsUnmountApp(app) {
    $860eea622cdf5973$var$emit("app:unmount" /* APP_UNMOUNT */ , app);
}
const $860eea622cdf5973$var$devtoolsComponentAdded = /*#__PURE__*/ $860eea622cdf5973$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $860eea622cdf5973$var$devtoolsComponentUpdated = /*#__PURE__*/ $860eea622cdf5973$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $860eea622cdf5973$var$devtoolsComponentRemoved = /*#__PURE__*/ $860eea622cdf5973$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
function $860eea622cdf5973$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $860eea622cdf5973$var$emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
    };
}
const $860eea622cdf5973$var$devtoolsPerfStart = /*#__PURE__*/ $860eea622cdf5973$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $860eea622cdf5973$var$devtoolsPerfEnd = /*#__PURE__*/ $860eea622cdf5973$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $860eea622cdf5973$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $860eea622cdf5973$var$emit(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $860eea622cdf5973$var$devtoolsComponentEmit(component, event, params) {
    $860eea622cdf5973$var$emit("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $860eea622cdf5973$var$emit$1(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $ltDz5.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    // for v-model update:xxx events, apply modifiers on args
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $ltDz5.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>a.trim());
        if (number) args = rawArgs.map((0, $ltDz5.toNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $ltDz5.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $ltDz5.toHandlerKey)((0, $ltDz5.camelize)(event))];
    // for v-model update:xxx events, also trigger kebab-case equivalent
    // for props passed via kebab-case
    if (!handler && isModelListener) handler = props[handlerName = (0, $ltDz5.toHandlerKey)((0, $ltDz5.hyphenate)(event))];
    if (handler) $860eea622cdf5973$export$dae85862a8d94378(handler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $860eea622cdf5973$export$dae85862a8d94378(onceHandler, instance, 6 /* COMPONENT_EVENT_HANDLER */ , args);
    }
}
function $860eea622cdf5973$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== undefined) return cached;
    const raw = comp.emits;
    let normalized = {};
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $ltDz5.isFunction)(comp)) {
        const extendEmits = (raw)=>{
            const normalizedFromExtend = $860eea622cdf5973$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $ltDz5.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, null);
        return null;
    }
    if ((0, $ltDz5.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $ltDz5.extend)(normalized, raw);
    cache.set(comp, normalized);
    return normalized;
}
// Check if an incoming prop key is a declared emit event listener.
// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
// both considered matched listeners.
function $860eea622cdf5973$var$isEmitListener(options, key) {
    if (!options || !(0, $ltDz5.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $ltDz5.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $ltDz5.hasOwn)(options, (0, $ltDz5.hyphenate)(key)) || (0, $ltDz5.hasOwn)(options, key);
}
/**
 * mark the current rendering instance for asset resolution (e.g.
 * resolveComponent, resolveDirective) during render
 */ let $860eea622cdf5973$var$currentRenderingInstance = null;
let $860eea622cdf5973$var$currentScopeId = null;
/**
 * Note: rendering calls maybe nested. The function returns the parent rendering
 * instance if present, which should be restored after the render is done:
 *
 * ```js
 * const prev = setCurrentRenderingInstance(i)
 * // ...render
 * setCurrentRenderingInstance(prev)
 * ```
 */ function $860eea622cdf5973$var$setCurrentRenderingInstance(instance) {
    const prev = $860eea622cdf5973$var$currentRenderingInstance;
    $860eea622cdf5973$var$currentRenderingInstance = instance;
    $860eea622cdf5973$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
 * Set scope id when creating hoisted vnodes.
 * @private compiler helper
 */ function $860eea622cdf5973$export$ac020265ca2cc4cd(id) {
    $860eea622cdf5973$var$currentScopeId = id;
}
/**
 * Technically we no longer need this after 3.0.8 but we need to keep the same
 * API for backwards compat w/ code generated by compilers.
 * @private
 */ function $860eea622cdf5973$export$f2dc6805dc11834e() {
    $860eea622cdf5973$var$currentScopeId = null;
}
/**
 * Only for backwards compat
 * @private
 */ const $860eea622cdf5973$export$15ba313e13f3dd04 = (_id)=>$860eea622cdf5973$export$694b237e827a3d23;
/**
 * Wrap a slot function to memoize current rendering instance
 * @private compiler helper
 */ function $860eea622cdf5973$export$694b237e827a3d23(fn, ctx = $860eea622cdf5973$var$currentRenderingInstance, isNonScopedSlot // false only
) {
    if (!ctx) return fn;
    // already normalized
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        // If a user calls a compiled slot inside a template expression (#1745), it
        // can mess up block tracking, so by default we disable block tracking and
        // force bail out when invoking a compiled slot (indicated by the ._d flag).
        // This isn't necessary if rendering a compiled `<slot>`, so we flip the
        // ._d flag off when invoking the wrapped fn inside `renderSlot`.
        if (renderFnWithContext._d) $860eea622cdf5973$export$c20bee82f26f1e27(-1);
        const prevInstance = $860eea622cdf5973$var$setCurrentRenderingInstance(ctx);
        const res = fn(...args);
        $860eea622cdf5973$var$setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) $860eea622cdf5973$export$c20bee82f26f1e27(1);
        if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    // mark normalized to avoid duplicated wrapping
    renderFnWithContext._n = true;
    // mark this as compiled by default
    // this is used in vnode.ts -> normalizeChildren() to set the slot
    // rendering flag.
    renderFnWithContext._c = true;
    // disable block tracking by default
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
/**
 * dev only flag to track whether $attrs was used during render.
 * If $attrs was used during render then the warning for failed attrs
 * fallthrough can be suppressed.
 */ let $860eea622cdf5973$var$accessedAttrs = false;
function $860eea622cdf5973$var$markAttrsAccessed() {
    $860eea622cdf5973$var$accessedAttrs = true;
}
function $860eea622cdf5973$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $860eea622cdf5973$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) {
            // withProxy is a proxy with a different `has` trap only for
            // runtime-compiled render functions using `with` block.
            const proxyToUse = withProxy || proxy;
            result = $860eea622cdf5973$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            // functional
            const render = Component;
            result = $860eea622cdf5973$var$normalizeVNode(render.length > 1 ? render(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render(props, null));
            fallthroughAttrs = Component.props ? attrs : $860eea622cdf5973$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $860eea622cdf5973$var$blockStack.length = 0;
        $860eea622cdf5973$export$d3da1ecaf1206c58(err, instance, 1 /* RENDER_FUNCTION */ );
        result = $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$4d299b491347818a);
    }
    // attr merging
    // in dev mode, comments are preserved, and it's possible for a template
    // to have comments along side the root element which makes it a fragment
    let root = result;
    let setRoot = undefined;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7 /* COMPONENT */ ) {
                if (propsOptions && keys.some((0, $ltDz5.isModelListener))) // If a v-model listener (onUpdate:xxx) has a corresponding declared
                // prop, it indicates this component expects to handle v-model and
                // it should not fallthrough.
                // related: #1543, #1643, #1989
                fallthroughAttrs = $860eea622cdf5973$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $860eea622cdf5973$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    // inherit directives
    if (vnode.dirs) {
        // clone before mutating since the root may be a hoisted vnode
        root = $860eea622cdf5973$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    // inherit transition data
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $860eea622cdf5973$var$setCurrentRenderingInstance(prev);
    return result;
}
/**
 * dev only
 * In dev mode, template root level comments are rendered, which turns the
 * template into a fragment root, but we need to locate the single element
 * root for attrs and scope id processing.
 */ const $860eea622cdf5973$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $860eea622cdf5973$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        undefined
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $860eea622cdf5973$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $860eea622cdf5973$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($860eea622cdf5973$export$3868d13f8734ae81(child)) // ignore user comment
        {
            if (child.type !== $860eea622cdf5973$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) // has more than 1 non-comment child, return now
                return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $860eea622cdf5973$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $ltDz5.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $860eea622cdf5973$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $ltDz5.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $860eea622cdf5973$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 /* ELEMENT */  || vnode.type === $860eea622cdf5973$export$4d299b491347818a // potential v-if branch switch
    ;
};
function $860eea622cdf5973$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    // force child update for runtime directive or transition on component vnode.
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024 /* DYNAMIC_SLOTS */ ) // slot content that references values that might have changed,
        // e.g. in a v-for
        return true;
        if (patchFlag & 16 /* FULL_PROPS */ ) {
            if (!prevProps) return !!nextProps;
            // presence of this flag indicates props are always non-null
            return $860eea622cdf5973$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8 /* PROPS */ ) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$860eea622cdf5973$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        // this path is only taken by manually written render functions
        // so presence of any children leads to a forced update
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $860eea622cdf5973$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $860eea622cdf5973$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$860eea622cdf5973$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $860eea622cdf5973$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el // HostNode
) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $860eea622cdf5973$var$isSuspense = (type)=>type.__isSuspense;
// Suspense exposes a component-like API, and is treated like a component
// in the compiler, but internally it's a special built-in type that hooks
// directly into the renderer.
const $860eea622cdf5973$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, // platform-specific impl passed from renderer
    rendererInternals) {
        if (n1 == null) $860eea622cdf5973$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $860eea622cdf5973$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $860eea622cdf5973$var$hydrateSuspense,
    create: $860eea622cdf5973$var$createSuspenseBoundary,
    normalize: $860eea622cdf5973$var$normalizeSuspenseChildren
};
// Force-casted public typing for h and TSX props inference
const $860eea622cdf5973$export$74bf444e3cd11ea5 = $860eea622cdf5973$var$SuspenseImpl;
function $860eea622cdf5973$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $ltDz5.isFunction)(eventListener)) eventListener();
}
function $860eea622cdf5973$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $860eea622cdf5973$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    // start mounting the content subtree in an off-dom container
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    // now check if we have encountered any async deps
    if (suspense.deps > 0) {
        // has async
        // invoke @fallback event
        $860eea622cdf5973$var$triggerEvent(vnode, "onPending");
        $860eea622cdf5973$var$triggerEvent(vnode, "onFallback");
        // mount the fallback tree
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds);
        $860eea622cdf5973$var$setActiveBranch(suspense, vnode.ssFallback);
    } else // Suspense has no async deps. Just resolve.
    suspense.resolve();
}
function $860eea622cdf5973$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($860eea622cdf5973$var$isSameVNodeType(newBranch, pendingBranch)) {
            // same root type but content may have changed.
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $860eea622cdf5973$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            // toggled before pending tree is resolved
            suspense.pendingId++;
            if (isHydrating) {
                // if toggled before hydration is finished, the current DOM tree is
                // no longer valid. set it as the active branch so it will be unmounted
                // when resolved
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            // increment pending ID. this is used to invalidate async callbacks
            // reset suspense state
            suspense.deps = 0;
            // discard effects from pending branch
            suspense.effects.length = 0;
            // discard previous container
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                // already in fallback state
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                    $860eea622cdf5973$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $860eea622cdf5973$var$isSameVNodeType(newBranch, activeBranch)) {
                // toggled "back" to current active branch
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                // force resolve
                suspense.resolve(true);
            } else {
                // switched to a 3rd branch
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $860eea622cdf5973$var$isSameVNodeType(newBranch, activeBranch)) {
        // root did not change, just normal patch
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $860eea622cdf5973$var$setActiveBranch(suspense, newBranch);
    } else {
        // root node toggled
        // invoke @pending event
        $860eea622cdf5973$var$triggerEvent(n2, "onPending");
        // mount pending branch in off-dom container
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) // incoming branch has no async deps, resolve now.
        suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $860eea622cdf5973$var$hasWarned = false;
function $860eea622cdf5973$var$createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    const timeout = (0, $ltDz5.toNumber)(vnode.props && vnode.props.timeout);
    const suspense = {
        vnode: vnode,
        parent: parent,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false) {
            const { vnode: vnode, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent, container: container } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container, anchor, 0 /* ENTER */ );
                };
                // this is initial anchor on mount
                let { anchor: anchor } = suspense;
                // unmount current active tree
                if (activeBranch) {
                    // if the fallback tree was mounted, it may have been moved
                    // as part of a parent suspense. get the latest anchor for insertion
                    anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent, suspense, true);
                }
                if (!delayEnter) // move content from off-dom container to actual container
                move(pendingBranch, container, anchor, 0 /* ENTER */ );
            }
            $860eea622cdf5973$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            // flush buffered effects
            // check if there is a pending parent suspense
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    // found a pending parent suspense, merge buffered post jobs
                    // into that parent
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            // no pending parent suspense, flush all jobs
            if (!hasUnresolvedAncestor) $860eea622cdf5973$export$59536a0199721cab(effects);
            suspense.effects = [];
            // invoke @resolve event
            $860eea622cdf5973$var$triggerEvent(vnode, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode, activeBranch: activeBranch, parentComponent: parentComponent, container: container, isSVG: isSVG } = suspense;
            // invoke @fallback event
            $860eea622cdf5973$var$triggerEvent(vnode, "onFallback");
            const anchor = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                // mount the fallback tree
                patch(null, fallbackVNode, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $860eea622cdf5973$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            // unmount current active branch
            unmount(activeBranch, parentComponent, null, true // shouldRemove
            );
            if (!delayEnter) mountFallback();
        },
        move (container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type);
            suspense.container = container;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $860eea622cdf5973$export$d3da1ecaf1206c58(err, instance, 0 /* SETUP_FUNCTION */ );
            }).then((asyncSetupResult)=>{
                // retry when the setup() promise resolves.
                // component may have been unmounted before resolve.
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                // retry from this component
                instance.asyncResolved = true;
                const { vnode: vnode } = instance;
                $860eea622cdf5973$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) // vnode may have been replaced if an update happened before the
                // async dep is resolved.
                vnode.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $860eea622cdf5973$var$updateHOCHostEl(instance, vnode.el);
                // only decrease deps count if suspense is not already resolved
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $860eea622cdf5973$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    /* eslint-disable no-restricted-globals */ const suspense = vnode.suspense = $860eea622cdf5973$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    // there are two possible scenarios for server-rendered suspense:
    // - success: ssr content should be fully resolved
    // - failure: ssr content should be the fallback branch.
    // however, on the client we don't really know if it has failed or not
    // attempt to hydrate the DOM assuming it has succeeded, but we still
    // need to construct a suspense boundary first
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve();
    return result;
/* eslint-enable no-restricted-globals */ }
function $860eea622cdf5973$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32 /* SLOTS_CHILDREN */ ;
    vnode.ssContent = $860eea622cdf5973$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $860eea622cdf5973$var$normalizeSuspenseSlot(children.fallback) : $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$4d299b491347818a);
}
function $860eea622cdf5973$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $ltDz5.isFunction)(s)) {
        const trackBlock = $860eea622cdf5973$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            // disableTracking: false
            // allow block tracking for compiled slots
            // (see ./componentRenderContext.ts)
            s._d = false;
            $860eea622cdf5973$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $860eea622cdf5973$var$currentBlock;
            $860eea622cdf5973$var$closeBlock();
        }
    }
    if ((0, $ltDz5.isArray)(s)) {
        const singleChild = $860eea622cdf5973$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $860eea622cdf5973$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $860eea622cdf5973$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $ltDz5.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $860eea622cdf5973$export$59536a0199721cab(fn);
}
function $860eea622cdf5973$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    // in case suspense is the root node of a component,
    // recursively update the HOC el
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $860eea622cdf5973$var$updateHOCHostEl(parentComponent, el);
    }
}
function $860eea622cdf5973$export$abe1e183e22e10ad(key, value) {
    if (!$860eea622cdf5973$var$currentInstance) ;
    else {
        let provides = $860eea622cdf5973$var$currentInstance.provides;
        // by default an instance inherits its parent's provides object
        // but when it needs to provide values of its own, it creates its
        // own provides object using parent provides object as prototype.
        // this way in `inject` we can simply look up injections from direct
        // parent and let the prototype chain do the work.
        const parentProvides = $860eea622cdf5973$var$currentInstance.parent && $860eea622cdf5973$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $860eea622cdf5973$var$currentInstance.provides = Object.create(parentProvides);
        // TS doesn't allow symbol as index type
        provides[key] = value;
    }
}
function $860eea622cdf5973$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    const instance = $860eea622cdf5973$var$currentInstance || $860eea622cdf5973$var$currentRenderingInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $ltDz5.isFunction)(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    }
}
// Simple effect.
function $860eea622cdf5973$export$ede35fc0e5500309(effect, options) {
    return $860eea622cdf5973$var$doWatch(effect, null, options);
}
function $860eea622cdf5973$export$b7f27ea67102d543(effect, options) {
    return $860eea622cdf5973$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $860eea622cdf5973$export$2035654f31b0e555(effect, options) {
    return $860eea622cdf5973$var$doWatch(effect, null, {
        flush: "sync"
    });
}
// initial value for watchers to trigger on undefined initial values
const $860eea622cdf5973$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $860eea622cdf5973$export$3db5d71bdb2d5499(source, cb, options) {
    return $860eea622cdf5973$var$doWatch(source, cb, options);
}
function $860eea622cdf5973$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $ltDz5.EMPTY_OBJ)) {
    const warnInvalidSource = (s)=>{
        $860eea622cdf5973$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, ` + `a reactive object, or an array of these types.`);
    };
    const instance = $860eea622cdf5973$var$currentInstance;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $uDJ7A.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $uDJ7A.isShallow)(source);
    } else if ((0, $uDJ7A.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $ltDz5.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $uDJ7A.isReactive)(s) || (0, $uDJ7A.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $uDJ7A.isRef)(s)) return s.value;
                else if ((0, $uDJ7A.isReactive)(s)) return $860eea622cdf5973$var$traverse(s);
                else if ((0, $ltDz5.isFunction)(s)) return $860eea622cdf5973$export$b22fcaf88446e9bf(s, instance, 2 /* WATCH_GETTER */ );
            });
    } else if ((0, $ltDz5.isFunction)(source)) {
        if (cb) // getter with cb
        getter = ()=>$860eea622cdf5973$export$b22fcaf88446e9bf(source, instance, 2 /* WATCH_GETTER */ );
        else // no cb -> simple effect
        getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $860eea622cdf5973$export$dae85862a8d94378(source, instance, 3 /* WATCH_CALLBACK */ , [
                onCleanup
            ]);
        };
    } else getter = (0, $ltDz5.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$860eea622cdf5973$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $860eea622cdf5973$export$b22fcaf88446e9bf(fn, instance, 4 /* WATCH_CLEANUP */ );
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($860eea622cdf5973$var$isInSSRComponentSetup) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = (0, $ltDz5.NOOP);
        if (!cb) getter();
        else if (immediate) $860eea622cdf5973$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
            getter(),
            isMultiSource ? [] : undefined,
            onCleanup
        ]);
        return 0, $ltDz5.NOOP;
    }
    let oldValue = isMultiSource ? [] : $860eea622cdf5973$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            // watch(source, cb)
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $ltDz5.hasChanged)(v1, oldValue[i])) : (0, $ltDz5.hasChanged)(newValue, oldValue)) || false) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                $860eea622cdf5973$export$dae85862a8d94378(cb, instance, 3 /* WATCH_CALLBACK */ , [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $860eea622cdf5973$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        effect.run();
    };
    // important: mark the job as a watcher callback so that scheduler knows
    // it is allowed to self-trigger (#1727)
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job; // the scheduler function gets called directly
    else if (flush === "post") scheduler = ()=>$860eea622cdf5973$var$queuePostRenderEffect(job, instance && instance.suspense);
    else // default: 'pre'
    scheduler = ()=>$860eea622cdf5973$var$queuePreFlushCb(job);
    const effect = new (0, $uDJ7A.ReactiveEffect)(getter, scheduler);
    // initial run
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $860eea622cdf5973$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    return ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $ltDz5.remove)(instance.scope.effects, effect);
    };
}
// this.$watch
function $860eea622cdf5973$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $ltDz5.isString)(source) ? source.includes(".") ? $860eea622cdf5973$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $ltDz5.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const cur = $860eea622cdf5973$var$currentInstance;
    $860eea622cdf5973$var$setCurrentInstance(this);
    const res = $860eea622cdf5973$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $860eea622cdf5973$var$setCurrentInstance(cur);
    else $860eea622cdf5973$var$unsetCurrentInstance();
    return res;
}
function $860eea622cdf5973$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $860eea622cdf5973$var$traverse(value, seen) {
    if (!(0, $ltDz5.isObject)(value) || value["__v_skip" /* SKIP */ ]) return value;
    seen = seen || new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $uDJ7A.isRef)(value)) $860eea622cdf5973$var$traverse(value.value, seen);
    else if ((0, $ltDz5.isArray)(value)) for(let i = 0; i < value.length; i++)$860eea622cdf5973$var$traverse(value[i], seen);
    else if ((0, $ltDz5.isSet)(value) || (0, $ltDz5.isMap)(value)) value.forEach((v1)=>{
        $860eea622cdf5973$var$traverse(v1, seen);
    });
    else if ((0, $ltDz5.isPlainObject)(value)) for(const key in value)$860eea622cdf5973$var$traverse(value[key], seen);
    return value;
}
function $860eea622cdf5973$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: new Map()
    };
    $860eea622cdf5973$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $860eea622cdf5973$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $860eea622cdf5973$var$TransitionHookValidator = [
    Function,
    Array
];
const $860eea622cdf5973$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: $860eea622cdf5973$var$TransitionHookValidator,
        onEnter: $860eea622cdf5973$var$TransitionHookValidator,
        onAfterEnter: $860eea622cdf5973$var$TransitionHookValidator,
        onEnterCancelled: $860eea622cdf5973$var$TransitionHookValidator,
        // leave
        onBeforeLeave: $860eea622cdf5973$var$TransitionHookValidator,
        onLeave: $860eea622cdf5973$var$TransitionHookValidator,
        onAfterLeave: $860eea622cdf5973$var$TransitionHookValidator,
        onLeaveCancelled: $860eea622cdf5973$var$TransitionHookValidator,
        // appear
        onBeforeAppear: $860eea622cdf5973$var$TransitionHookValidator,
        onAppear: $860eea622cdf5973$var$TransitionHookValidator,
        onAfterAppear: $860eea622cdf5973$var$TransitionHookValidator,
        onAppearCancelled: $860eea622cdf5973$var$TransitionHookValidator
    },
    setup (props, { slots: slots }) {
        const instance = $860eea622cdf5973$export$f13e630aa3915748();
        const state = $860eea622cdf5973$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $860eea622cdf5973$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                // locate first non-comment child
                for (const c of children)if (c.type !== $860eea622cdf5973$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            // there's no need to track reactivity for these props so use the raw
            // props for a bit better perf
            const rawProps = (0, $uDJ7A.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $860eea622cdf5973$var$emptyPlaceholder(child);
            // in the case of <transition><keep-alive/></transition>, we need to
            // compare the type of the kept-alive children.
            const innerChild = $860eea622cdf5973$var$getKeepAliveChild(child);
            if (!innerChild) return $860eea622cdf5973$var$emptyPlaceholder(child);
            const enterHooks = $860eea622cdf5973$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $860eea622cdf5973$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $860eea622cdf5973$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === undefined) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            // handle mode
            if (oldInnerChild && oldInnerChild.type !== $860eea622cdf5973$export$4d299b491347818a && (!$860eea622cdf5973$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $860eea622cdf5973$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                // update old tree's hooks in case of dynamic transition
                $860eea622cdf5973$export$7770a22486565649(oldInnerChild, leavingHooks);
                // switching between different views
                if (mode === "out-in") {
                    state.isLeaving = true;
                    // return placeholder node and queue update when leave finishes
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        instance.update();
                    };
                    return $860eea622cdf5973$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $860eea622cdf5973$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $860eea622cdf5973$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    // early removal callback
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = undefined;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $860eea622cdf5973$export$abd95b5f5e8a8837 = $860eea622cdf5973$var$BaseTransitionImpl;
function $860eea622cdf5973$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
// The transition hooks are attached to the vnode as vnode.transition
// and will be called at appropriate timing in the renderer.
function $860eea622cdf5973$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $860eea622cdf5973$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $860eea622cdf5973$export$dae85862a8d94378(hook, instance, 9 /* TRANSITION_HOOK */ , args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $ltDz5.isArray)(hook)) {
            if (hook.every((hook)=>hook.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            // for same element (v-show)
            if (el._leaveCb) el._leaveCb(true);
            // for toggled element with same key (v-if)
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $860eea622cdf5973$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) // force early removal (not cancelled)
            leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = undefined;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = undefined;
                if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
            };
            leavingVNodesCache[key] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode) {
            return $860eea622cdf5973$export$76ac1779589cd824(vnode, props, state, instance);
        }
    };
    return hooks;
}
// the placeholder really only handles one special case: KeepAlive
// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
// placeholder with empty content to avoid the KeepAlive instance from being
// unmounted.
function $860eea622cdf5973$var$emptyPlaceholder(vnode) {
    if ($860eea622cdf5973$var$isKeepAlive(vnode)) {
        vnode = $860eea622cdf5973$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $860eea622cdf5973$var$getKeepAliveChild(vnode) {
    return $860eea622cdf5973$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : undefined : vnode;
}
function $860eea622cdf5973$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 /* COMPONENT */  && vnode.component) $860eea622cdf5973$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128 /* SUSPENSE */ ) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $860eea622cdf5973$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        // #5360 inherit parent key in case of <template v-for>
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        // handle fragment children case, e.g. v-for
        if (child.type === $860eea622cdf5973$export$ffb0004e005737fa) {
            if (child.patchFlag & 128 /* KEYED_FRAGMENT */ ) keyedFragmentCount++;
            ret = ret.concat($860eea622cdf5973$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $860eea622cdf5973$export$4d299b491347818a) ret.push(key != null ? $860eea622cdf5973$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    // #1126 if a transition children list contains multiple sub fragments, these
    // fragments will be merged into a flat children array. Since each v-for
    // fragment may contain different static bindings inside, we need to de-op
    // these children to force full diffs to ensure correct behavior.
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2 /* BAIL */ ;
    return ret;
}
// implementation, close to no-op
function $860eea622cdf5973$export$afa64b67e5a01c3b(options) {
    return (0, $ltDz5.isFunction)(options) ? {
        setup: options,
        name: options.name
    } : options;
}
const $860eea622cdf5973$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $860eea622cdf5973$export$d75d499b4c16cf21(source) {
    if ((0, $ltDz5.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $860eea622cdf5973$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $860eea622cdf5973$var$currentInstance;
            // already resolved
            if (resolvedComp) return ()=>$860eea622cdf5973$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $860eea622cdf5973$export$d3da1ecaf1206c58(err, instance, 13 /* ASYNC_COMPONENT_LOADER */ , !errorComponent /* do not throw in dev if user provided error component */ );
            };
            // suspense-controlled or SSR.
            if (suspensible && instance.suspense || $860eea622cdf5973$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$860eea622cdf5973$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $860eea622cdf5973$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $uDJ7A.ref)(false);
            const error = (0, $uDJ7A.ref)();
            const delayed = (0, $uDJ7A.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $860eea622cdf5973$var$isKeepAlive(instance.parent.vnode)) // parent is keep-alive, force update so the loaded component's
                // name is taken into account
                $860eea622cdf5973$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $860eea622cdf5973$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $860eea622cdf5973$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $860eea622cdf5973$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $860eea622cdf5973$var$createInnerComp(comp, { vnode: { ref: ref, props: props, children: children, shapeFlag: shapeFlag }, parent: parent }) {
    const vnode = $860eea622cdf5973$export$bf5c4cf060303d58(comp, props, children);
    // ensure inner component inherits the async wrapper's ref owner
    vnode.ref = ref;
    return vnode;
}
const $860eea622cdf5973$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $860eea622cdf5973$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $860eea622cdf5973$export$f13e630aa3915748();
        // KeepAlive communicates with the instantiated renderer via the
        // ctx where the renderer passes in its internals,
        // and the KeepAlive instance exposes activate/deactivate implementations.
        // The whole point of this is to avoid importing KeepAlive directly in the
        // renderer to facilitate tree-shaking.
        const sharedContext = instance.ctx;
        // if the internal renderer is not registered, it indicates that this is server-side rendering,
        // for KeepAlive, we just need to render its children
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = new Map();
        const keys = new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance = vnode.component;
            move(vnode, container, anchor, 0 /* ENTER */ , parentSuspense);
            // in case props have changed
            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $860eea622cdf5973$var$queuePostRenderEffect(()=>{
                instance.isDeactivated = false;
                if (instance.a) (0, $ltDz5.invokeArrayFns)(instance.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $860eea622cdf5973$var$devtoolsComponentAdded(instance);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance = vnode.component;
            move(vnode, storageContainer, null, 1 /* LEAVE */ , parentSuspense);
            $860eea622cdf5973$var$queuePostRenderEffect(()=>{
                if (instance.da) (0, $ltDz5.invokeArrayFns)(instance.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
                instance.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $860eea622cdf5973$var$devtoolsComponentAdded(instance);
        };
        function unmount(vnode) {
            // reset the shapeFlag so it can be properly unmounted
            $860eea622cdf5973$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $860eea622cdf5973$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || cached.type !== current.type) unmount(cached);
            else if (current) // current active instance should no longer be kept-alive.
            // we can't unmount it now but it might be later, so reset its flag now.
            $860eea622cdf5973$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        // prune cache on include/exclude prop change
        $860eea622cdf5973$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$860eea622cdf5973$var$matches(include, name));
            exclude && pruneCache((name)=>!$860eea622cdf5973$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        // cache sub tree after render
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            // fix #1621, the pendingCacheKey could be 0
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $860eea622cdf5973$var$getInnerChild(instance.subTree));
        };
        $860eea622cdf5973$export$6d1641039221b5cb(cacheSubtree);
        $860eea622cdf5973$export$5876c47052fb88b1(cacheSubtree);
        $860eea622cdf5973$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $860eea622cdf5973$var$getInnerChild(subTree);
                if (cached.type === vnode.type) {
                    // current instance will be unmounted as part of keep-alive's unmount
                    $860eea622cdf5973$var$resetShapeFlag(vnode);
                    // but invoke its deactivated hook here
                    const da = vnode.component.da;
                    da && $860eea622cdf5973$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$860eea622cdf5973$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ) && !(rawVNode.shapeFlag & 128 /* SUSPENSE */ )) {
                current = null;
                return rawVNode;
            }
            let vnode = $860eea622cdf5973$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            // for async components, name check should be based in its loaded
            // inner component if available
            const name = $860eea622cdf5973$var$getComponentName($860eea622cdf5973$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$860eea622cdf5973$var$matches(include, name)) || exclude && name && $860eea622cdf5973$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            // clone vnode if it's reused because we are going to mutate it
            if (vnode.el) {
                vnode = $860eea622cdf5973$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128 /* SUSPENSE */ ) rawVNode.ssContent = vnode;
            }
            // #1513 it's possible for the returned vnode to be cloned due to attr
            // fallthrough or scopeId, so the vnode here may not be the final vnode
            // that is mounted. Instead of caching it directly, we store the pending
            // key and cache `instance.subTree` (the normalized vnode) in
            // beforeMount/beforeUpdate hooks.
            pendingCacheKey = key;
            if (cachedVNode) {
                // copy over mounted state
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) // recursively update transition hooks on subTree
                $860eea622cdf5973$export$7770a22486565649(vnode, vnode.transition);
                // avoid vnode being mounted as fresh
                vnode.shapeFlag |= 512 /* COMPONENT_KEPT_ALIVE */ ;
                // make this key the freshest
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                // prune oldest entry
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            // avoid vnode being unmounted
            vnode.shapeFlag |= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
            current = vnode;
            return $860eea622cdf5973$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $860eea622cdf5973$export$70eb8a58709972df = $860eea622cdf5973$var$KeepAliveImpl;
function $860eea622cdf5973$var$matches(pattern, name) {
    if ((0, $ltDz5.isArray)(pattern)) return pattern.some((p)=>$860eea622cdf5973$var$matches(p, name));
    else if ((0, $ltDz5.isString)(pattern)) return pattern.split(",").includes(name);
    else if (pattern.test) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $860eea622cdf5973$export$ba52d824b95a2154(hook, target) {
    $860eea622cdf5973$var$registerKeepAliveHook(hook, "a" /* ACTIVATED */ , target);
}
function $860eea622cdf5973$export$bf1440eeaf5fa709(hook, target) {
    $860eea622cdf5973$var$registerKeepAliveHook(hook, "da" /* DEACTIVATED */ , target);
}
function $860eea622cdf5973$var$registerKeepAliveHook(hook, type, target = $860eea622cdf5973$var$currentInstance) {
    // cache the deactivate branch check wrapper for injected hooks so the same
    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
    // deactivation check".
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        // only fire the hook if the target instance is NOT in a deactivated branch.
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $860eea622cdf5973$var$injectHook(type, wrappedHook, target);
    // In addition to registering it on the target instance, we walk up the parent
    // chain and register it on all ancestor instances that are keep-alive roots.
    // This avoids the need to walk the entire component tree when invoking these
    // hooks, and more importantly, avoids the need to track child components in
    // arrays.
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($860eea622cdf5973$var$isKeepAlive(current.parent.vnode)) $860eea622cdf5973$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $860eea622cdf5973$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    // injectHook wraps the original for error handling, so make sure to remove
    // the wrapped version.
    const injected = $860eea622cdf5973$var$injectHook(type, hook, keepAliveRoot, true);
    $860eea622cdf5973$export$13348a43ccacfe58(()=>{
        (0, $ltDz5.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $860eea622cdf5973$var$resetShapeFlag(vnode) {
    let shapeFlag = vnode.shapeFlag;
    if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) shapeFlag -= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ;
    if (shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) shapeFlag -= 512 /* COMPONENT_KEPT_ALIVE */ ;
    vnode.shapeFlag = shapeFlag;
}
function $860eea622cdf5973$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 /* SUSPENSE */  ? vnode.ssContent : vnode;
}
function $860eea622cdf5973$var$injectHook(type, hook, target = $860eea622cdf5973$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        // cache the error handling wrapper for injected hooks so the same hook
        // can be properly deduped by the scheduler. "__weh" stands for "with error
        // handling".
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $uDJ7A.pauseTracking)();
            // Set currentInstance during hook invocation.
            // This assumes the hook does not synchronously trigger other hooks, which
            // can only be false when the user does something really funky.
            $860eea622cdf5973$var$setCurrentInstance(target);
            const res = $860eea622cdf5973$export$dae85862a8d94378(hook, target, type, args);
            $860eea622cdf5973$var$unsetCurrentInstance();
            (0, $uDJ7A.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $860eea622cdf5973$var$createHook = (lifecycle)=>(hook, target = $860eea622cdf5973$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$860eea622cdf5973$var$isInSSRComponentSetup || lifecycle === "sp" /* SERVER_PREFETCH */ ) && $860eea622cdf5973$var$injectHook(lifecycle, hook, target);
const $860eea622cdf5973$export$23b7aeb0d671f804 = $860eea622cdf5973$var$createHook("bm" /* BEFORE_MOUNT */ );
const $860eea622cdf5973$export$6d1641039221b5cb = $860eea622cdf5973$var$createHook("m" /* MOUNTED */ );
const $860eea622cdf5973$export$ab91988a13872e4c = $860eea622cdf5973$var$createHook("bu" /* BEFORE_UPDATE */ );
const $860eea622cdf5973$export$5876c47052fb88b1 = $860eea622cdf5973$var$createHook("u" /* UPDATED */ );
const $860eea622cdf5973$export$40c420df62d2614 = $860eea622cdf5973$var$createHook("bum" /* BEFORE_UNMOUNT */ );
const $860eea622cdf5973$export$13348a43ccacfe58 = $860eea622cdf5973$var$createHook("um" /* UNMOUNTED */ );
const $860eea622cdf5973$export$ebf0c601f267bceb = $860eea622cdf5973$var$createHook("sp" /* SERVER_PREFETCH */ );
const $860eea622cdf5973$export$898295a813d662eb = $860eea622cdf5973$var$createHook("rtg" /* RENDER_TRIGGERED */ );
const $860eea622cdf5973$export$2b41f4235363e921 = $860eea622cdf5973$var$createHook("rtc" /* RENDER_TRACKED */ );
function $860eea622cdf5973$export$6a3a15856e50ad19(hook, target = $860eea622cdf5973$var$currentInstance) {
    $860eea622cdf5973$var$injectHook("ec" /* ERROR_CAPTURED */ , hook, target);
}
/**
Runtime helper for applying directives to a vnode. Example usage:

const comp = resolveComponent('comp')
const foo = resolveDirective('foo')
const bar = resolveDirective('bar')

return withDirectives(h(comp), [
  [foo, this.x],
  [bar, this.y]
])
*/ function $860eea622cdf5973$var$validateDirectiveName(name) {
    if ((0, $ltDz5.isBuiltInDirective)(name)) $860eea622cdf5973$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
/**
 * Adds directives to a VNode.
 */ function $860eea622cdf5973$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $860eea622cdf5973$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $860eea622cdf5973$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $ltDz5.EMPTY_OBJ)] = directives[i];
        if ((0, $ltDz5.isFunction)(dir)) dir = {
            mounted: dir,
            updated: dir
        };
        if (dir.deep) $860eea622cdf5973$var$traverse(value);
        bindings.push({
            dir: dir,
            instance: instance,
            value: value,
            oldValue: void 0,
            arg: arg,
            modifiers: modifiers
        });
    }
    return vnode;
}
function $860eea622cdf5973$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $uDJ7A.pauseTracking)();
            $860eea622cdf5973$export$dae85862a8d94378(hook, instance, 8 /* DIRECTIVE_HOOK */ , [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $uDJ7A.resetTracking)();
        }
    }
}
const $860eea622cdf5973$var$COMPONENTS = "components";
const $860eea622cdf5973$var$DIRECTIVES = "directives";
/**
 * @private
 */ function $860eea622cdf5973$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $860eea622cdf5973$var$resolveAsset($860eea622cdf5973$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $860eea622cdf5973$var$NULL_DYNAMIC_COMPONENT = Symbol();
/**
 * @private
 */ function $860eea622cdf5973$export$b44c564a05ca975(component) {
    if ((0, $ltDz5.isString)(component)) return $860eea622cdf5973$var$resolveAsset($860eea622cdf5973$var$COMPONENTS, component, false) || component;
    else // invalid types will fallthrough to createVNode and raise warning
    return component || $860eea622cdf5973$var$NULL_DYNAMIC_COMPONENT;
}
/**
 * @private
 */ function $860eea622cdf5973$export$a1989e995cd481be(name) {
    return $860eea622cdf5973$var$resolveAsset($860eea622cdf5973$var$DIRECTIVES, name);
}
// implementation
function $860eea622cdf5973$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $860eea622cdf5973$var$currentRenderingInstance || $860eea622cdf5973$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        // explicit self name has highest priority
        if (type === $860eea622cdf5973$var$COMPONENTS) {
            const selfName = $860eea622cdf5973$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $ltDz5.camelize)(name) || selfName === (0, $ltDz5.capitalize)((0, $ltDz5.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $860eea622cdf5973$var$resolve(instance[type] || Component[type], name) || // global registration
        $860eea622cdf5973$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) // fallback to implicit self-reference
        return Component;
        return res;
    }
}
function $860eea622cdf5973$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $ltDz5.camelize)(name)] || registry[(0, $ltDz5.capitalize)((0, $ltDz5.camelize)(name))]);
}
/**
 * Actual implementation
 */ function $860eea622cdf5973$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $ltDz5.isArray)(source) || (0, $ltDz5.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, undefined, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, undefined, cached && cached[i]);
    } else if ((0, $ltDz5.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, undefined, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
/**
 * Compiler runtime helper for creating dynamic slots object
 * @private
 */ function $860eea622cdf5973$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        // array of dynamic slot generated by <template v-for="..." #[...]>
        if ((0, $ltDz5.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) // conditional single slot generated by <template v-if="..." #foo>
        slots[slot.name] = slot.fn;
    }
    return slots;
}
/**
 * Compiler runtime helper for rendering `<slot/>`
 * @private
 */ function $860eea622cdf5973$export$4abee4c34694ada1(slots, name, props = {}, // this is not a user-facing function, so the fallback is always generated by
// the compiler and guaranteed to be a function returning an array
fallback, noSlotted) {
    if ($860eea622cdf5973$var$currentRenderingInstance.isCE || $860eea622cdf5973$var$currentRenderingInstance.parent && $860eea622cdf5973$var$isAsyncWrapper($860eea622cdf5973$var$currentRenderingInstance.parent) && $860eea622cdf5973$var$currentRenderingInstance.parent.isCE) return $860eea622cdf5973$export$bf5c4cf060303d58("slot", name === "default" ? null : {
        name: name
    }, fallback && fallback());
    let slot = slots[name];
    // a compiled slot disables block tracking by default to avoid manual
    // invocation interfering with template-based block tracking, but in
    // `renderSlot` we can be sure that it's template-based so we can force
    // enable it.
    if (slot && slot._c) slot._d = false;
    $860eea622cdf5973$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $860eea622cdf5973$var$ensureValidVNode(slot(props));
    const rendered = $860eea622cdf5973$export$9f2dfe8048dfb22b($860eea622cdf5973$export$ffb0004e005737fa, {
        key: props.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* STABLE */  ? 64 /* STABLE_FRAGMENT */  : -2 /* BAIL */ );
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $860eea622cdf5973$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$860eea622cdf5973$export$3868d13f8734ae81(child)) return true;
        if (child.type === $860eea622cdf5973$export$4d299b491347818a) return false;
        if (child.type === $860eea622cdf5973$export$ffb0004e005737fa && !$860eea622cdf5973$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
/**
 * For prefixing keys in v-on="obj" with "on"
 * @private
 */ function $860eea622cdf5973$export$2fb94ff667a6a1a(obj) {
    const ret = {};
    for(const key in obj)ret[(0, $ltDz5.toHandlerKey)(key)] = obj[key];
    return ret;
}
/**
 * #2437 In Vue 3, functional components do not have a public instance proxy but
 * they exist in the internal parent chain. For code that relies on traversing
 * public $parent chains, skip functional ones and go to the parent instead.
 */ const $860eea622cdf5973$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($860eea622cdf5973$var$isStatefulComponent(i)) return $860eea622cdf5973$var$getExposeProxy(i) || i.proxy;
    return $860eea622cdf5973$var$getPublicInstance(i.parent);
};
const $860eea622cdf5973$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/*#__PURE__*/ (0, $ltDz5.extend)(Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$860eea622cdf5973$var$getPublicInstance(i.parent),
    $root: (i)=>$860eea622cdf5973$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $860eea622cdf5973$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$860eea622cdf5973$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $860eea622cdf5973$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $860eea622cdf5973$var$instanceWatch.bind(i) : (0, $ltDz5.NOOP)
});
const $860eea622cdf5973$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $860eea622cdf5973$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        // data / props / ctx
        // This getter gets called for every property access on the render context
        // during render and is a major hotspot. The most expensive part of this
        // is the multiple hasOwn() calls. It's much faster to do a simple property
        // access on a plain object, so we use an accessCache object (with null
        // prototype) to memoize what access type a key corresponds to.
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== undefined) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (setupState !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $ltDz5.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $860eea622cdf5973$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $860eea622cdf5973$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        // public $xxx properties
        if (publicGetter) {
            if (key === "$attrs") (0, $uDJ7A.track)(instance, "get" /* GET */ , key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(ctx, key)) {
            // user may set custom properties to `this` that start with `$`
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $ltDz5.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if (setupState !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(setupState, key)) {
            setupState[key] = value;
            return true;
        } else if (data !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(data, key)) {
            data[key] = value;
            return true;
        } else if ((0, $ltDz5.hasOwn)(instance.props, key)) return false;
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(data, key) || setupState !== (0, $ltDz5.EMPTY_OBJ) && (0, $ltDz5.hasOwn)(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $ltDz5.hasOwn)(normalizedProps, key) || (0, $ltDz5.hasOwn)(ctx, key) || (0, $ltDz5.hasOwn)($860eea622cdf5973$var$publicPropertiesMap, key) || (0, $ltDz5.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) // invalidate key cache of a getter based property #5417
        target._.accessCache[key] = 0;
        else if ((0, $ltDz5.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $860eea622cdf5973$var$target;
const $860eea622cdf5973$var$RuntimeCompiledPublicInstanceProxyHandlers = /*#__PURE__*/ (0, $ltDz5.extend)({}, $860eea622cdf5973$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        // fast path for unscopables when using `with` block
        if (key === Symbol.unscopables) return;
        return $860eea622cdf5973$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $ltDz5.isGloballyWhitelisted)(key);
        return has;
    }
});
// dev only
// In dev mode, the proxy target exposes the same properties as seen on `this`
// for easier console inspection. In prod mode it will be an empty object so
// these properties definitions can be skipped.
function $860eea622cdf5973$var$createDevRenderContext(instance) {
    const target = {};
    // expose internal instance for proxy handlers
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    // expose public properties
    Object.keys($860eea622cdf5973$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$860eea622cdf5973$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $ltDz5.NOOP)
        });
    });
    return target;
}
// dev only
function $860eea622cdf5973$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $ltDz5.NOOP)
        });
    });
}
// dev only
function $860eea622cdf5973$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $uDJ7A.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($860eea622cdf5973$var$isReservedPrefix(key[0])) {
                $860eea622cdf5973$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" ` + `which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $ltDz5.NOOP)
            });
        }
    });
}
function $860eea622cdf5973$var$createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key)=>{
        if (cache[key]) $860eea622cdf5973$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $860eea622cdf5973$var$shouldCacheAccess = true;
function $860eea622cdf5973$var$applyOptions(instance) {
    const options = $860eea622cdf5973$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    // do not cache property access on public proxy during state initialization
    $860eea622cdf5973$var$shouldCacheAccess = false;
    // call beforeCreate first before accessing other options since
    // the hook may mutate resolved options (#2791)
    if (options.beforeCreate) $860eea622cdf5973$var$callHook(options.beforeCreate, instance, "bc" /* BEFORE_CREATE */ );
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    // options initialization order (to be consistent with Vue 2):
    // - props (already done outside of this function)
    // - inject
    // - methods
    // - data (deferred since it relies on `this` access)
    // - computed
    // - watch (deferred since it relies on `this` access)
    if (injectOptions) $860eea622cdf5973$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $ltDz5.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $ltDz5.isObject)(data)) ;
        else instance.data = (0, $uDJ7A.reactive)(data);
    }
    // state initialization complete at this point - start caching access
    $860eea622cdf5973$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $ltDz5.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $ltDz5.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $ltDz5.NOOP);
        const set = !(0, $ltDz5.isFunction)(opt) && (0, $ltDz5.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $ltDz5.NOOP);
        const c = $860eea622cdf5973$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$860eea622cdf5973$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $ltDz5.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $860eea622cdf5973$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $860eea622cdf5973$var$callHook(created, instance, "c" /* CREATED */ );
    function registerLifecycleHook(register, hook) {
        if ((0, $ltDz5.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($860eea622cdf5973$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($860eea622cdf5973$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($860eea622cdf5973$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($860eea622cdf5973$export$5876c47052fb88b1, updated);
    registerLifecycleHook($860eea622cdf5973$export$ba52d824b95a2154, activated);
    registerLifecycleHook($860eea622cdf5973$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($860eea622cdf5973$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($860eea622cdf5973$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($860eea622cdf5973$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($860eea622cdf5973$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($860eea622cdf5973$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($860eea622cdf5973$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $ltDz5.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    // options that are handled when creating the instance but also need to be
    // applied from mixins
    if (render && instance.render === (0, $ltDz5.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    // asset options.
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $860eea622cdf5973$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $ltDz5.NOOP), unwrapRef = false) {
    if ((0, $ltDz5.isArray)(injectOptions)) injectOptions = $860eea622cdf5973$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $ltDz5.isObject)(opt)) {
            if ("default" in opt) injected = $860eea622cdf5973$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $860eea622cdf5973$export$a976684a0efeb93f(opt.from || key);
        } else injected = $860eea622cdf5973$export$a976684a0efeb93f(opt);
        if ((0, $uDJ7A.isRef)(injected)) {
            // TODO remove the check in 3.3
            if (unwrapRef) Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>injected.value,
                set: (v1)=>injected.value = v1
            });
            else ctx[key] = injected;
        } else ctx[key] = injected;
    }
}
function $860eea622cdf5973$var$callHook(hook, instance, type) {
    $860eea622cdf5973$export$dae85862a8d94378((0, $ltDz5.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $860eea622cdf5973$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $860eea622cdf5973$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $ltDz5.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $ltDz5.isFunction)(handler)) $860eea622cdf5973$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $ltDz5.isFunction)(raw)) $860eea622cdf5973$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $ltDz5.isObject)(raw)) {
        if ((0, $ltDz5.isArray)(raw)) raw.forEach((r)=>$860eea622cdf5973$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $ltDz5.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $ltDz5.isFunction)(handler)) $860eea622cdf5973$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
/**
 * Resolve merged options and cache it on the component.
 * This is done only once per-component since the merging does not involve
 * instances.
 */ function $860eea622cdf5973$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$860eea622cdf5973$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $860eea622cdf5973$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    cache.set(base, resolved);
    return resolved;
}
function $860eea622cdf5973$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $860eea622cdf5973$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$860eea622cdf5973$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $860eea622cdf5973$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $860eea622cdf5973$var$internalOptionMergeStrats = {
    data: $860eea622cdf5973$var$mergeDataFn,
    props: $860eea622cdf5973$var$mergeObjectOptions,
    emits: $860eea622cdf5973$var$mergeObjectOptions,
    // objects
    methods: $860eea622cdf5973$var$mergeObjectOptions,
    computed: $860eea622cdf5973$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $860eea622cdf5973$var$mergeAsArray,
    created: $860eea622cdf5973$var$mergeAsArray,
    beforeMount: $860eea622cdf5973$var$mergeAsArray,
    mounted: $860eea622cdf5973$var$mergeAsArray,
    beforeUpdate: $860eea622cdf5973$var$mergeAsArray,
    updated: $860eea622cdf5973$var$mergeAsArray,
    beforeDestroy: $860eea622cdf5973$var$mergeAsArray,
    beforeUnmount: $860eea622cdf5973$var$mergeAsArray,
    destroyed: $860eea622cdf5973$var$mergeAsArray,
    unmounted: $860eea622cdf5973$var$mergeAsArray,
    activated: $860eea622cdf5973$var$mergeAsArray,
    deactivated: $860eea622cdf5973$var$mergeAsArray,
    errorCaptured: $860eea622cdf5973$var$mergeAsArray,
    serverPrefetch: $860eea622cdf5973$var$mergeAsArray,
    // assets
    components: $860eea622cdf5973$var$mergeObjectOptions,
    directives: $860eea622cdf5973$var$mergeObjectOptions,
    // watch
    watch: $860eea622cdf5973$var$mergeWatchOptions,
    // provide / inject
    provide: $860eea622cdf5973$var$mergeDataFn,
    inject: $860eea622cdf5973$var$mergeInject
};
function $860eea622cdf5973$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $ltDz5.extend)((0, $ltDz5.isFunction)(to) ? to.call(this, this) : to, (0, $ltDz5.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $860eea622cdf5973$var$mergeInject(to, from) {
    return $860eea622cdf5973$var$mergeObjectOptions($860eea622cdf5973$var$normalizeInject(to), $860eea622cdf5973$var$normalizeInject(from));
}
function $860eea622cdf5973$var$normalizeInject(raw) {
    if ((0, $ltDz5.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $860eea622cdf5973$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $860eea622cdf5973$var$mergeObjectOptions(to, from) {
    return to ? (0, $ltDz5.extend)((0, $ltDz5.extend)(Object.create(null), to), from) : from;
}
function $860eea622cdf5973$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $ltDz5.extend)(Object.create(null), to);
    for(const key in from)merged[key] = $860eea622cdf5973$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $860eea622cdf5973$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $ltDz5.def)(attrs, $860eea622cdf5973$var$InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    $860eea622cdf5973$var$setFullProps(instance, rawProps, props, attrs);
    // ensure all declared prop keys are present
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = undefined;
    if (isStateful) // stateful
    instance.props = isSSR ? props : (0, $uDJ7A.shallowReactive)(props);
    else if (!instance.type.props) // functional w/ optional props, props === attrs
    instance.props = attrs;
    else // functional w/ declared props
    instance.props = props;
    instance.attrs = attrs;
}
function $860eea622cdf5973$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $uDJ7A.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16 /* FULL_PROPS */ )) {
        if (patchFlag & 8 /* PROPS */ ) {
            // Compiler-generated props & no keys change, just set the updated
            // the props.
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                // skip if the prop key is a declared emit event listener
                if ($860eea622cdf5973$var$isEmitListener(instance.emitsOptions, key)) continue;
                // PROPS flag guarantees rawProps to be non-null
                const value = rawProps[key];
                if (options) {
                    // attr / props separation was done on init and will be consistent
                    // in this code path, so just check if attrs have it.
                    if ((0, $ltDz5.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $ltDz5.camelize)(key);
                        props[camelizedKey] = $860eea622cdf5973$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        // full props update.
        if ($860eea622cdf5973$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        // in case of dynamic props, check if we need to delete keys from
        // the props object
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $ltDz5.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $ltDz5.hyphenate)(key)) === key || !(0, $ltDz5.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== undefined || // for kebab-case
                rawPrevProps[kebabKey] !== undefined)) props[key] = $860eea622cdf5973$var$resolvePropValue(options, rawCurrentProps, key, undefined, instance, true);
            } else delete props[key];
        }
        // in the case of functional component w/o props declaration, props and
        // attrs point to the same object so it should already have been updated.
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $ltDz5.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    // trigger updates for $attrs in case it's used in component slots
    if (hasAttrsChanged) (0, $uDJ7A.trigger)(instance, "set" /* SET */ , "$attrs");
}
function $860eea622cdf5973$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        // key, ref are reserved and never passed down
        if ((0, $ltDz5.isReservedProp)(key)) continue;
        const value = rawProps[key];
        // prop option names are camelized during normalization, so to support
        // kebab -> camel conversion here we need to camelize the key.
        let camelKey;
        if (options && (0, $ltDz5.hasOwn)(options, camelKey = (0, $ltDz5.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$860eea622cdf5973$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $uDJ7A.toRaw)(props);
        const castValues = rawCastValues || (0, $ltDz5.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $860eea622cdf5973$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $ltDz5.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $860eea622cdf5973$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $ltDz5.hasOwn)(opt, "default");
        // default values
        if (hasDefault && value === undefined) {
            const defaultValue = opt.default;
            if (opt.type !== Function && (0, $ltDz5.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    $860eea622cdf5973$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    $860eea622cdf5973$var$unsetCurrentInstance();
                }
            } else value = defaultValue;
        }
        // boolean casting
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $ltDz5.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $860eea622cdf5973$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $ltDz5.isFunction)(comp)) {
        const extendProps = (raw)=>{
            hasExtends = true;
            const [props, keys] = $860eea622cdf5973$var$normalizePropsOptions(raw, appContext, true);
            (0, $ltDz5.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        cache.set(comp, (0, $ltDz5.EMPTY_ARR));
        return 0, $ltDz5.EMPTY_ARR;
    }
    if ((0, $ltDz5.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $ltDz5.camelize)(raw[i]);
        if ($860eea622cdf5973$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $ltDz5.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $ltDz5.camelize)(key);
        if ($860eea622cdf5973$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $ltDz5.isArray)(opt) || (0, $ltDz5.isFunction)(opt) ? {
                type: opt
            } : opt;
            if (prop) {
                const booleanIndex = $860eea622cdf5973$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $860eea622cdf5973$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                // if the prop needs boolean casting or default value
                if (booleanIndex > -1 || (0, $ltDz5.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    cache.set(comp, res);
    return res;
}
function $860eea622cdf5973$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
// use function string name to check type constructors
// so that it works across vms / iframes.
function $860eea622cdf5973$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? "null" : "";
}
function $860eea622cdf5973$var$isSameType(a, b) {
    return $860eea622cdf5973$var$getType(a) === $860eea622cdf5973$var$getType(b);
}
function $860eea622cdf5973$var$getTypeIndex(type, expectedTypes) {
    if ((0, $ltDz5.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$860eea622cdf5973$var$isSameType(t, type));
    else if ((0, $ltDz5.isFunction)(expectedTypes)) return $860eea622cdf5973$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
/**
 * dev only
 */ function $860eea622cdf5973$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $uDJ7A.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $860eea622cdf5973$var$validateProp(key, resolvedValues[key], opt, !(0, $ltDz5.hasOwn)(rawProps, key) && !(0, $ltDz5.hasOwn)(rawProps, (0, $ltDz5.hyphenate)(key)));
    }
}
/**
 * dev only
 */ function $860eea622cdf5973$var$validateProp(name, value, prop, isAbsent) {
    const { type: type, required: required, validator: validator } = prop;
    // required!
    if (required && isAbsent) {
        $860eea622cdf5973$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    // missing but optional
    if (value == null && !prop.required) return;
    // type check
    if (type != null && type !== true) {
        let isValid = false;
        const types = (0, $ltDz5.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        // value is valid as long as one of the specified types match
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $860eea622cdf5973$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $860eea622cdf5973$export$c106dd0671a0fc2d($860eea622cdf5973$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    // custom validator
    if (validator && !validator(value)) $860eea622cdf5973$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $860eea622cdf5973$var$isSimpleType = /*#__PURE__*/ (0, $ltDz5.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
/**
 * dev only
 */ function $860eea622cdf5973$var$assertType(value, type) {
    let valid;
    const expectedType = $860eea622cdf5973$var$getType(type);
    if ($860eea622cdf5973$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $ltDz5.isObject)(value);
    else if (expectedType === "Array") valid = (0, $ltDz5.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
 * dev only
 */ function $860eea622cdf5973$var$getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}".` + ` Expected ${expectedTypes.map((0, $ltDz5.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $ltDz5.toRawType)(value);
    const expectedValue = $860eea622cdf5973$var$styleValue(value, expectedType);
    const receivedValue = $860eea622cdf5973$var$styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $860eea622cdf5973$var$isExplicable(expectedType) && !$860eea622cdf5973$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    // check if we need to specify received value
    if ($860eea622cdf5973$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
/**
 * dev only
 */ function $860eea622cdf5973$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
/**
 * dev only
 */ function $860eea622cdf5973$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
/**
 * dev only
 */ function $860eea622cdf5973$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $860eea622cdf5973$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $860eea622cdf5973$var$normalizeSlotValue = (value)=>(0, $ltDz5.isArray)(value) ? value.map($860eea622cdf5973$var$normalizeVNode) : [
        $860eea622cdf5973$var$normalizeVNode(value)
    ];
const $860eea622cdf5973$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) // already normalized - #5353
    return rawSlot;
    const normalized = $860eea622cdf5973$export$694b237e827a3d23((...args)=>{
        return $860eea622cdf5973$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $860eea622cdf5973$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($860eea622cdf5973$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $ltDz5.isFunction)(value)) slots[key] = $860eea622cdf5973$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $860eea622cdf5973$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $860eea622cdf5973$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $860eea622cdf5973$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $860eea622cdf5973$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            // users can get the shallow readonly version of the slots object through `this.$slots`,
            // we should avoid the proxy object polluting the slots of the internal instance
            instance.slots = (0, $uDJ7A.toRaw)(children);
            // make compiler marker non-enumerable
            (0, $ltDz5.def)(children, "_", type);
        } else $860eea622cdf5973$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $860eea622cdf5973$var$normalizeVNodeSlots(instance, children);
    }
    (0, $ltDz5.def)(instance.slots, $860eea622cdf5973$var$InternalObjectKey, 1);
};
const $860eea622cdf5973$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $ltDz5.EMPTY_OBJ);
    if (vnode.shapeFlag & 32 /* SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            if (optimized && type === 1 /* STABLE */ ) // compiled AND stable.
            // no need to update, and skip stale slots removal.
            needDeletionCheck = false;
            else {
                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
                // normalization.
                (0, $ltDz5.extend)(slots, children);
                // #2893
                // when rendering the optimized slots by manually written render function,
                // we need to delete the `slots._` flag if necessary to make subsequent updates reliable,
                // i.e. let the `renderSlot` create the bailed Fragment
                if (!optimized && type === 1 /* STABLE */ ) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $860eea622cdf5973$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        // non slot object children (direct value) passed to a component
        $860eea622cdf5973$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    // delete stale slots
    if (needDeletionCheck) {
        for(const key in slots)if (!$860eea622cdf5973$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $860eea622cdf5973$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $ltDz5.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: undefined,
            warnHandler: undefined,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap(),
        propsCache: new WeakMap(),
        emitsCache: new WeakMap()
    };
}
let $860eea622cdf5973$var$uid = 0;
function $860eea622cdf5973$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $ltDz5.isFunction)(rootComponent)) rootComponent = Object.assign({}, rootComponent);
        if (rootProps != null && !(0, $ltDz5.isObject)(rootProps)) rootProps = null;
        const context = $860eea622cdf5973$var$createAppContext();
        const installedPlugins = new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $860eea622cdf5973$var$uid++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $860eea622cdf5973$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $ltDz5.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $ltDz5.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $860eea622cdf5973$export$bf5c4cf060303d58(rootComponent, rootProps);
                    // store app context on the root VNode.
                    // this will be set on the root instance on initial mount.
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $860eea622cdf5973$var$devtoolsInitApp(app, $860eea622cdf5973$export$83d89fbfd8236492);
                    }
                    return $860eea622cdf5973$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $860eea622cdf5973$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            }
        };
        return app;
    };
}
/**
 * Function for handling a template ref
 */ function $860eea622cdf5973$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $ltDz5.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$860eea622cdf5973$var$setRef(r, oldRawRef && ((0, $ltDz5.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($860eea622cdf5973$var$isAsyncWrapper(vnode) && !isUnmount) // when mounting async components, nothing needs to be done,
    // because the template ref is forwarded to inner component
    return;
    const refValue = vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */  ? $860eea622cdf5973$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $ltDz5.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    // dynamic ref changed. unset old ref
    if (oldRef != null && oldRef !== ref) {
        if ((0, $ltDz5.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $ltDz5.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $uDJ7A.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $ltDz5.isFunction)(ref)) $860eea622cdf5973$export$b22fcaf88446e9bf(ref, owner, 12 /* FUNCTION_REF */ , [
        value,
        refs
    ]);
    else {
        const _isString = (0, $ltDz5.isString)(ref);
        const _isRef = (0, $uDJ7A.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? refs[ref] : ref.value;
                    if (isUnmount) (0, $ltDz5.isArray)(existing) && (0, $ltDz5.remove)(existing, refValue);
                    else {
                        if (!(0, $ltDz5.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $ltDz5.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $ltDz5.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $860eea622cdf5973$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $860eea622cdf5973$var$hasMismatch = false;
const $860eea622cdf5973$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $860eea622cdf5973$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
// Note: hydration is DOM-specific
// But we have to place it in core due to tight coupling with core - splitting
// it out creates a ton of unnecessary complexity.
// Hydration also depends on some renderer internal logic which needs to be
// passed in via arguments.
function $860eea622cdf5973$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $860eea622cdf5973$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $860eea622cdf5973$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $860eea622cdf5973$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($860eea622cdf5973$var$hasMismatch && true) // this error should show up in production
        console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $860eea622cdf5973$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        const domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2 /* BAIL */ ) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $860eea622cdf5973$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    // #5728 empty text node inside a slot can cause hydration failure
                    // because the server rendered HTML won't contain a text node
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $860eea622cdf5973$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $860eea622cdf5973$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $860eea622cdf5973$export$c1b9a1d3af45b7b6:
                if (domType !== 1 /* ELEMENT */  && domType !== 3 /* TEXT */ ) nextNode = onMismatch();
                else {
                    // determine anchor, adopt content
                    nextNode = node;
                    // if the static vnode has its content stripped during build,
                    // adopt it from the server-rendered HTML.
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return nextNode;
                }
                break;
            case $860eea622cdf5973$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6 /* COMPONENT */ ) {
                    // when setting up the render effect, if the initial vnode already
                    // has .el set, the component will perform hydration instead of mount
                    // on its sub-tree.
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $860eea622cdf5973$var$isSVGContainer(container), optimized);
                    // component may be async, so in the case of fragments we cannot rely
                    // on component's rendered output to determine the end of the fragment
                    // instead, we do a lookahead to find the end anchor node.
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    // #4293 teleport as component root
                    if (nextNode && $860eea622cdf5973$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    // #3787
                    // if component is async, it may get moved / unmounted before its
                    // inner component is loaded, so we need to give it a placeholder
                    // vnode that matches its adopted DOM.
                    if ($860eea622cdf5973$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $860eea622cdf5973$export$22f9b5ffd89dac9("") : $860eea622cdf5973$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64 /* TELEPORT */ ) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128 /* SUSPENSE */ ) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $860eea622cdf5973$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $860eea622cdf5973$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        // #4006 for form elements with non-string v-model value bindings
        // e.g. <option :value="obj">, <input type="checkbox" :true-value="1">
        const forcePatchValue = type === "input" && dirs || type === "option";
        // skip props & children if this is hoisted static nodes
        // #5405 in dev, always hydrate children for HMR
        if (forcePatchValue || patchFlag !== -1 /* HOISTED */ ) {
            if (dirs) $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48 /* HYDRATE_EVENTS */ ) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $ltDz5.isOn)(key) && !(0, $ltDz5.isReservedProp)(key)) patchProp(el, key, null, props[key], false, undefined, parentComponent);
                } else if (props.onClick) // Fast path for click listeners (which is most often) to avoid
                // iterating through props.
                patchProp(el, "onClick", null, props.onClick, false, undefined, parentComponent);
            }
            // vnode / directive hooks
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $860eea622cdf5973$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $860eea622cdf5973$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $860eea622cdf5973$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            // children
            if (shapeFlag & 16 /* ARRAY_CHILDREN */  && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $860eea622cdf5973$var$hasMismatch = true;
                    // The SSRed DOM contains more nodes than it should. Remove them.
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
                if (el.textContent !== vnode.children) {
                    $860eea622cdf5973$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $860eea622cdf5973$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $860eea622cdf5973$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $860eea622cdf5973$var$hasMismatch = true;
                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
                patch(null, vnode, container, null, parentComponent, parentSuspense, $860eea622cdf5973$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $860eea622cdf5973$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            // fragment didn't hydrate successfully, since we didn't get a end anchor
            // back. This should have led to node/children mismatch warnings.
            $860eea622cdf5973$var$hasMismatch = true;
            // since the anchor is missing, we need to create one and insert it
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $860eea622cdf5973$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            // remove excessive fragment nodes
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $860eea622cdf5973$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $860eea622cdf5973$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
/* eslint-disable no-restricted-globals */ let $860eea622cdf5973$var$supported;
let $860eea622cdf5973$var$perf;
function $860eea622cdf5973$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $860eea622cdf5973$var$isSupported()) $860eea622cdf5973$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$var$devtoolsPerfStart(instance, type, $860eea622cdf5973$var$isSupported() ? $860eea622cdf5973$var$perf.now() : Date.now());
}
function $860eea622cdf5973$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $860eea622cdf5973$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $860eea622cdf5973$var$perf.mark(endTag);
        $860eea622cdf5973$var$perf.measure(`<${$860eea622cdf5973$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $860eea622cdf5973$var$perf.clearMarks(startTag);
        $860eea622cdf5973$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$var$devtoolsPerfEnd(instance, type, $860eea622cdf5973$var$isSupported() ? $860eea622cdf5973$var$perf.now() : Date.now());
}
function $860eea622cdf5973$var$isSupported() {
    if ($860eea622cdf5973$var$supported !== undefined) return $860eea622cdf5973$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $860eea622cdf5973$var$supported = true;
        $860eea622cdf5973$var$perf = window.performance;
    } else $860eea622cdf5973$var$supported = false;
    return $860eea622cdf5973$var$supported;
}
/**
 * This is only called in esm-bundler builds.
 * It is called when a renderer is created, in `baseCreateRenderer` so that
 * importing runtime-core is side-effects free.
 *
 * istanbul-ignore-next
 */ function $860eea622cdf5973$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $ltDz5.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $ltDz5.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $860eea622cdf5973$var$queuePostRenderEffect = $860eea622cdf5973$var$queueEffectWithSuspense;
/**
 * The createRenderer function accepts two generic arguments:
 * HostNode and HostElement, corresponding to Node and Element types in the
 * host environment. For example, for runtime-dom, HostNode would be the DOM
 * `Node` interface and HostElement would be the DOM `Element` interface.
 *
 * Custom renderers can pass in the platform specific types like this:
 *
 * ``` js
 * const { render, createApp } = createRenderer<Node, Element>({
 *   patchProp,
 *   ...nodeOps
 * })
 * ```
 */ function $860eea622cdf5973$export$53ae2f996c64e9a(options) {
    return $860eea622cdf5973$var$baseCreateRenderer(options);
}
// Separate API for creating hydration-enabled renderer.
// Hydration logic is only used when calling this function, making it
// tree-shakable.
function $860eea622cdf5973$export$200524cf0d997ff0(options) {
    return $860eea622cdf5973$var$baseCreateRenderer(options, $860eea622cdf5973$var$createHydrationFunctions);
}
// implementation
function $860eea622cdf5973$var$baseCreateRenderer(options, createHydrationFns) {
    $860eea622cdf5973$var$initFeatureFlags();
    const target = (0, $ltDz5.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $ltDz5.NOOP), cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
    // Note: functions inside this closure should use `const xxx = () => {}`
    // style in order to prevent being inlined by minifiers.
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        // patching & not same type, unmount old tree
        if (n1 && !$860eea622cdf5973$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2 /* BAIL */ ) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $860eea622cdf5973$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $860eea622cdf5973$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $860eea622cdf5973$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $860eea622cdf5973$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */ ) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6 /* COMPONENT */ ) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64 /* TELEPORT */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128 /* SUSPENSE */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        // set ref
        if (ref != null && parentComponent) $860eea622cdf5973$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else // there's no support for dynamic comments
        n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    /**
     * Dev / HMR only
     */ const patchStaticNode = (n1, n2, container, isSVG)=>{
        // static nodes are only patched during dev for HMR
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            // remove existing
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, patchFlag: patchFlag, dirs: dirs } = vnode;
        if ((0, vnode.el) && hostCloneNode !== undefined && patchFlag === -1 /* HOISTED */ ) // If a vnode has non-null el, it means it's being reused.
        // Only static vnodes can be reused, so its mounted DOM nodes should be
        // exactly the same, and we can simply do a clone here.
        // only do this in production since cloned trees cannot be HMR updated.
        el = vnode.el = hostCloneNode(vnode.el);
        else {
            el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
            // mount children first, since some props may rely on child content
            // being already rendered, e.g. `<select value>`
            if (shapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(el, vnode.children);
            else if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
            if (dirs) $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                for(const key in props)if (key !== "value" && !(0, $ltDz5.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                /**
                 * Special case for setting value on DOM elements:
                 * - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
                 * - it needs to be forced (#1471)
                 * #2353 proposes adding another renderer option to configure this, but
                 * the properties affects are so finite it is worth special casing it
                 * here to reduce the complexity. (Special casing it also should not
                 * affect non-DOM renderers)
                 */ if ("value" in props) hostPatchProp(el, "value", null, props.value);
                if (vnodeHook = props.onVnodeBeforeMount) $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            }
            // scopeId
            setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
        // #1689 For inside suspense + suspense resolved case, just call it
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $860eea622cdf5973$var$queuePostRenderEffect(()=>{
            vnodeHook && $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $860eea622cdf5973$var$cloneIfMounted(children[i]) : $860eea622cdf5973$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        // #1426 take the old vnode's patch flag into account since user may clone a
        // compiler-generated vnode, which de-opts to FULL_PROPS
        patchFlag |= n1.patchFlag & 16 /* FULL_PROPS */ ;
        const oldProps = n1.props || (0, $ltDz5.EMPTY_OBJ);
        const newProps = n2.props || (0, $ltDz5.EMPTY_OBJ);
        let vnodeHook;
        // disable recurse in beforeUpdate hooks
        parentComponent && $860eea622cdf5973$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $860eea622cdf5973$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $860eea622cdf5973$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) // full diff
        patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            // the presence of a patchFlag means this element's render code was
            // generated by the compiler and can take the fast path.
            // in this path old node and new node are guaranteed to have the same shape
            // (i.e. at the exact same position in the source template)
            if (patchFlag & 16 /* FULL_PROPS */ ) // element props contain dynamic keys, full diff needed
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                // class
                // this flag is matched when the element has dynamic class bindings.
                if (patchFlag & 2 /* CLASS */ ) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                // style
                // this flag is matched when the element has dynamic style bindings
                if (patchFlag & 4 /* STYLE */ ) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                // props
                // This flag is matched when the element has dynamic prop/attr bindings
                // other than class and style. The keys of dynamic prop/attrs are saved for
                // faster iteration.
                // Note dynamic keys like :[foo]="bar" will cause this optimization to
                // bail out and go through a full diff because we need to unset the old key
                if (patchFlag & 8 /* PROPS */ ) {
                    // if the flag is present then dynamicProps must be non-null
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        // #1471 force patch value
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            // text
            // This flag is matched when the element has only dynamic text children.
            if (patchFlag & 1 /* TEXT */ ) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) // unoptimized, full diff
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $860eea622cdf5973$var$queuePostRenderEffect(()=>{
            vnodeHook && $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $860eea622cdf5973$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    // The fast path for blocks.
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            // Determine the container (parent element) for the patch.
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $860eea622cdf5973$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$860eea622cdf5973$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70 /* TELEPORT */ ) ? hostParentNode(oldVNode.el) : // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            for(const key in newProps){
                // empty string is not valid prop
                if ((0, $ltDz5.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                // defer patching value
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if (oldProps !== (0, $ltDz5.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $ltDz5.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        // check if this is a slot fragment with :slotted scope ids
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            // a fragment can only have array children
            // since they are either generated by the compiler, or implicitly created
            // from arrays.
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */  && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            // a stable fragment (template root or <template v-for>) doesn't need to
            // patch children order, but it may contain dynamicChildren.
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $860eea622cdf5973$var$traverseStaticChildren(n1, n2, true);
        } else // keyed / unkeyed, or manual fragments.
        // for keyed & unkeyed, since they are compiler generated from v-for,
        // each child is guaranteed to be a block so the fragment will never
        // have dynamicChildren.
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */ ) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $860eea622cdf5973$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        // inject renderer internals for keepAlive
        if ($860eea622cdf5973$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $860eea622cdf5973$var$setupComponent(instance);
        // setup() is async. This component relies on async logic to be resolved
        // before proceeding
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            // Give it a placeholder if this is not hydration
            // TODO handle self-defined fallback
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($860eea622cdf5973$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                // normal update
                instance.next = n2;
                // in case the child component is also queued, remove it to avoid
                // double updating the same child component in the same flush.
                $860eea622cdf5973$var$invalidateJob(instance.update);
                // instance.update is the reactive effect.
                instance.update();
            }
        } else {
            // no update needed. just copy over properties
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $860eea622cdf5973$var$isAsyncWrapper(initialVNode);
                $860eea622cdf5973$var$toggleRecurse(instance, false);
                // beforeMount hook
                if (bm) (0, $ltDz5.invokeArrayFns)(bm);
                // onVnodeBeforeMount
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $860eea622cdf5973$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    // vnode has adopted host node - perform hydration instead of mount.
                    const hydrateSubTree = ()=>{
                        instance.subTree = $860eea622cdf5973$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $860eea622cdf5973$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                // mounted hook
                if (m) $860eea622cdf5973$var$queuePostRenderEffect(m, parentSuspense);
                // onVnodeMounted
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $860eea622cdf5973$var$queuePostRenderEffect(()=>$860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                // activated hook for keep-alive roots.
                // #1742 activated hook must be accessed after first render
                // since the hook may be injected by a child keep-alive
                if (initialVNode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */  || parent && $860eea622cdf5973$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) instance.a && $860eea622cdf5973$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$var$devtoolsComponentAdded(instance);
                // #2458: deference mount-only object parameters to prevent memleaks
                initialVNode = container = anchor = null;
            } else {
                // updateComponent
                // This is triggered by mutation of component's own state (next: null)
                // OR parent calling processComponent (next: VNode)
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                // Disallow component effect recursion during pre-lifecycle hooks.
                $860eea622cdf5973$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                // beforeUpdate hook
                if (bu) (0, $ltDz5.invokeArrayFns)(bu);
                // onVnodeBeforeUpdate
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $860eea622cdf5973$var$toggleRecurse(instance, true);
                const nextTree = $860eea622cdf5973$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) // self-triggered update. In case of HOC, update parent component
                // vnode el. HOC is indicated by parent instance's subTree pointing
                // to child component's vnode
                $860eea622cdf5973$var$updateHOCHostEl(instance, nextTree.el);
                // updated hook
                if (u) $860eea622cdf5973$var$queuePostRenderEffect(u, parentSuspense);
                // onVnodeUpdated
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $860eea622cdf5973$var$queuePostRenderEffect(()=>$860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$var$devtoolsComponentUpdated(instance);
            }
        };
        // create reactive effect for rendering
        const effect = instance.effect = new (0, $uDJ7A.ReactiveEffect)(componentUpdateFn, ()=>$860eea622cdf5973$var$queueJob(update), instance.scope // track it in component's effect scope
        );
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        // allowRecurse
        // #1801, #2043 component render effects should allow recursive updates
        $860eea622cdf5973$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $860eea622cdf5973$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $860eea622cdf5973$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $uDJ7A.pauseTracking)();
        // props update may have triggered pre-flush watchers.
        // flush them before the render update.
        $860eea622cdf5973$var$flushPreFlushCbs(undefined, instance.update);
        (0, $uDJ7A.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        // fast path
        if (patchFlag > 0) {
            if (patchFlag & 128 /* KEYED_FRAGMENT */ ) {
                // this could be either fully-keyed or mixed (some keyed some not)
                // presence of patchFlag means children are guaranteed to be arrays
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256 /* UNKEYED_FRAGMENT */ ) {
                // unkeyed
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        // children has 3 possibilities: text, array or no children.
        if (shapeFlag & 8 /* TEXT_CHILDREN */ ) {
            // text children fast path
            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            // prev children was array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) // two arrays, cannot assume anything, do full diff
            patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else // no new children, just unmount old
            unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            // prev children was text OR null
            // new children is array OR null
            if (prevShapeFlag & 8 /* TEXT_CHILDREN */ ) hostSetElementText(container, "");
            // mount new if array
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $ltDz5.EMPTY_ARR);
        c2 = c2 || (0, $ltDz5.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $860eea622cdf5973$var$cloneIfMounted(c2[i]) : $860eea622cdf5973$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) // remove old
        unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else // mount new
        mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    // can be all-keyed or mixed
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1; // prev ending index
        let e2 = l2 - 1; // next ending index
        // 1. sync from start
        // (a b) c
        // (a b) d e
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $860eea622cdf5973$var$cloneIfMounted(c2[i]) : $860eea622cdf5973$var$normalizeVNode(c2[i]);
            if ($860eea622cdf5973$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        // 2. sync from end
        // a (b c)
        // d e (b c)
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $860eea622cdf5973$var$cloneIfMounted(c2[e2]) : $860eea622cdf5973$var$normalizeVNode(c2[e2]);
            if ($860eea622cdf5973$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        // 3. common sequence + mount
        // (a b)
        // (a b) c
        // i = 2, e1 = 1, e2 = 2
        // (a b)
        // c (a b)
        // i = 0, e1 = -1, e2 = 0
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $860eea622cdf5973$var$cloneIfMounted(c2[i]) : $860eea622cdf5973$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i; // prev starting index
            const s2 = i; // next starting index
            // 5.1 build key:index map for newChildren
            const keyToNewIndexMap = new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $860eea622cdf5973$var$cloneIfMounted(c2[i]) : $860eea622cdf5973$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            // 5.2 loop through old children left to be patched and try to patch
            // matching nodes & remove nodes that are no longer present
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            // used to track whether any node has moved
            let maxNewIndexSoFar = 0;
            // works as Map<newIndex, oldIndex>
            // Note that oldIndex is offset by +1
            // and oldIndex = 0 is a special value indicating the new node has
            // no corresponding old node.
            // used for determining longest stable subsequence
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    // all new children have been patched so this can only be a removal
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    // key-less node, try to locate a key-less node of the same type
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $860eea622cdf5973$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === undefined) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            // 5.3 move and mount
            // generate longest stable subsequence only when nodes have moved
            const increasingNewIndexSequence = moved ? $860eea622cdf5973$var$getSequence(newIndexToOldIndexMap) : (0, $ltDz5.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            // looping backwards so that we can use last patched node as anchor
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) // mount new
                patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    // move if:
                    // There is no stable subsequence (e.g. a reverse)
                    // OR current node is not among the stable sequence
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2 /* REORDER */ );
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6 /* COMPONENT */ ) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128 /* SUSPENSE */ ) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $860eea622cdf5973$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $860eea622cdf5973$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        // single nodes
        const needTransition = moveType !== 2 /* REORDER */  && shapeFlag & 1 /* ELEMENT */  && transition;
        if (needTransition) {
            if (moveType === 0 /* ENTER */ ) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $860eea622cdf5973$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        // unset ref
        if (ref != null) $860eea622cdf5973$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */ ) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 /* ELEMENT */  && dirs;
        const shouldInvokeVnodeHook = !$860eea622cdf5973$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6 /* COMPONENT */ ) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128 /* SUSPENSE */ ) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64 /* TELEPORT */ ) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $860eea622cdf5973$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */ )) // fast path for block nodes: only need to unmount dynamic children.
            unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $860eea622cdf5973$export$ffb0004e005737fa && patchFlag & 384 /* UNKEYED_FRAGMENT */  || !optimized && shapeFlag & 16 /* ARRAY_CHILDREN */ ) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $860eea622cdf5973$var$queuePostRenderEffect(()=>{
            vnodeHook && $860eea622cdf5973$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $860eea622cdf5973$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $860eea622cdf5973$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $860eea622cdf5973$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 /* ELEMENT */  && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        // For fragments, directly remove all contained DOM nodes.
        // (fragment child nodes cannot have transition)
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        // beforeUnmount hook
        if (bum) (0, $ltDz5.invokeArrayFns)(bum);
        // stop effects in component scope
        scope.stop();
        // update may be null if a component is unmounted before its async
        // setup has resolved.
        if (update) {
            // so that scheduler will no longer invoke it
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        // unmounted hook
        if (um) $860eea622cdf5973$var$queuePostRenderEffect(um, parentSuspense);
        $860eea622cdf5973$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        // A component with async dep inside a pending suspense is unmounted before
        // its async dep resolves. This should remove the dep from the suspense, and
        // cause the suspense to resolve immediately if that was the last dep.
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $860eea622cdf5973$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6 /* COMPONENT */ ) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128 /* SUSPENSE */ ) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $860eea622cdf5973$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $860eea622cdf5973$var$createAppAPI(render, hydrate)
    };
}
function $860eea622cdf5973$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
/**
 * #1156
 * When a component is HMR-enabled, we need to make sure that all static nodes
 * inside a block also inherit the DOM element from the previous tree so that
 * HMR updates (which are full updates) can retrieve the element for patching.
 *
 * #2080
 * Inside keyed `template` fragment static children, if a fragment is moved,
 * the children will always be moved. Therefore, in order to ensure correct move
 * position, el should be inherited from previous nodes.
 */ function $860eea622cdf5973$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $ltDz5.isArray)(ch1) && (0, $ltDz5.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        // this is only called in the optimized path so array children are
        // guaranteed to be vnodes
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 /* ELEMENT */  && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* HYDRATE_EVENTS */ ) {
                c2 = ch2[i] = $860eea622cdf5973$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $860eea622cdf5973$var$traverseStaticChildren(c1, c2);
        }
    }
}
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function $860eea622cdf5973$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $860eea622cdf5973$var$isTeleport = (type)=>type.__isTeleport;
const $860eea622cdf5973$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $860eea622cdf5973$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $860eea622cdf5973$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $ltDz5.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $860eea622cdf5973$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $860eea622cdf5973$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            // insert anchors in the main view
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $860eea622cdf5973$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
                isSVG = isSVG || $860eea622cdf5973$var$isTargetSVG(target);
            }
            const mount = (container, anchor)=>{
                // Teleport *always* has Array children. This is enforced in both the
                // compiler and vnode children normalization.
                if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            // update content
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $860eea622cdf5973$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $860eea622cdf5973$var$isTargetSVG(target);
            if (dynamicChildren) {
                // fast path when the teleport happens to be a block root
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                // even in block tree mode we need to make sure all root-level nodes
                // in the teleport inherit previous DOM references so that they can
                // be moved in future patches.
                $860eea622cdf5973$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) // enabled -> disabled
                // move into main container
                $860eea622cdf5973$var$moveTeleport(n2, container, mainAnchor, internals, 1 /* TOGGLE */ );
            } else {
                // target changed
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $860eea622cdf5973$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $860eea622cdf5973$var$moveTeleport(n2, nextTarget, null, internals, 0 /* TARGET_CHANGE */ );
                } else if (wasDisabled) // disabled -> enabled
                // move into teleport target
                $860eea622cdf5973$var$moveTeleport(n2, target, targetAnchor, internals, 1 /* TOGGLE */ );
            }
        }
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        // an unmounted teleport should always remove its children if not disabled
        if (doRemove || !$860eea622cdf5973$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $860eea622cdf5973$var$moveTeleport,
    hydrate: $860eea622cdf5973$var$hydrateTeleport
};
function $860eea622cdf5973$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2 /* REORDER */ ) {
    // move target anchor if this is a target change.
    if (moveType === 0 /* TARGET_CHANGE */ ) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2 /* REORDER */ ;
    // move main view anchor if this is a re-order.
    if (isReorder) insert(el, container, parentAnchor);
    // if this is a re-order and teleport is enabled (content is in target)
    // do not move children. So the opposite is: only move children if this
    // is not a reorder, or the teleport is disabled
    if (!isReorder || $860eea622cdf5973$var$isTeleportDisabled(props)) {
        // Teleport has either Array children or no children.
        if (shapeFlag & 16 /* ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2 /* REORDER */ );
    }
    // move main view anchor if this is a re-order.
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $860eea622cdf5973$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $860eea622cdf5973$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        // if multiple teleports rendered to the same target element, we need to
        // pick up from where the last teleport finished instead of the first node
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16 /* ARRAY_CHILDREN */ ) {
            if ($860eea622cdf5973$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                // lookahead until we find the target anchor
                // we cannot rely on return value of hydrateChildren() because there
                // could be nested teleports
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
// Force-casted public typing for h and TSX props inference
const $860eea622cdf5973$export$76d55a0304a371f4 = $860eea622cdf5973$var$TeleportImpl;
const $860eea622cdf5973$export$ffb0004e005737fa = Symbol(undefined);
const $860eea622cdf5973$export$5f1af8db9871e1d6 = Symbol(undefined);
const $860eea622cdf5973$export$4d299b491347818a = Symbol(undefined);
const $860eea622cdf5973$export$c1b9a1d3af45b7b6 = Symbol(undefined);
// Since v-if and v-for are the two possible ways node structure can dynamically
// change, once we consider v-if branches and each v-for fragment a block, we
// can divide a template into nested blocks, and within each block the node
// structure would be stable. This allows us to skip most children diffing
// and only worry about the dynamic nodes (indicated by patch flags).
const $860eea622cdf5973$var$blockStack = [];
let $860eea622cdf5973$var$currentBlock = null;
/**
 * Open a block.
 * This must be called before `createBlock`. It cannot be part of `createBlock`
 * because the children of the block are evaluated before `createBlock` itself
 * is called. The generated code typically looks like this:
 *
 * ```js
 * function render() {
 *   return (openBlock(),createBlock('div', null, [...]))
 * }
 * ```
 * disableTracking is true when creating a v-for fragment block, since a v-for
 * fragment always diffs its children.
 *
 * @private
 */ function $860eea622cdf5973$export$e7eaa45e502fe5cc(disableTracking = false) {
    $860eea622cdf5973$var$blockStack.push($860eea622cdf5973$var$currentBlock = disableTracking ? null : []);
}
function $860eea622cdf5973$var$closeBlock() {
    $860eea622cdf5973$var$blockStack.pop();
    $860eea622cdf5973$var$currentBlock = $860eea622cdf5973$var$blockStack[$860eea622cdf5973$var$blockStack.length - 1] || null;
}
// Whether we should be tracking dynamic child nodes inside a block.
// Only tracks when this value is > 0
// We are not using a simple boolean because this value may need to be
// incremented/decremented by nested usage of v-once (see below)
let $860eea622cdf5973$var$isBlockTreeEnabled = 1;
/**
 * Block tracking sometimes needs to be disabled, for example during the
 * creation of a tree that needs to be cached by v-once. The compiler generates
 * code like this:
 *
 * ``` js
 * _cache[1] || (
 *   setBlockTracking(-1),
 *   _cache[1] = createVNode(...),
 *   setBlockTracking(1),
 *   _cache[1]
 * )
 * ```
 *
 * @private
 */ function $860eea622cdf5973$export$c20bee82f26f1e27(value) {
    $860eea622cdf5973$var$isBlockTreeEnabled += value;
}
function $860eea622cdf5973$var$setupBlock(vnode) {
    // save current block children on the block vnode
    vnode.dynamicChildren = $860eea622cdf5973$var$isBlockTreeEnabled > 0 ? $860eea622cdf5973$var$currentBlock || (0, $ltDz5.EMPTY_ARR) : null;
    // close block
    $860eea622cdf5973$var$closeBlock();
    // a block is always going to be patched, so track it as a child of its
    // parent block
    if ($860eea622cdf5973$var$isBlockTreeEnabled > 0 && $860eea622cdf5973$var$currentBlock) $860eea622cdf5973$var$currentBlock.push(vnode);
    return vnode;
}
/**
 * @private
 */ function $860eea622cdf5973$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $860eea622cdf5973$var$setupBlock($860eea622cdf5973$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
 * A block root keeps track of dynamic nodes within the block in the
 * `dynamicChildren` array.
 *
 * @private
 */ function $860eea622cdf5973$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $860eea622cdf5973$var$setupBlock($860eea622cdf5973$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $860eea622cdf5973$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $860eea622cdf5973$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $860eea622cdf5973$var$vnodeArgsTransformer;
/**
 * Internal API for registering an arguments transform for createVNode
 * used for creating stubs in the test-utils
 * It is *internal* but needs to be exposed for test-utils to pick up proper
 * typings
 */ function $860eea622cdf5973$export$83beccd3afeeb809(transformer) {
    $860eea622cdf5973$var$vnodeArgsTransformer = transformer;
}
const $860eea622cdf5973$var$createVNodeWithArgsTransform = (...args)=>{
    return $860eea622cdf5973$var$_createVNode(...$860eea622cdf5973$var$vnodeArgsTransformer ? $860eea622cdf5973$var$vnodeArgsTransformer(args, $860eea622cdf5973$var$currentRenderingInstance) : args);
};
const $860eea622cdf5973$var$InternalObjectKey = `__vInternal`;
const $860eea622cdf5973$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $860eea622cdf5973$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    return ref != null ? (0, $ltDz5.isString)(ref) || (0, $uDJ7A.isRef)(ref) || (0, $ltDz5.isFunction)(ref) ? {
        i: $860eea622cdf5973$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $860eea622cdf5973$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $860eea622cdf5973$export$ffb0004e005737fa ? 0 : 1 /* ELEMENT */ , isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $860eea622cdf5973$var$normalizeKey(props),
        ref: props && $860eea622cdf5973$var$normalizeRef(props),
        scopeId: $860eea622cdf5973$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null
    };
    if (needFullChildrenNormalization) {
        $860eea622cdf5973$var$normalizeChildren(vnode, children);
        // normalize suspense children
        if (shapeFlag & 128 /* SUSPENSE */ ) type.normalize(vnode);
    } else if (children) // compiled element vnode - if children is passed, only possible types are
    // string or Array.
    vnode.shapeFlag |= (0, $ltDz5.isString)(children) ? 8 /* TEXT_CHILDREN */  : 16 /* ARRAY_CHILDREN */ ;
    // track vnode for block tree
    if ($860eea622cdf5973$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $860eea622cdf5973$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6 /* COMPONENT */ ) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32 /* HYDRATE_EVENTS */ ) $860eea622cdf5973$var$currentBlock.push(vnode);
    return vnode;
}
const $860eea622cdf5973$export$bf5c4cf060303d58 = $860eea622cdf5973$var$_createVNode;
function $860eea622cdf5973$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $860eea622cdf5973$var$NULL_DYNAMIC_COMPONENT) type = $860eea622cdf5973$export$4d299b491347818a;
    if ($860eea622cdf5973$export$3868d13f8734ae81(type)) {
        // createVNode receiving an existing vnode. This happens in cases like
        // <component :is="vnode"/>
        // #2078 make sure to merge refs during the clone instead of overwriting it
        const cloned = $860eea622cdf5973$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $860eea622cdf5973$var$normalizeChildren(cloned, children);
        if ($860eea622cdf5973$var$isBlockTreeEnabled > 0 && !isBlockNode && $860eea622cdf5973$var$currentBlock) {
            if (cloned.shapeFlag & 6 /* COMPONENT */ ) $860eea622cdf5973$var$currentBlock[$860eea622cdf5973$var$currentBlock.indexOf(type)] = cloned;
            else $860eea622cdf5973$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2 /* BAIL */ ;
        return cloned;
    }
    // class component normalization.
    if ($860eea622cdf5973$var$isClassComponent(type)) type = type.__vccOpts;
    // class & style normalization.
    if (props) {
        // for reactive or proxy objects, we need to clone it to enable mutation.
        props = $860eea622cdf5973$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $ltDz5.isString)(klass)) props.class = (0, $ltDz5.normalizeClass)(klass);
        if ((0, $ltDz5.isObject)(style)) {
            // reactive state objects need to be cloned since they are likely to be
            // mutated
            if ((0, $uDJ7A.isProxy)(style) && !(0, $ltDz5.isArray)(style)) style = (0, $ltDz5.extend)({}, style);
            props.style = (0, $ltDz5.normalizeStyle)(style);
        }
    }
    // encode the vnode type information into a bitmap
    const shapeFlag = (0, $ltDz5.isString)(type) ? 1 /* ELEMENT */  : $860eea622cdf5973$var$isSuspense(type) ? 128 /* SUSPENSE */  : $860eea622cdf5973$var$isTeleport(type) ? 64 /* TELEPORT */  : (0, $ltDz5.isObject)(type) ? 4 /* STATEFUL_COMPONENT */  : (0, $ltDz5.isFunction)(type) ? 2 /* FUNCTIONAL_COMPONENT */  : 0;
    return $860eea622cdf5973$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $860eea622cdf5973$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $uDJ7A.isProxy)(props) || $860eea622cdf5973$var$InternalObjectKey in props ? (0, $ltDz5.extend)({}, props) : props;
}
function $860eea622cdf5973$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    // This is intentionally NOT using spread or extend to avoid the runtime
    // key enumeration cost.
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $860eea622cdf5973$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $860eea622cdf5973$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $ltDz5.isArray)(ref) ? ref.concat($860eea622cdf5973$var$normalizeRef(extraProps)) : [
            ref,
            $860eea622cdf5973$var$normalizeRef(extraProps)
        ] : $860eea622cdf5973$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $860eea622cdf5973$export$ffb0004e005737fa ? patchFlag === -1 // hoisted node
         ? 16 /* FULL_PROPS */  : patchFlag | 16 /* FULL_PROPS */  : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $860eea622cdf5973$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $860eea622cdf5973$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor
    };
    return cloned;
}
/**
 * Dev only, for HMR of hoisted vnodes reused in v-for
 * https://github.com/vitejs/vite/issues/2022
 */ function $860eea622cdf5973$var$deepCloneVNode(vnode) {
    const cloned = $860eea622cdf5973$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $ltDz5.isArray)(vnode.children)) cloned.children = vnode.children.map($860eea622cdf5973$var$deepCloneVNode);
    return cloned;
}
/**
 * @private
 */ function $860eea622cdf5973$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$5f1af8db9871e1d6, null, text, flag);
}
/**
 * @private
 */ function $860eea622cdf5973$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    // A static vnode can contain multiple stringified elements, and the number
    // of elements is necessary for hydration.
    const vnode = $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
 * @private
 */ function $860eea622cdf5973$export$49553837c7236d3c(text = "", // when used as the v-else branch, the comment node must be created as a
// block to ensure correct updates.
asBlock = false) {
    return asBlock ? ($860eea622cdf5973$export$e7eaa45e502fe5cc(), $860eea622cdf5973$export$9f2dfe8048dfb22b($860eea622cdf5973$export$4d299b491347818a, null, text)) : $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$4d299b491347818a, null, text);
}
function $860eea622cdf5973$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") // empty placeholder
    return $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$4d299b491347818a);
    else if ((0, $ltDz5.isArray)(child)) // fragment
    return $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") // already vnode, this should be the most common since compiled templates
    // always produce all-vnode children arrays
    return $860eea622cdf5973$var$cloneIfMounted(child);
    else // strings and numbers
    return $860eea622cdf5973$export$bf5c4cf060303d58($860eea622cdf5973$export$5f1af8db9871e1d6, null, String(child));
}
// optimized normalization for template-compiled render fns
function $860eea622cdf5973$var$cloneIfMounted(child) {
    return child.el === null || child.memo ? child : $860eea622cdf5973$export$ee4f9e12c0a92a1a(child);
}
function $860eea622cdf5973$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $ltDz5.isArray)(children)) type = 16 /* ARRAY_CHILDREN */ ;
    else if (typeof children === "object") {
        if (shapeFlag & 65 /* TELEPORT */ ) {
            // Normalize slot to plain children for plain element and Teleport
            const slot = children.default;
            if (slot) {
                // _c marker is added by withCtx() indicating this is a compiled slot
                slot._c && (slot._d = false);
                $860eea622cdf5973$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32 /* SLOTS_CHILDREN */ ;
            const slotFlag = children._;
            if (!slotFlag && !($860eea622cdf5973$var$InternalObjectKey in children)) children._ctx = $860eea622cdf5973$var$currentRenderingInstance;
            else if (slotFlag === 3 /* FORWARDED */  && $860eea622cdf5973$var$currentRenderingInstance) {
                // a child component receives forwarded slots from the parent.
                // its slot type is determined by its parent's slot type.
                if ($860eea622cdf5973$var$currentRenderingInstance.slots._ === 1 /* STABLE */ ) children._ = 1 /* STABLE */ ;
                else {
                    children._ = 2 /* DYNAMIC */ ;
                    vnode.patchFlag |= 1024 /* DYNAMIC_SLOTS */ ;
                }
            }
        }
    } else if ((0, $ltDz5.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $860eea622cdf5973$var$currentRenderingInstance
        };
        type = 32 /* SLOTS_CHILDREN */ ;
    } else {
        children = String(children);
        // force teleport children to array so it can be moved around
        if (shapeFlag & 64 /* TELEPORT */ ) {
            type = 16 /* ARRAY_CHILDREN */ ;
            children = [
                $860eea622cdf5973$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8 /* TEXT_CHILDREN */ ;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $860eea622cdf5973$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $ltDz5.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $ltDz5.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $ltDz5.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $ltDz5.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $860eea622cdf5973$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $860eea622cdf5973$export$dae85862a8d94378(hook, instance, 7 /* VNODE_HOOK */ , [
        vnode,
        prevVNode
    ]);
}
const $860eea622cdf5973$var$emptyAppContext = $860eea622cdf5973$var$createAppContext();
let $860eea622cdf5973$var$uid$1 = 0;
function $860eea622cdf5973$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    // inherit parent app context - or - if root, adopt from root vnode
    const appContext = (parent ? parent.appContext : vnode.appContext) || $860eea622cdf5973$var$emptyAppContext;
    const instance = {
        uid: $860eea622cdf5973$var$uid$1++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        scope: new (0, $uDJ7A.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $860eea622cdf5973$var$normalizePropsOptions(type, appContext),
        emitsOptions: $860eea622cdf5973$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        emitted: null,
        // props default value
        propsDefaults: (0, $ltDz5.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $ltDz5.EMPTY_OBJ),
        data: (0, $ltDz5.EMPTY_OBJ),
        props: (0, $ltDz5.EMPTY_OBJ),
        attrs: (0, $ltDz5.EMPTY_OBJ),
        slots: (0, $ltDz5.EMPTY_OBJ),
        refs: (0, $ltDz5.EMPTY_OBJ),
        setupState: (0, $ltDz5.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $860eea622cdf5973$var$emit$1.bind(null, instance);
    // apply custom element special handling
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $860eea622cdf5973$var$currentInstance = null;
const $860eea622cdf5973$export$f13e630aa3915748 = ()=>$860eea622cdf5973$var$currentInstance || $860eea622cdf5973$var$currentRenderingInstance;
const $860eea622cdf5973$var$setCurrentInstance = (instance)=>{
    $860eea622cdf5973$var$currentInstance = instance;
    instance.scope.on();
};
const $860eea622cdf5973$var$unsetCurrentInstance = ()=>{
    $860eea622cdf5973$var$currentInstance && $860eea622cdf5973$var$currentInstance.scope.off();
    $860eea622cdf5973$var$currentInstance = null;
};
const $860eea622cdf5973$var$isBuiltInTag = /*#__PURE__*/ (0, $ltDz5.makeMap)("slot,component");
function $860eea622cdf5973$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $ltDz5.NO);
    if ($860eea622cdf5973$var$isBuiltInTag(name) || appIsNativeTag(name)) $860eea622cdf5973$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $860eea622cdf5973$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */ ;
}
let $860eea622cdf5973$var$isInSSRComponentSetup = false;
function $860eea622cdf5973$var$setupComponent(instance, isSSR = false) {
    $860eea622cdf5973$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $860eea622cdf5973$var$isStatefulComponent(instance);
    $860eea622cdf5973$var$initProps(instance, props, isStateful, isSSR);
    $860eea622cdf5973$var$initSlots(instance, children);
    const setupResult = isStateful ? $860eea622cdf5973$var$setupStatefulComponent(instance, isSSR) : undefined;
    $860eea622cdf5973$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $860eea622cdf5973$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    // 0. create render proxy property access cache
    instance.accessCache = Object.create(null);
    // 1. create public instance / render proxy
    // also mark it raw so it's never observed
    instance.proxy = (0, $uDJ7A.markRaw)(new Proxy(instance.ctx, $860eea622cdf5973$var$PublicInstanceProxyHandlers));
    // 2. call setup()
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $860eea622cdf5973$var$createSetupContext(instance) : null;
        $860eea622cdf5973$var$setCurrentInstance(instance);
        (0, $uDJ7A.pauseTracking)();
        const setupResult = $860eea622cdf5973$export$b22fcaf88446e9bf(setup, instance, 0 /* SETUP_FUNCTION */ , [
            (0, instance.props),
            setupContext
        ]);
        (0, $uDJ7A.resetTracking)();
        $860eea622cdf5973$var$unsetCurrentInstance();
        if ((0, $ltDz5.isPromise)(setupResult)) {
            setupResult.then($860eea622cdf5973$var$unsetCurrentInstance, $860eea622cdf5973$var$unsetCurrentInstance);
            if (isSSR) // return the promise so server-renderer can wait on it
            return setupResult.then((resolvedResult)=>{
                $860eea622cdf5973$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $860eea622cdf5973$export$d3da1ecaf1206c58(e, instance, 0 /* SETUP_FUNCTION */ );
            });
            else // async setup returned Promise.
            // bail here and wait for re-entry.
            instance.asyncDep = setupResult;
        } else $860eea622cdf5973$var$handleSetupResult(instance, setupResult, isSSR);
    } else $860eea622cdf5973$var$finishComponentSetup(instance, isSSR);
}
function $860eea622cdf5973$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $ltDz5.isFunction)(setupResult)) {
        // setup returned an inline render function
        if (instance.type.__ssrInlineRender) // when the function's name is `ssrRender` (compiled by SFC inline mode),
        // set it as ssrRender instead.
        instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $ltDz5.isObject)(setupResult)) {
        // setup returned bindings.
        // assuming a render function compiled from template is present.
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $uDJ7A.proxyRefs)(setupResult);
    }
    $860eea622cdf5973$var$finishComponentSetup(instance, isSSR);
}
let $860eea622cdf5973$var$compile;
let $860eea622cdf5973$var$installWithProxy;
/**
 * For runtime-dom to register the compiler.
 * Note the exported method uses any to avoid d.ts relying on the compiler types.
 */ function $860eea622cdf5973$export$667bb5a67822b941(_compile) {
    $860eea622cdf5973$var$compile = _compile;
    $860eea622cdf5973$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $860eea622cdf5973$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
// dev only
const $860eea622cdf5973$export$c93a9c496c5211fa = ()=>!$860eea622cdf5973$var$compile;
function $860eea622cdf5973$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    // template / render function normalization
    // could be already set when returned from setup()
    if (!instance.render) {
        // only do on-the-fly compile if not in SSR - SSR on-the-fly compilation
        // is done by server-renderer
        if (!isSSR && $860eea622cdf5973$var$compile && !Component.render) {
            const template = Component.template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $ltDz5.extend)((0, $ltDz5.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $860eea622cdf5973$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $ltDz5.NOOP);
        // for runtime-compiled render functions using `with` blocks, the render
        // proxy used needs a different `has` handler which is more performant and
        // also only allows a whitelist of globals to fallthrough.
        if ($860eea622cdf5973$var$installWithProxy) $860eea622cdf5973$var$installWithProxy(instance);
    }
    // support for 2.x options
    if (__VUE_OPTIONS_API__ && true) {
        $860eea622cdf5973$var$setCurrentInstance(instance);
        (0, $uDJ7A.pauseTracking)();
        $860eea622cdf5973$var$applyOptions(instance);
        (0, $uDJ7A.resetTracking)();
        $860eea622cdf5973$var$unsetCurrentInstance();
    }
}
function $860eea622cdf5973$var$createAttrsProxy(instance) {
    return new Proxy(instance.attrs, {
        get (target, key) {
            (0, $uDJ7A.track)(instance, "get" /* GET */ , "$attrs");
            return target[key];
        }
    });
}
function $860eea622cdf5973$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    let attrs;
    var event, args;
    return {
        get attrs () {
            return attrs || (attrs = $860eea622cdf5973$var$createAttrsProxy(instance));
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $860eea622cdf5973$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $uDJ7A.proxyRefs)((0, $uDJ7A.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $860eea622cdf5973$var$publicPropertiesMap) return $860eea622cdf5973$var$publicPropertiesMap[key](instance);
        }
    }));
}
const $860eea622cdf5973$var$classifyRE = /(?:^|[-_])(\w)/g;
const $860eea622cdf5973$var$classify = (str)=>str.replace($860eea622cdf5973$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $860eea622cdf5973$var$getComponentName(Component, includeInferred = true) {
    return (0, $ltDz5.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
/* istanbul ignore next */ function $860eea622cdf5973$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $860eea622cdf5973$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        // try to infer the name based on reverse resolution
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $860eea622cdf5973$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $860eea622cdf5973$var$isClassComponent(value) {
    return (0, $ltDz5.isFunction)(value) && "__vccOpts" in value;
}
const $860eea622cdf5973$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    // @ts-ignore
    return (0, $uDJ7A.computed)(getterOrOptions, debugOptions, $860eea622cdf5973$var$isInSSRComponentSetup);
};
// dev only
const $860eea622cdf5973$var$warnRuntimeUsage = (method)=>$860eea622cdf5973$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside ` + `<script setup> of a single file component. Its arguments should be ` + `compiled away and passing it at runtime has no effect.`);
// implementation
function $860eea622cdf5973$export$80b33eababae110e() {
    return null;
}
// implementation
function $860eea622cdf5973$export$51ecece22fc17ddc() {
    return null;
}
/**
 * Vue `<script setup>` compiler macro for declaring a component's exposed
 * instance properties when it is accessed by a parent component via template
 * refs.
 *
 * `<script setup>` components are closed by default - i.e. variables inside
 * the `<script setup>` scope is not exposed to parent unless explicitly exposed
 * via `defineExpose`.
 *
 * This is only usable inside `<script setup>`, is compiled away in the
 * output and should **not** be actually called at runtime.
 */ function $860eea622cdf5973$export$da25b65ca24b518a(exposed) {}
/**
 * Vue `<script setup>` compiler macro for providing props default values when
 * using type-based `defineProps` declaration.
 *
 * Example usage:
 * ```ts
 * withDefaults(defineProps<{
 *   size?: number
 *   labels?: string[]
 * }>(), {
 *   size: 3,
 *   labels: () => ['default label']
 * })
 * ```
 *
 * This is only usable inside `<script setup>`, is compiled away in the output
 * and should **not** be actually called at runtime.
 */ function $860eea622cdf5973$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $860eea622cdf5973$export$9203a8e84125433c() {
    return $860eea622cdf5973$var$getContext().slots;
}
function $860eea622cdf5973$export$75e29435042cd2ea() {
    return $860eea622cdf5973$var$getContext().attrs;
}
function $860eea622cdf5973$var$getContext() {
    const i = $860eea622cdf5973$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $860eea622cdf5973$var$createSetupContext(i));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $860eea622cdf5973$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = (0, $ltDz5.isArray)(raw) ? raw.reduce((normalized, p)=>(normalized[p] = {}, normalized), {}) : raw;
    for(const key in defaults){
        const opt = props[key];
        if (opt) {
            if ((0, $ltDz5.isArray)(opt) || (0, $ltDz5.isFunction)(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
    }
    return props;
}
/**
 * Used to create a proxy for the rest element when destructuring props with
 * defineProps().
 * @internal
 */ function $860eea622cdf5973$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
/**
 * `<script setup>` helper for persisting the current instance context over
 * async/await flows.
 *
 * `@vue/compiler-sfc` converts the following:
 *
 * ```ts
 * const x = await foo()
 * ```
 *
 * into:
 *
 * ```ts
 * let __temp, __restore
 * const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
 * ```
 * @internal
 */ function $860eea622cdf5973$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $860eea622cdf5973$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $860eea622cdf5973$var$unsetCurrentInstance();
    if ((0, $ltDz5.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $860eea622cdf5973$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$860eea622cdf5973$var$setCurrentInstance(ctx)
    ];
}
// Actual implementation
function $860eea622cdf5973$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $ltDz5.isObject)(propsOrChildren) && !(0, $ltDz5.isArray)(propsOrChildren)) {
            // single vnode without props
            if ($860eea622cdf5973$export$3868d13f8734ae81(propsOrChildren)) return $860eea622cdf5973$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            // props without children
            return $860eea622cdf5973$export$bf5c4cf060303d58(type, propsOrChildren);
        } else // omit props
        return $860eea622cdf5973$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $860eea622cdf5973$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $860eea622cdf5973$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $860eea622cdf5973$export$f2549a27e18acf2d = Symbol(``);
const $860eea622cdf5973$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $860eea622cdf5973$export$a976684a0efeb93f($860eea622cdf5973$export$f2549a27e18acf2d);
        if (!ctx) $860eea622cdf5973$export$c106dd0671a0fc2d(`Server rendering context not provided. Make sure to only call ` + `useSSRContext() conditionally in the server build.`);
        return ctx;
    }
};
function $860eea622cdf5973$var$isShallow(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */ ]);
}
function $860eea622cdf5973$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $uDJ7A.toRaw)(instance.props)));
        if (instance.setupState !== (0, $ltDz5.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $ltDz5.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $uDJ7A.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $ltDz5.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $ltDz5.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $uDJ7A.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $ltDz5.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $ltDz5.isArray)(opts) && opts.includes(key) || (0, $ltDz5.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($860eea622cdf5973$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $860eea622cdf5973$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $860eea622cdf5973$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    // shallow clone
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $860eea622cdf5973$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $ltDz5.hasChanged)(prev[i], memo[i])) return false;
    }
    // make sure to let parent block track it when returning cached
    if ($860eea622cdf5973$var$isBlockTreeEnabled > 0 && $860eea622cdf5973$var$currentBlock) $860eea622cdf5973$var$currentBlock.push(cached);
    return true;
}
// Core API ------------------------------------------------------------------
const $860eea622cdf5973$export$83d89fbfd8236492 = "3.2.37";
const $860eea622cdf5973$var$_ssrUtils = {
    createComponentInstance: $860eea622cdf5973$var$createComponentInstance,
    setupComponent: $860eea622cdf5973$var$setupComponent,
    renderComponentRoot: $860eea622cdf5973$var$renderComponentRoot,
    setCurrentRenderingInstance: $860eea622cdf5973$var$setCurrentRenderingInstance,
    isVNode: $860eea622cdf5973$export$3868d13f8734ae81,
    normalizeVNode: $860eea622cdf5973$var$normalizeVNode
};
/**
 * SSR utils for \@vue/server-renderer. Only exposed in ssr-possible builds.
 * @internal
 */ const $860eea622cdf5973$export$a9679033567b336d = $860eea622cdf5973$var$_ssrUtils;
/**
 * @internal only exposed in compat builds
 */ const $860eea622cdf5973$export$83cf26e06ea620e1 = null;
/**
 * @internal only exposed in compat builds.
 */ const $860eea622cdf5973$export$dc678eddf276286e = null;

});
parcelRegister("uDJ7A", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $05c19e5d4ccaf4e7$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $05c19e5d4ccaf4e7$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $05c19e5d4ccaf4e7$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $05c19e5d4ccaf4e7$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $05c19e5d4ccaf4e7$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $05c19e5d4ccaf4e7$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isRef", () => $05c19e5d4ccaf4e7$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $05c19e5d4ccaf4e7$export$90a44edba14e47be);
$parcel$export(module.exports, "isShallow", () => $05c19e5d4ccaf4e7$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "shallowReactive", () => $05c19e5d4ccaf4e7$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $05c19e5d4ccaf4e7$export$352205f445242f02);
$parcel$export(module.exports, "isProxy", () => $05c19e5d4ccaf4e7$export$5f3ca29d057519b3);
$parcel$export(module.exports, "markRaw", () => $05c19e5d4ccaf4e7$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $05c19e5d4ccaf4e7$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "proxyRefs", () => $05c19e5d4ccaf4e7$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "computed", () => $05c19e5d4ccaf4e7$export$2983e091f1a1e8e2);

var $ltDz5 = parcelRequire("ltDz5");
function $05c19e5d4ccaf4e7$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $05c19e5d4ccaf4e7$var$activeEffectScope;
class $05c19e5d4ccaf4e7$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        /**
         * @internal
         */ this.active = true;
        /**
         * @internal
         */ this.effects = [];
        /**
         * @internal
         */ this.cleanups = [];
        if (!detached && $05c19e5d4ccaf4e7$var$activeEffectScope) {
            this.parent = $05c19e5d4ccaf4e7$var$activeEffectScope;
            this.index = ($05c19e5d4ccaf4e7$var$activeEffectScope.scopes || ($05c19e5d4ccaf4e7$var$activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    run(fn) {
        if (this.active) {
            const currentEffectScope = $05c19e5d4ccaf4e7$var$activeEffectScope;
            try {
                $05c19e5d4ccaf4e7$var$activeEffectScope = this;
                return fn();
            } finally{
                $05c19e5d4ccaf4e7$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ on() {
        $05c19e5d4ccaf4e7$var$activeEffectScope = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ off() {
        $05c19e5d4ccaf4e7$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this.active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            // nested scope, dereference from parent to avoid memory leaks
            if (this.parent && !fromParent) {
                // optimized O(1) removal
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.active = false;
        }
    }
}
function $05c19e5d4ccaf4e7$export$7056603ea81600be(detached) {
    return new $05c19e5d4ccaf4e7$export$1168ed9dbc71ddbd(detached);
}
function $05c19e5d4ccaf4e7$var$recordEffectScope(effect, scope = $05c19e5d4ccaf4e7$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $05c19e5d4ccaf4e7$export$c7be4b0125a10cba() {
    return $05c19e5d4ccaf4e7$var$activeEffectScope;
}
function $05c19e5d4ccaf4e7$export$a780418acd4762da(fn) {
    if ($05c19e5d4ccaf4e7$var$activeEffectScope) $05c19e5d4ccaf4e7$var$activeEffectScope.cleanups.push(fn);
}
const $05c19e5d4ccaf4e7$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $05c19e5d4ccaf4e7$var$wasTracked = (dep)=>(dep.w & $05c19e5d4ccaf4e7$var$trackOpBit) > 0;
const $05c19e5d4ccaf4e7$var$newTracked = (dep)=>(dep.n & $05c19e5d4ccaf4e7$var$trackOpBit) > 0;
const $05c19e5d4ccaf4e7$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $05c19e5d4ccaf4e7$var$trackOpBit; // set was tracked
};
const $05c19e5d4ccaf4e7$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($05c19e5d4ccaf4e7$var$wasTracked(dep) && !$05c19e5d4ccaf4e7$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            // clear bits
            dep.w &= ~$05c19e5d4ccaf4e7$var$trackOpBit;
            dep.n &= ~$05c19e5d4ccaf4e7$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $05c19e5d4ccaf4e7$var$targetMap = new WeakMap();
// The number of effects currently being tracked recursively.
let $05c19e5d4ccaf4e7$var$effectTrackDepth = 0;
let $05c19e5d4ccaf4e7$var$trackOpBit = 1;
/**
 * The bitwise track markers support at most 30 levels of recursion.
 * This value is chosen to enable modern JS engines to use a SMI on all platforms.
 * When recursion depth is greater, fall back to using a full cleanup.
 */ const $05c19e5d4ccaf4e7$var$maxMarkerBits = 30;
let $05c19e5d4ccaf4e7$var$activeEffect;
const $05c19e5d4ccaf4e7$export$3c41b1a4e06acc14 = Symbol("");
const $05c19e5d4ccaf4e7$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $05c19e5d4ccaf4e7$export$28352bb4dd362521 {
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = undefined;
        $05c19e5d4ccaf4e7$var$recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) return this.fn();
        let parent = $05c19e5d4ccaf4e7$var$activeEffect;
        let lastShouldTrack = $05c19e5d4ccaf4e7$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $05c19e5d4ccaf4e7$var$activeEffect;
            $05c19e5d4ccaf4e7$var$activeEffect = this;
            $05c19e5d4ccaf4e7$var$shouldTrack = true;
            $05c19e5d4ccaf4e7$var$trackOpBit = 1 << ++$05c19e5d4ccaf4e7$var$effectTrackDepth;
            if ($05c19e5d4ccaf4e7$var$effectTrackDepth <= $05c19e5d4ccaf4e7$var$maxMarkerBits) $05c19e5d4ccaf4e7$var$initDepMarkers(this);
            else $05c19e5d4ccaf4e7$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($05c19e5d4ccaf4e7$var$effectTrackDepth <= $05c19e5d4ccaf4e7$var$maxMarkerBits) $05c19e5d4ccaf4e7$var$finalizeDepMarkers(this);
            $05c19e5d4ccaf4e7$var$trackOpBit = 1 << --$05c19e5d4ccaf4e7$var$effectTrackDepth;
            $05c19e5d4ccaf4e7$var$activeEffect = this.parent;
            $05c19e5d4ccaf4e7$var$shouldTrack = lastShouldTrack;
            this.parent = undefined;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        // stopped while running itself - defer the cleanup
        if ($05c19e5d4ccaf4e7$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $05c19e5d4ccaf4e7$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
}
function $05c19e5d4ccaf4e7$var$cleanupEffect(effect) {
    const { deps: deps } = effect;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect);
        deps.length = 0;
    }
}
function $05c19e5d4ccaf4e7$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $05c19e5d4ccaf4e7$export$28352bb4dd362521(fn);
    if (options) {
        (0, $ltDz5.extend)(_effect, options);
        if (options.scope) $05c19e5d4ccaf4e7$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $05c19e5d4ccaf4e7$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $05c19e5d4ccaf4e7$var$shouldTrack = true;
const $05c19e5d4ccaf4e7$var$trackStack = [];
function $05c19e5d4ccaf4e7$export$938a971395fef855() {
    $05c19e5d4ccaf4e7$var$trackStack.push($05c19e5d4ccaf4e7$var$shouldTrack);
    $05c19e5d4ccaf4e7$var$shouldTrack = false;
}
function $05c19e5d4ccaf4e7$export$1f8ffc6fd33b1d16() {
    $05c19e5d4ccaf4e7$var$trackStack.push($05c19e5d4ccaf4e7$var$shouldTrack);
    $05c19e5d4ccaf4e7$var$shouldTrack = true;
}
function $05c19e5d4ccaf4e7$export$c39176b1babaa8b8() {
    const last = $05c19e5d4ccaf4e7$var$trackStack.pop();
    $05c19e5d4ccaf4e7$var$shouldTrack = last === undefined ? true : last;
}
function $05c19e5d4ccaf4e7$export$6b2a7d5132615086(target, type, key) {
    if ($05c19e5d4ccaf4e7$var$shouldTrack && $05c19e5d4ccaf4e7$var$activeEffect) {
        let depsMap = $05c19e5d4ccaf4e7$var$targetMap.get(target);
        if (!depsMap) $05c19e5d4ccaf4e7$var$targetMap.set(target, depsMap = new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $05c19e5d4ccaf4e7$var$createDep());
        const eventInfo = undefined;
        $05c19e5d4ccaf4e7$var$trackEffects(dep, eventInfo);
    }
}
function $05c19e5d4ccaf4e7$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack = false;
    if ($05c19e5d4ccaf4e7$var$effectTrackDepth <= $05c19e5d4ccaf4e7$var$maxMarkerBits) {
        if (!$05c19e5d4ccaf4e7$var$newTracked(dep)) {
            dep.n |= $05c19e5d4ccaf4e7$var$trackOpBit; // set newly tracked
            shouldTrack = !$05c19e5d4ccaf4e7$var$wasTracked(dep);
        }
    } else // Full cleanup mode.
    shouldTrack = !dep.has($05c19e5d4ccaf4e7$var$activeEffect);
    if (shouldTrack) {
        dep.add($05c19e5d4ccaf4e7$var$activeEffect);
        $05c19e5d4ccaf4e7$var$activeEffect.deps.push(dep);
    }
}
function $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $05c19e5d4ccaf4e7$var$targetMap.get(target);
    if (!depsMap) // never been tracked
    return;
    let deps = [];
    if (type === "clear" /* CLEAR */ ) // collection being cleared
    // trigger all effects for target
    deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $ltDz5.isArray)(target)) depsMap.forEach((dep, key)=>{
        if (key === "length" || key >= newValue) deps.push(dep);
    });
    else {
        // schedule runs for SET | ADD | DELETE
        if (key !== void 0) deps.push(depsMap.get(key));
        // also run for iteration key on ADD | DELETE | Map.SET
        switch(type){
            case "add" /* ADD */ :
                if (!(0, $ltDz5.isArray)(target)) {
                    deps.push(depsMap.get($05c19e5d4ccaf4e7$export$3c41b1a4e06acc14));
                    if ((0, $ltDz5.isMap)(target)) deps.push(depsMap.get($05c19e5d4ccaf4e7$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $ltDz5.isIntegerKey)(key)) // new index added to array -> length changes
                deps.push(depsMap.get("length"));
                break;
            case "delete" /* DELETE */ :
                if (!(0, $ltDz5.isArray)(target)) {
                    deps.push(depsMap.get($05c19e5d4ccaf4e7$export$3c41b1a4e06acc14));
                    if ((0, $ltDz5.isMap)(target)) deps.push(depsMap.get($05c19e5d4ccaf4e7$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set" /* SET */ :
                if ((0, $ltDz5.isMap)(target)) deps.push(depsMap.get($05c19e5d4ccaf4e7$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = undefined;
    if (deps.length === 1) {
        if (deps[0]) $05c19e5d4ccaf4e7$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $05c19e5d4ccaf4e7$var$triggerEffects($05c19e5d4ccaf4e7$var$createDep(effects));
    }
}
function $05c19e5d4ccaf4e7$var$triggerEffects(dep, debuggerEventExtraInfo) {
    // spread into array for stabilization
    const effects = (0, $ltDz5.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect of effects)if (effect.computed) $05c19e5d4ccaf4e7$var$triggerEffect(effect, debuggerEventExtraInfo);
    for (const effect of effects)if (!effect.computed) $05c19e5d4ccaf4e7$var$triggerEffect(effect, debuggerEventExtraInfo);
}
function $05c19e5d4ccaf4e7$var$triggerEffect(effect, debuggerEventExtraInfo) {
    if (effect !== $05c19e5d4ccaf4e7$var$activeEffect || effect.allowRecurse) {
        if (effect.scheduler) effect.scheduler();
        else effect.run();
    }
}
const $05c19e5d4ccaf4e7$var$isNonTrackableKeys = /*#__PURE__*/ (0, $ltDz5.makeMap)(`__proto__,__v_isRef,__isVue`);
const $05c19e5d4ccaf4e7$var$builtInSymbols = new Set(/*#__PURE__*/ Object.getOwnPropertyNames(Symbol)// ios10.x Object.getOwnPropertyNames(Symbol) can enumerate 'arguments' and 'caller'
// but accessing them on Symbol leads to TypeError because Symbol is a strict mode
// function
.filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $ltDz5.isSymbol)));
const $05c19e5d4ccaf4e7$var$get = /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createGetter();
const $05c19e5d4ccaf4e7$var$shallowGet = /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createGetter(false, true);
const $05c19e5d4ccaf4e7$var$readonlyGet = /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createGetter(true);
const $05c19e5d4ccaf4e7$var$shallowReadonlyGet = /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createGetter(true, true);
const $05c19e5d4ccaf4e7$var$arrayInstrumentations = /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createArrayInstrumentations();
function $05c19e5d4ccaf4e7$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$05c19e5d4ccaf4e7$export$6b2a7d5132615086(arr, "get" /* GET */ , i + "");
            // we run the method using the original args first (which may be reactive)
            const res = arr[key](...args);
            if (res === -1 || res === false) // if that didn't work, run it again using raw values.
            return arr[key](...args.map($05c19e5d4ccaf4e7$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $05c19e5d4ccaf4e7$export$938a971395fef855();
            const res = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $05c19e5d4ccaf4e7$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $05c19e5d4ccaf4e7$var$createGetter(isReadonly = false, shallow = false) {
    return function get(target, key, receiver) {
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_isShallow" /* IS_SHALLOW */ ) return shallow;
        else if (key === "__v_raw" /* RAW */  && receiver === (isReadonly ? shallow ? $05c19e5d4ccaf4e7$var$shallowReadonlyMap : $05c19e5d4ccaf4e7$var$readonlyMap : shallow ? $05c19e5d4ccaf4e7$var$shallowReactiveMap : $05c19e5d4ccaf4e7$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $ltDz5.isArray)(target);
        if (!isReadonly && targetIsArray && (0, $ltDz5.hasOwn)($05c19e5d4ccaf4e7$var$arrayInstrumentations, key)) return Reflect.get($05c19e5d4ccaf4e7$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ((0, $ltDz5.isSymbol)(key) ? $05c19e5d4ccaf4e7$var$builtInSymbols.has(key) : $05c19e5d4ccaf4e7$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $05c19e5d4ccaf4e7$export$6b2a7d5132615086(target, "get" /* GET */ , key);
        if (shallow) return res;
        if ($05c19e5d4ccaf4e7$export$4f9f5282de18fc69(res)) // ref unwrapping - skip unwrap for Array + integer key.
        return targetIsArray && (0, $ltDz5.isIntegerKey)(key) ? res : res.value;
        if ((0, $ltDz5.isObject)(res)) // Convert returned value into a proxy as well. we do the isObject check
        // here to avoid invalid value warning. Also need to lazy access readonly
        // and reactive here to avoid circular dependency.
        return isReadonly ? $05c19e5d4ccaf4e7$export$6ec456bd5b7b3c51(res) : $05c19e5d4ccaf4e7$export$90a44edba14e47be(res);
        return res;
    };
}
const $05c19e5d4ccaf4e7$var$set = /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createSetter();
const $05c19e5d4ccaf4e7$var$shallowSet = /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createSetter(true);
function $05c19e5d4ccaf4e7$var$createSetter(shallow = false) {
    return function set(target, key, value, receiver) {
        let oldValue = target[key];
        if ($05c19e5d4ccaf4e7$export$92d09b48637741e7(oldValue) && $05c19e5d4ccaf4e7$export$4f9f5282de18fc69(oldValue) && !$05c19e5d4ccaf4e7$export$4f9f5282de18fc69(value)) return false;
        if (!shallow && !$05c19e5d4ccaf4e7$export$92d09b48637741e7(value)) {
            if (!$05c19e5d4ccaf4e7$export$7f3fe6025abfa26e(value)) {
                value = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(value);
                oldValue = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(oldValue);
            }
            if (!(0, $ltDz5.isArray)(target) && $05c19e5d4ccaf4e7$export$4f9f5282de18fc69(oldValue) && !$05c19e5d4ccaf4e7$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $ltDz5.isArray)(target) && (0, $ltDz5.isIntegerKey)(key) ? Number(key) < target.length : (0, $ltDz5.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        // don't trigger if target is something up in the prototype chain of original
        if (target === $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "add" /* ADD */ , key, value);
            else if ((0, $ltDz5.hasChanged)(value, oldValue)) $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "set" /* SET */ , key, value, oldValue);
        }
        return result;
    };
}
function $05c19e5d4ccaf4e7$var$deleteProperty(target, key) {
    const hadKey = (0, $ltDz5.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function $05c19e5d4ccaf4e7$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $ltDz5.isSymbol)(key) || !$05c19e5d4ccaf4e7$var$builtInSymbols.has(key)) $05c19e5d4ccaf4e7$export$6b2a7d5132615086(target, "has" /* HAS */ , key);
    return result;
}
function $05c19e5d4ccaf4e7$var$ownKeys(target) {
    $05c19e5d4ccaf4e7$export$6b2a7d5132615086(target, "iterate" /* ITERATE */ , (0, $ltDz5.isArray)(target) ? "length" : $05c19e5d4ccaf4e7$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $05c19e5d4ccaf4e7$var$mutableHandlers = {
    get: $05c19e5d4ccaf4e7$var$get,
    set: $05c19e5d4ccaf4e7$var$set,
    deleteProperty: $05c19e5d4ccaf4e7$var$deleteProperty,
    has: $05c19e5d4ccaf4e7$var$has,
    ownKeys: $05c19e5d4ccaf4e7$var$ownKeys
};
const $05c19e5d4ccaf4e7$var$readonlyHandlers = {
    get: $05c19e5d4ccaf4e7$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $05c19e5d4ccaf4e7$var$shallowReactiveHandlers = /*#__PURE__*/ (0, $ltDz5.extend)({}, $05c19e5d4ccaf4e7$var$mutableHandlers, {
    get: $05c19e5d4ccaf4e7$var$shallowGet,
    set: $05c19e5d4ccaf4e7$var$shallowSet
});
// Props handlers are special in the sense that it should not unwrap top-level
// refs (in order to allow refs to be explicitly passed down), but should
// retain the reactivity of the normal readonly object.
const $05c19e5d4ccaf4e7$var$shallowReadonlyHandlers = /*#__PURE__*/ (0, $ltDz5.extend)({}, $05c19e5d4ccaf4e7$var$readonlyHandlers, {
    get: $05c19e5d4ccaf4e7$var$shallowReadonlyGet
});
const $05c19e5d4ccaf4e7$var$toShallow = (value)=>value;
const $05c19e5d4ccaf4e7$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $05c19e5d4ccaf4e7$var$get$1(target, key, isReadonly = false, isShallow = false) {
    // #1772: readonly(reactive(Map)) should return readonly + reactive version
    // of the value
    target = target["__v_raw" /* RAW */ ];
    const rawTarget = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(target);
    const rawKey = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $05c19e5d4ccaf4e7$export$6b2a7d5132615086(rawTarget, "get" /* GET */ , key);
        $05c19e5d4ccaf4e7$export$6b2a7d5132615086(rawTarget, "get" /* GET */ , rawKey);
    }
    const { has: has } = $05c19e5d4ccaf4e7$var$getProto(rawTarget);
    const wrap = isShallow ? $05c19e5d4ccaf4e7$var$toShallow : isReadonly ? $05c19e5d4ccaf4e7$var$toReadonly : $05c19e5d4ccaf4e7$var$toReactive;
    if (has.call(rawTarget, key)) return wrap(target.get(key));
    else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) // #3602 readonly(reactive(Map))
    // ensure that the nested reactive `Map` can do tracking for itself
    target.get(key);
}
function $05c19e5d4ccaf4e7$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw" /* RAW */ ];
    const rawTarget = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(target);
    const rawKey = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $05c19e5d4ccaf4e7$export$6b2a7d5132615086(rawTarget, "has" /* HAS */ , key);
        $05c19e5d4ccaf4e7$export$6b2a7d5132615086(rawTarget, "has" /* HAS */ , rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $05c19e5d4ccaf4e7$var$size(target, isReadonly = false) {
    target = target["__v_raw" /* RAW */ ];
    !isReadonly && $05c19e5d4ccaf4e7$export$6b2a7d5132615086($05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(target), "iterate" /* ITERATE */ , $05c19e5d4ccaf4e7$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $05c19e5d4ccaf4e7$var$add(value) {
    value = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(value);
    const target = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this);
    const proto = $05c19e5d4ccaf4e7$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "add" /* ADD */ , value, value);
    }
    return this;
}
function $05c19e5d4ccaf4e7$var$set$1(key, value) {
    value = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(value);
    const target = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $05c19e5d4ccaf4e7$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get.call(target, key);
    target.set(key, value);
    if (!hadKey) $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "add" /* ADD */ , key, value);
    else if ((0, $ltDz5.hasChanged)(value, oldValue)) $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "set" /* SET */ , key, value, oldValue);
    return this;
}
function $05c19e5d4ccaf4e7$var$deleteEntry(key) {
    const target = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $05c19e5d4ccaf4e7$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get ? get.call(target, key) : undefined;
    // forward the operation before queueing reactions
    const result = target.delete(key);
    if (hadKey) $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "delete" /* DELETE */ , key, undefined, oldValue);
    return result;
}
function $05c19e5d4ccaf4e7$var$clear() {
    const target = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = undefined;
    // forward the operation before queueing reactions
    const result = target.clear();
    if (hadItems) $05c19e5d4ccaf4e7$export$e614dc9140f7ae71(target, "clear" /* CLEAR */ , undefined, undefined, oldTarget);
    return result;
}
function $05c19e5d4ccaf4e7$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw" /* RAW */ ];
        const rawTarget = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $05c19e5d4ccaf4e7$var$toShallow : isReadonly ? $05c19e5d4ccaf4e7$var$toReadonly : $05c19e5d4ccaf4e7$var$toReactive;
        !isReadonly && $05c19e5d4ccaf4e7$export$6b2a7d5132615086(rawTarget, "iterate" /* ITERATE */ , $05c19e5d4ccaf4e7$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            // important: make sure the callback is
            // 1. invoked with the reactive map as `this` and 3rd arg
            // 2. the value received should be a corresponding reactive/readonly.
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $05c19e5d4ccaf4e7$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw" /* RAW */ ];
        const rawTarget = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $ltDz5.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $05c19e5d4ccaf4e7$var$toShallow : isReadonly ? $05c19e5d4ccaf4e7$var$toReadonly : $05c19e5d4ccaf4e7$var$toReactive;
        !isReadonly && $05c19e5d4ccaf4e7$export$6b2a7d5132615086(rawTarget, "iterate" /* ITERATE */ , isKeyOnly ? $05c19e5d4ccaf4e7$var$MAP_KEY_ITERATE_KEY : $05c19e5d4ccaf4e7$export$3c41b1a4e06acc14);
        // return a wrapped iterator which returns observed versions of the
        // values emitted from the real iterator
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $05c19e5d4ccaf4e7$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" /* DELETE */  ? false : this;
    };
}
function $05c19e5d4ccaf4e7$var$createInstrumentations() {
    const mutableInstrumentations = {
        get (key) {
            return $05c19e5d4ccaf4e7$var$get$1(this, key);
        },
        get size () {
            return $05c19e5d4ccaf4e7$var$size(this);
        },
        has: $05c19e5d4ccaf4e7$var$has$1,
        add: $05c19e5d4ccaf4e7$var$add,
        set: $05c19e5d4ccaf4e7$var$set$1,
        delete: $05c19e5d4ccaf4e7$var$deleteEntry,
        clear: $05c19e5d4ccaf4e7$var$clear,
        forEach: $05c19e5d4ccaf4e7$var$createForEach(false, false)
    };
    const shallowInstrumentations = {
        get (key) {
            return $05c19e5d4ccaf4e7$var$get$1(this, key, false, true);
        },
        get size () {
            return $05c19e5d4ccaf4e7$var$size(this);
        },
        has: $05c19e5d4ccaf4e7$var$has$1,
        add: $05c19e5d4ccaf4e7$var$add,
        set: $05c19e5d4ccaf4e7$var$set$1,
        delete: $05c19e5d4ccaf4e7$var$deleteEntry,
        clear: $05c19e5d4ccaf4e7$var$clear,
        forEach: $05c19e5d4ccaf4e7$var$createForEach(false, true)
    };
    const readonlyInstrumentations = {
        get (key) {
            return $05c19e5d4ccaf4e7$var$get$1(this, key, true);
        },
        get size () {
            return $05c19e5d4ccaf4e7$var$size(this, true);
        },
        has (key) {
            return $05c19e5d4ccaf4e7$var$has$1.call(this, key, true);
        },
        add: $05c19e5d4ccaf4e7$var$createReadonlyMethod("add" /* ADD */ ),
        set: $05c19e5d4ccaf4e7$var$createReadonlyMethod("set" /* SET */ ),
        delete: $05c19e5d4ccaf4e7$var$createReadonlyMethod("delete" /* DELETE */ ),
        clear: $05c19e5d4ccaf4e7$var$createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: $05c19e5d4ccaf4e7$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations = {
        get (key) {
            return $05c19e5d4ccaf4e7$var$get$1(this, key, true, true);
        },
        get size () {
            return $05c19e5d4ccaf4e7$var$size(this, true);
        },
        has (key) {
            return $05c19e5d4ccaf4e7$var$has$1.call(this, key, true);
        },
        add: $05c19e5d4ccaf4e7$var$createReadonlyMethod("add" /* ADD */ ),
        set: $05c19e5d4ccaf4e7$var$createReadonlyMethod("set" /* SET */ ),
        delete: $05c19e5d4ccaf4e7$var$createReadonlyMethod("delete" /* DELETE */ ),
        clear: $05c19e5d4ccaf4e7$var$createReadonlyMethod("clear" /* CLEAR */ ),
        forEach: $05c19e5d4ccaf4e7$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations[method] = $05c19e5d4ccaf4e7$var$createIterableMethod(method, false, false);
        readonlyInstrumentations[method] = $05c19e5d4ccaf4e7$var$createIterableMethod(method, true, false);
        shallowInstrumentations[method] = $05c19e5d4ccaf4e7$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations[method] = $05c19e5d4ccaf4e7$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations
    ];
}
const [$05c19e5d4ccaf4e7$var$mutableInstrumentations, $05c19e5d4ccaf4e7$var$readonlyInstrumentations, $05c19e5d4ccaf4e7$var$shallowInstrumentations, $05c19e5d4ccaf4e7$var$shallowReadonlyInstrumentations] = /* #__PURE__*/ $05c19e5d4ccaf4e7$var$createInstrumentations();
function $05c19e5d4ccaf4e7$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $05c19e5d4ccaf4e7$var$shallowReadonlyInstrumentations : $05c19e5d4ccaf4e7$var$shallowInstrumentations : isReadonly ? $05c19e5d4ccaf4e7$var$readonlyInstrumentations : $05c19e5d4ccaf4e7$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive" /* IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* IS_READONLY */ ) return isReadonly;
        else if (key === "__v_raw" /* RAW */ ) return target;
        return Reflect.get((0, $ltDz5.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $05c19e5d4ccaf4e7$var$mutableCollectionHandlers = {
    get: /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createInstrumentationGetter(false, false)
};
const $05c19e5d4ccaf4e7$var$shallowCollectionHandlers = {
    get: /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createInstrumentationGetter(false, true)
};
const $05c19e5d4ccaf4e7$var$readonlyCollectionHandlers = {
    get: /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createInstrumentationGetter(true, false)
};
const $05c19e5d4ccaf4e7$var$shallowReadonlyCollectionHandlers = {
    get: /*#__PURE__*/ $05c19e5d4ccaf4e7$var$createInstrumentationGetter(true, true)
};
function $05c19e5d4ccaf4e7$var$checkIdentityKeys(target, has, key) {
    const rawKey = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $ltDz5.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive ` + `versions of the same object${type === `Map` ? ` as keys` : ``}, ` + `which can lead to inconsistencies. ` + `Avoid differentiating between the raw and reactive versions ` + `of an object and only use the reactive version if possible.`);
    }
}
const $05c19e5d4ccaf4e7$var$reactiveMap = new WeakMap();
const $05c19e5d4ccaf4e7$var$shallowReactiveMap = new WeakMap();
const $05c19e5d4ccaf4e7$var$readonlyMap = new WeakMap();
const $05c19e5d4ccaf4e7$var$shallowReadonlyMap = new WeakMap();
function $05c19e5d4ccaf4e7$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $05c19e5d4ccaf4e7$var$getTargetType(value) {
    return value["__v_skip" /* SKIP */ ] || !Object.isExtensible(value) ? 0 /* INVALID */  : $05c19e5d4ccaf4e7$var$targetTypeMap((0, $ltDz5.toRawType)(value));
}
function $05c19e5d4ccaf4e7$export$90a44edba14e47be(target) {
    // if trying to observe a readonly proxy, return the readonly version.
    if ($05c19e5d4ccaf4e7$export$92d09b48637741e7(target)) return target;
    return $05c19e5d4ccaf4e7$var$createReactiveObject(target, false, $05c19e5d4ccaf4e7$var$mutableHandlers, $05c19e5d4ccaf4e7$var$mutableCollectionHandlers, $05c19e5d4ccaf4e7$var$reactiveMap);
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function $05c19e5d4ccaf4e7$export$8d81cefd22d22260(target) {
    return $05c19e5d4ccaf4e7$var$createReactiveObject(target, false, $05c19e5d4ccaf4e7$var$shallowReactiveHandlers, $05c19e5d4ccaf4e7$var$shallowCollectionHandlers, $05c19e5d4ccaf4e7$var$shallowReactiveMap);
}
/**
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */ function $05c19e5d4ccaf4e7$export$6ec456bd5b7b3c51(target) {
    return $05c19e5d4ccaf4e7$var$createReactiveObject(target, true, $05c19e5d4ccaf4e7$var$readonlyHandlers, $05c19e5d4ccaf4e7$var$readonlyCollectionHandlers, $05c19e5d4ccaf4e7$var$readonlyMap);
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function $05c19e5d4ccaf4e7$export$7c4b5f2b50f09f6b(target) {
    return $05c19e5d4ccaf4e7$var$createReactiveObject(target, true, $05c19e5d4ccaf4e7$var$shallowReadonlyHandlers, $05c19e5d4ccaf4e7$var$shallowReadonlyCollectionHandlers, $05c19e5d4ccaf4e7$var$shallowReadonlyMap);
}
function $05c19e5d4ccaf4e7$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $ltDz5.isObject)(target)) return target;
    // target is already a Proxy, return it.
    // exception: calling readonly() on a reactive object
    if (target["__v_raw" /* RAW */ ] && !(isReadonly && target["__v_isReactive" /* IS_REACTIVE */ ])) return target;
    // target already has corresponding Proxy
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    // only specific value types can be observed.
    const targetType = $05c19e5d4ccaf4e7$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $05c19e5d4ccaf4e7$export$352205f445242f02(value) {
    if ($05c19e5d4ccaf4e7$export$92d09b48637741e7(value)) return $05c19e5d4ccaf4e7$export$352205f445242f02(value["__v_raw" /* RAW */ ]);
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */ ]);
}
function $05c19e5d4ccaf4e7$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */ ]);
}
function $05c19e5d4ccaf4e7$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */ ]);
}
function $05c19e5d4ccaf4e7$export$5f3ca29d057519b3(value) {
    return $05c19e5d4ccaf4e7$export$352205f445242f02(value) || $05c19e5d4ccaf4e7$export$92d09b48637741e7(value);
}
function $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw" /* RAW */ ];
    return raw ? $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(raw) : observed;
}
function $05c19e5d4ccaf4e7$export$995ab8b13ad7a9d0(value) {
    (0, $ltDz5.def)(value, "__v_skip" /* SKIP */ , true);
    return value;
}
const $05c19e5d4ccaf4e7$var$toReactive = (value)=>(0, $ltDz5.isObject)(value) ? $05c19e5d4ccaf4e7$export$90a44edba14e47be(value) : value;
const $05c19e5d4ccaf4e7$var$toReadonly = (value)=>(0, $ltDz5.isObject)(value) ? $05c19e5d4ccaf4e7$export$6ec456bd5b7b3c51(value) : value;
function $05c19e5d4ccaf4e7$var$trackRefValue(ref) {
    if ($05c19e5d4ccaf4e7$var$shouldTrack && $05c19e5d4ccaf4e7$var$activeEffect) {
        ref = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(ref);
        $05c19e5d4ccaf4e7$var$trackEffects(ref.dep || (ref.dep = $05c19e5d4ccaf4e7$var$createDep()));
    }
}
function $05c19e5d4ccaf4e7$var$triggerRefValue(ref, newVal) {
    ref = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(ref);
    if (ref.dep) $05c19e5d4ccaf4e7$var$triggerEffects(ref.dep);
}
function $05c19e5d4ccaf4e7$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $05c19e5d4ccaf4e7$export$eff4d24c3ff7876e(value) {
    return $05c19e5d4ccaf4e7$var$createRef(value, false);
}
function $05c19e5d4ccaf4e7$export$9b7bc5fe3b17c8b3(value) {
    return $05c19e5d4ccaf4e7$var$createRef(value, true);
}
function $05c19e5d4ccaf4e7$var$createRef(rawValue, shallow) {
    if ($05c19e5d4ccaf4e7$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $05c19e5d4ccaf4e7$var$RefImpl(rawValue, shallow);
}
class $05c19e5d4ccaf4e7$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = undefined;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $05c19e5d4ccaf4e7$var$toReactive(value);
    }
    get value() {
        $05c19e5d4ccaf4e7$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        newVal = this.__v_isShallow ? newVal : $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(newVal);
        if ((0, $ltDz5.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = this.__v_isShallow ? newVal : $05c19e5d4ccaf4e7$var$toReactive(newVal);
            $05c19e5d4ccaf4e7$var$triggerRefValue(this, newVal);
        }
    }
}
function $05c19e5d4ccaf4e7$export$f402f86588575ccc(ref) {
    $05c19e5d4ccaf4e7$var$triggerRefValue(ref, void 0);
}
function $05c19e5d4ccaf4e7$export$a239a76781616204(ref) {
    return $05c19e5d4ccaf4e7$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
const $05c19e5d4ccaf4e7$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$05c19e5d4ccaf4e7$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($05c19e5d4ccaf4e7$export$4f9f5282de18fc69(oldValue) && !$05c19e5d4ccaf4e7$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $05c19e5d4ccaf4e7$export$f353fd1b97db3fa0(objectWithRefs) {
    return $05c19e5d4ccaf4e7$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $05c19e5d4ccaf4e7$var$shallowUnwrapHandlers);
}
class $05c19e5d4ccaf4e7$var$CustomRefImpl {
    constructor(factory){
        this.dep = undefined;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$05c19e5d4ccaf4e7$var$trackRefValue(this), ()=>$05c19e5d4ccaf4e7$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $05c19e5d4ccaf4e7$export$a20c2dd6199824cb(factory) {
    return new $05c19e5d4ccaf4e7$var$CustomRefImpl(factory);
}
function $05c19e5d4ccaf4e7$export$2e9533675e5e70e0(object) {
    const ret = (0, $ltDz5.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $05c19e5d4ccaf4e7$export$1f60508e4f47b4b7(object, key);
    return ret;
}
class $05c19e5d4ccaf4e7$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === undefined ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
}
function $05c19e5d4ccaf4e7$export$1f60508e4f47b4b7(object, key, defaultValue) {
    const val = object[key];
    return $05c19e5d4ccaf4e7$export$4f9f5282de18fc69(val) ? val : new $05c19e5d4ccaf4e7$var$ObjectRefImpl(object, key, defaultValue);
}
class $05c19e5d4ccaf4e7$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = undefined;
        this.__v_isRef = true;
        this._dirty = true;
        this.effect = new $05c19e5d4ccaf4e7$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $05c19e5d4ccaf4e7$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly" /* IS_READONLY */ ] = isReadonly;
    }
    get value() {
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        const self = $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this);
        $05c19e5d4ccaf4e7$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function $05c19e5d4ccaf4e7$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $ltDz5.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $ltDz5.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $05c19e5d4ccaf4e7$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
var $05c19e5d4ccaf4e7$var$_a;
const $05c19e5d4ccaf4e7$var$tick = /*#__PURE__*/ Promise.resolve();
const $05c19e5d4ccaf4e7$var$queue = [];
let $05c19e5d4ccaf4e7$var$queued = false;
const $05c19e5d4ccaf4e7$var$scheduler = (fn)=>{
    $05c19e5d4ccaf4e7$var$queue.push(fn);
    if (!$05c19e5d4ccaf4e7$var$queued) {
        $05c19e5d4ccaf4e7$var$queued = true;
        $05c19e5d4ccaf4e7$var$tick.then($05c19e5d4ccaf4e7$var$flush);
    }
};
const $05c19e5d4ccaf4e7$var$flush = ()=>{
    for(let i = 0; i < $05c19e5d4ccaf4e7$var$queue.length; i++)$05c19e5d4ccaf4e7$var$queue[i]();
    $05c19e5d4ccaf4e7$var$queue.length = 0;
    $05c19e5d4ccaf4e7$var$queued = false;
};
class $05c19e5d4ccaf4e7$var$DeferredComputedRefImpl {
    constructor(getter){
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this[$05c19e5d4ccaf4e7$var$_a] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $05c19e5d4ccaf4e7$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $05c19e5d4ccaf4e7$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $05c19e5d4ccaf4e7$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                // chained upstream computeds are notified synchronously to ensure
                // value invalidation in case of sync access; normal effects are
                // deferred to be triggered in scheduler.
                for (const e of this.dep)if (e.computed instanceof $05c19e5d4ccaf4e7$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $05c19e5d4ccaf4e7$var$trackRefValue(this);
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        return $05c19e5d4ccaf4e7$export$ab18938b9fc5f28e(this)._get();
    }
}
$05c19e5d4ccaf4e7$var$_a = "__v_isReadonly" /* IS_READONLY */ ;
function $05c19e5d4ccaf4e7$export$483264c4ec4c46ce(getter) {
    return new $05c19e5d4ccaf4e7$var$DeferredComputedRefImpl(getter);
}

});
parcelRegister("ltDz5", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $fa2aff2a06ef91e2$export$b41394a5437791c8);
$parcel$export(module.exports, "isGloballyWhitelisted", () => $fa2aff2a06ef91e2$export$d6571a1911e4f27e);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $fa2aff2a06ef91e2$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $fa2aff2a06ef91e2$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "normalizeStyle", () => $fa2aff2a06ef91e2$export$8756898546458274);
$parcel$export(module.exports, "isArray", () => $fa2aff2a06ef91e2$export$43bee75e5e14138e);
$parcel$export(module.exports, "isString", () => $fa2aff2a06ef91e2$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $fa2aff2a06ef91e2$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "hyphenate", () => $fa2aff2a06ef91e2$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "normalizeClass", () => $fa2aff2a06ef91e2$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $fa2aff2a06ef91e2$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $fa2aff2a06ef91e2$export$6328ce7565ea1049);
$parcel$export(module.exports, "looseEqual", () => $fa2aff2a06ef91e2$export$ae8015769846262c);
$parcel$export(module.exports, "isSymbol", () => $fa2aff2a06ef91e2$export$a244864fd9645c7f);
$parcel$export(module.exports, "looseIndexOf", () => $fa2aff2a06ef91e2$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $fa2aff2a06ef91e2$export$b5b1545233b45293);
$parcel$export(module.exports, "isFunction", () => $fa2aff2a06ef91e2$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isMap", () => $fa2aff2a06ef91e2$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $fa2aff2a06ef91e2$export$6750766a7c7ec627);
$parcel$export(module.exports, "isPlainObject", () => $fa2aff2a06ef91e2$export$53b83ca8eaab0383);
$parcel$export(module.exports, "EMPTY_OBJ", () => $fa2aff2a06ef91e2$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $fa2aff2a06ef91e2$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $fa2aff2a06ef91e2$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $fa2aff2a06ef91e2$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $fa2aff2a06ef91e2$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $fa2aff2a06ef91e2$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $fa2aff2a06ef91e2$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $fa2aff2a06ef91e2$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $fa2aff2a06ef91e2$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isPromise", () => $fa2aff2a06ef91e2$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $fa2aff2a06ef91e2$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isIntegerKey", () => $fa2aff2a06ef91e2$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $fa2aff2a06ef91e2$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $fa2aff2a06ef91e2$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $fa2aff2a06ef91e2$export$161d051f5dd25de7);
$parcel$export(module.exports, "capitalize", () => $fa2aff2a06ef91e2$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $fa2aff2a06ef91e2$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $fa2aff2a06ef91e2$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $fa2aff2a06ef91e2$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $fa2aff2a06ef91e2$export$8afb76124cf08683);
$parcel$export(module.exports, "toNumber", () => $fa2aff2a06ef91e2$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $fa2aff2a06ef91e2$export$ff5f2eeb11fc7e14);
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ function $fa2aff2a06ef91e2$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
/**
 * dev only flag -> name mapping
 */ const $fa2aff2a06ef91e2$export$def7dc2c2e95a08a = {
    [1 /* TEXT */ ]: `TEXT`,
    [2 /* CLASS */ ]: `CLASS`,
    [4 /* STYLE */ ]: `STYLE`,
    [8 /* PROPS */ ]: `PROPS`,
    [16 /* FULL_PROPS */ ]: `FULL_PROPS`,
    [32 /* HYDRATE_EVENTS */ ]: `HYDRATE_EVENTS`,
    [64 /* STABLE_FRAGMENT */ ]: `STABLE_FRAGMENT`,
    [128 /* KEYED_FRAGMENT */ ]: `KEYED_FRAGMENT`,
    [256 /* UNKEYED_FRAGMENT */ ]: `UNKEYED_FRAGMENT`,
    [512 /* NEED_PATCH */ ]: `NEED_PATCH`,
    [1024 /* DYNAMIC_SLOTS */ ]: `DYNAMIC_SLOTS`,
    [2048 /* DEV_ROOT_FRAGMENT */ ]: `DEV_ROOT_FRAGMENT`,
    [-1 /* HOISTED */ ]: `HOISTED`,
    [-2 /* BAIL */ ]: `BAIL`
};
/**
 * Dev only
 */ const $fa2aff2a06ef91e2$export$624972196ed3745f = {
    [1 /* STABLE */ ]: "STABLE",
    [2 /* DYNAMIC */ ]: "DYNAMIC",
    [3 /* FORWARDED */ ]: "FORWARDED"
};
const $fa2aff2a06ef91e2$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
const $fa2aff2a06ef91e2$export$d6571a1911e4f27e = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8($fa2aff2a06ef91e2$var$GLOBALS_WHITE_LISTED);
const $fa2aff2a06ef91e2$var$range = 2;
function $fa2aff2a06ef91e2$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $fa2aff2a06ef91e2$var$range; j <= i + $fa2aff2a06ef91e2$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ const $fa2aff2a06ef91e2$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $fa2aff2a06ef91e2$export$d186f5eb2e810715 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8($fa2aff2a06ef91e2$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ const $fa2aff2a06ef91e2$export$f763ba3b84e9cd8c = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8($fa2aff2a06ef91e2$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` + `loop,open,required,reversed,scoped,seamless,` + `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */ function $fa2aff2a06ef91e2$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $fa2aff2a06ef91e2$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $fa2aff2a06ef91e2$var$attrValidationCache = {};
function $fa2aff2a06ef91e2$export$d55ef77660f30d12(name) {
    if ($fa2aff2a06ef91e2$var$attrValidationCache.hasOwnProperty(name)) return $fa2aff2a06ef91e2$var$attrValidationCache[name];
    const isUnsafe = $fa2aff2a06ef91e2$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $fa2aff2a06ef91e2$var$attrValidationCache[name] = !isUnsafe;
}
const $fa2aff2a06ef91e2$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
 * CSS properties that accept plain numbers
 */ const $fa2aff2a06ef91e2$export$84da53524c6b1314 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8(`animation-iteration-count,border-image-outset,border-image-slice,` + `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` + `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` + `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` + `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` + `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` + // SVG
`fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` + `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ const $fa2aff2a06ef91e2$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,` + `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` + `border,buffered,capture,challenge,charset,checked,cite,class,code,` + `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` + `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` + `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` + `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` + `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` + `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` + `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` + `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` + `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` + `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` + `start,step,style,summary,tabindex,target,title,translate,type,usemap,` + `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ const $fa2aff2a06ef91e2$export$80da416f43933831 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` + `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` + `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` + `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` + `color-interpolation-filters,color-profile,color-rendering,` + `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` + `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` + `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` + `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` + `font-family,font-size,font-size-adjust,font-stretch,font-style,` + `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` + `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` + `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` + `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` + `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` + `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` + `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` + `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` + `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` + `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` + `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` + `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` + `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` + `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` + `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` + `specularConstant,specularExponent,speed,spreadMethod,startOffset,` + `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` + `strikethrough-position,strikethrough-thickness,string,stroke,` + `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` + `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` + `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` + `text-decoration,text-rendering,textLength,to,transform,transform-origin,` + `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` + `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` + `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` + `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` + `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` + `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` + `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $fa2aff2a06ef91e2$export$8756898546458274(value) {
    if ($fa2aff2a06ef91e2$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $fa2aff2a06ef91e2$export$844ec244b1367d54(item) ? $fa2aff2a06ef91e2$export$76a205ce979d066a(item) : $fa2aff2a06ef91e2$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($fa2aff2a06ef91e2$export$844ec244b1367d54(value)) return value;
    else if ($fa2aff2a06ef91e2$export$a6cdc56e425d0d0a(value)) return value;
}
const $fa2aff2a06ef91e2$var$listDelimiterRE = /;(?![^(]*\))/g;
const $fa2aff2a06ef91e2$var$propertyDelimiterRE = /:(.+)/;
function $fa2aff2a06ef91e2$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.split($fa2aff2a06ef91e2$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($fa2aff2a06ef91e2$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $fa2aff2a06ef91e2$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $fa2aff2a06ef91e2$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $fa2aff2a06ef91e2$export$6e6a0a3676c4b8bb(key);
        if ($fa2aff2a06ef91e2$export$844ec244b1367d54(value) || typeof value === "number" && $fa2aff2a06ef91e2$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $fa2aff2a06ef91e2$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($fa2aff2a06ef91e2$export$844ec244b1367d54(value)) res = value;
    else if ($fa2aff2a06ef91e2$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $fa2aff2a06ef91e2$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($fa2aff2a06ef91e2$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $fa2aff2a06ef91e2$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$fa2aff2a06ef91e2$export$844ec244b1367d54(klass)) props.class = $fa2aff2a06ef91e2$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $fa2aff2a06ef91e2$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $fa2aff2a06ef91e2$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const $fa2aff2a06ef91e2$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $fa2aff2a06ef91e2$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $fa2aff2a06ef91e2$export$1ccf854a0984f890 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8($fa2aff2a06ef91e2$var$HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $fa2aff2a06ef91e2$export$6328ce7565ea1049 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8($fa2aff2a06ef91e2$var$SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $fa2aff2a06ef91e2$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8($fa2aff2a06ef91e2$var$VOID_TAGS);
const $fa2aff2a06ef91e2$var$escapeRE = /["'&<>]/;
function $fa2aff2a06ef91e2$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $fa2aff2a06ef91e2$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const $fa2aff2a06ef91e2$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $fa2aff2a06ef91e2$export$7b105034a53bde5f(src) {
    return src.replace($fa2aff2a06ef91e2$var$commentStripRE, "");
}
function $fa2aff2a06ef91e2$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $fa2aff2a06ef91e2$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $fa2aff2a06ef91e2$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $fa2aff2a06ef91e2$export$871608497c498473(a);
    let bValidType = $fa2aff2a06ef91e2$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $fa2aff2a06ef91e2$export$a244864fd9645c7f(a);
    bValidType = $fa2aff2a06ef91e2$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $fa2aff2a06ef91e2$export$43bee75e5e14138e(a);
    bValidType = $fa2aff2a06ef91e2$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $fa2aff2a06ef91e2$var$looseCompareArrays(a, b) : false;
    aValidType = $fa2aff2a06ef91e2$export$a6cdc56e425d0d0a(a);
    bValidType = $fa2aff2a06ef91e2$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$fa2aff2a06ef91e2$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $fa2aff2a06ef91e2$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$fa2aff2a06ef91e2$export$ae8015769846262c(item, val));
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ const $fa2aff2a06ef91e2$export$b5b1545233b45293 = (val)=>{
    return $fa2aff2a06ef91e2$export$844ec244b1367d54(val) ? val : val == null ? "" : $fa2aff2a06ef91e2$export$43bee75e5e14138e(val) || $fa2aff2a06ef91e2$export$a6cdc56e425d0d0a(val) && (val.toString === $fa2aff2a06ef91e2$export$830c053460e5ddf6 || !$fa2aff2a06ef91e2$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $fa2aff2a06ef91e2$var$replacer, 2) : String(val);
};
const $fa2aff2a06ef91e2$var$replacer = (_key, val)=>{
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $fa2aff2a06ef91e2$var$replacer(_key, val.value);
    else if ($fa2aff2a06ef91e2$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val])=>{
            entries[`${key} =>`] = val;
            return entries;
        }, {})
    };
    else if ($fa2aff2a06ef91e2$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($fa2aff2a06ef91e2$export$a6cdc56e425d0d0a(val) && !$fa2aff2a06ef91e2$export$43bee75e5e14138e(val) && !$fa2aff2a06ef91e2$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $fa2aff2a06ef91e2$export$cf583d23ab39677c = {};
const $fa2aff2a06ef91e2$export$6bd8558f433f1cc1 = [];
const $fa2aff2a06ef91e2$export$5702a91a6f42969f = ()=>{};
/**
 * Always return false.
 */ const $fa2aff2a06ef91e2$export$c01351c0af048e39 = ()=>false;
const $fa2aff2a06ef91e2$var$onRE = /^on[^a-z]/;
const $fa2aff2a06ef91e2$export$1a2d97de39ecbb75 = (key)=>$fa2aff2a06ef91e2$var$onRE.test(key);
const $fa2aff2a06ef91e2$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $fa2aff2a06ef91e2$export$8b58be045bf06082 = Object.assign;
const $fa2aff2a06ef91e2$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $fa2aff2a06ef91e2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $fa2aff2a06ef91e2$export$b5a638e9b3fff9f3 = (val, key)=>$fa2aff2a06ef91e2$var$hasOwnProperty.call(val, key);
const $fa2aff2a06ef91e2$export$43bee75e5e14138e = Array.isArray;
const $fa2aff2a06ef91e2$export$5c90113a285f2241 = (val)=>$fa2aff2a06ef91e2$export$1dccc787cc36538b(val) === "[object Map]";
const $fa2aff2a06ef91e2$export$6750766a7c7ec627 = (val)=>$fa2aff2a06ef91e2$export$1dccc787cc36538b(val) === "[object Set]";
const $fa2aff2a06ef91e2$export$871608497c498473 = (val)=>$fa2aff2a06ef91e2$export$1dccc787cc36538b(val) === "[object Date]";
const $fa2aff2a06ef91e2$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $fa2aff2a06ef91e2$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $fa2aff2a06ef91e2$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $fa2aff2a06ef91e2$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $fa2aff2a06ef91e2$export$4369c812aac99591 = (val)=>{
    return $fa2aff2a06ef91e2$export$a6cdc56e425d0d0a(val) && $fa2aff2a06ef91e2$export$f6e2535fb5126e54(val.then) && $fa2aff2a06ef91e2$export$f6e2535fb5126e54(val.catch);
};
const $fa2aff2a06ef91e2$export$830c053460e5ddf6 = Object.prototype.toString;
const $fa2aff2a06ef91e2$export$1dccc787cc36538b = (value)=>$fa2aff2a06ef91e2$export$830c053460e5ddf6.call(value);
const $fa2aff2a06ef91e2$export$5ad0a3c360b8fbb5 = (value)=>{
    // extract "RawType" from strings like "[object RawType]"
    return $fa2aff2a06ef91e2$export$1dccc787cc36538b(value).slice(8, -1);
};
const $fa2aff2a06ef91e2$export$53b83ca8eaab0383 = (val)=>$fa2aff2a06ef91e2$export$1dccc787cc36538b(val) === "[object Object]";
const $fa2aff2a06ef91e2$export$e2a2b93446ec9fe = (key)=>$fa2aff2a06ef91e2$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $fa2aff2a06ef91e2$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $fa2aff2a06ef91e2$export$a9c1fdb3030c2a6b = /*#__PURE__*/ $fa2aff2a06ef91e2$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $fa2aff2a06ef91e2$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $fa2aff2a06ef91e2$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $fa2aff2a06ef91e2$export$161d051f5dd25de7 = $fa2aff2a06ef91e2$var$cacheStringFunction((str)=>{
    return str.replace($fa2aff2a06ef91e2$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $fa2aff2a06ef91e2$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ const $fa2aff2a06ef91e2$export$6e6a0a3676c4b8bb = $fa2aff2a06ef91e2$var$cacheStringFunction((str)=>str.replace($fa2aff2a06ef91e2$var$hyphenateRE, "-$1").toLowerCase());
/**
 * @private
 */ const $fa2aff2a06ef91e2$export$9a00dee1beb8f576 = $fa2aff2a06ef91e2$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */ const $fa2aff2a06ef91e2$export$8c022799eeaaefcd = $fa2aff2a06ef91e2$var$cacheStringFunction((str)=>str ? `on${$fa2aff2a06ef91e2$export$9a00dee1beb8f576(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const $fa2aff2a06ef91e2$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $fa2aff2a06ef91e2$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $fa2aff2a06ef91e2$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $fa2aff2a06ef91e2$export$a0a81dc3380ce7d3 = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let $fa2aff2a06ef91e2$var$_globalThis;
const $fa2aff2a06ef91e2$export$ff5f2eeb11fc7e14 = ()=>{
    return $fa2aff2a06ef91e2$var$_globalThis || ($fa2aff2a06ef91e2$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $fa2aff2a06ef91e2$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $fa2aff2a06ef91e2$export$53d5e12f9a1d3cde(name) {
    return $fa2aff2a06ef91e2$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}

});






parcelRegister("3f06B", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c2dac3d8c67e65$export$2e2bcd8739ae039);
let $25c2dac3d8c67e65$var$NOOP = ()=>{};
var $25c2dac3d8c67e65$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8vTj4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $632c1eb9876b0be5$export$2e2bcd8739ae039);

var $3I1WV = parcelRequire("3I1WV");

var $bpzxk = parcelRequire("bpzxk");
let $632c1eb9876b0be5$var$options = {
    includeScore: true,
    threshold: 0.2,
    includeMatches: true,
    distance: 100,
    keys: [
        "make",
        "range",
        "model",
        "year",
        "condition"
    ]
};
var // Vue Search
$632c1eb9876b0be5$export$2e2bcd8739ae039 = {
    name: "VueWooSearch",
    data () {
        return {
            store: $3I1WV.store,
            searchQuery: "",
            searchIsLoading: true,
            allAttributes: [],
            searchResults: [],
            filteredSearchResults: [],
            shopURL: wp_field_vars.wc_shop_url,
            fuse: new (0, $bpzxk.default)([], $632c1eb9876b0be5$var$options)
        };
    },
    methods: {
        fetchData: function() {
            fetch(`/wp-json/goeuro/v1/products`).then((response)=>response.json()).then((response)=>{
                this.searchIsLoading = false;
                const data = response;
                data.map((item)=>{
                    this.searchResults.push(item);
                });
                this.fuse.setCollection(this.searchResults);
            });
        },
        filterSearchResults: function(e) {
            searchQuery = e.target.value;
            let filterQuery = this.fuse.search(searchQuery);
            this.filteredSearchResults = filterQuery;
        },
        clearSearchQuery: function(id) {
            this.searchQuery = null;
            this.filteredSearchResults = [];
        }
    },
    mounted () {
        this.fetchData();
    }
};

});
parcelRegister("3I1WV", function(module, exports) {

$parcel$export(module.exports, "store", () => $2b36fe41c7ae1d47$export$6f57813fe9f31bf9);
parcelRequire("ey4ci");
var $uDJ7A = parcelRequire("uDJ7A");
const $2b36fe41c7ae1d47$export$6f57813fe9f31bf9 = (0, $uDJ7A.reactive)({
    allProducts: []
});

});

parcelRegister("bpzxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0224dd4ba904099a$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $0224dd4ba904099a$var$isArray(value) {
    return !Array.isArray ? $0224dd4ba904099a$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $0224dd4ba904099a$var$INFINITY = 1 / 0;
function $0224dd4ba904099a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$0224dd4ba904099a$var$INFINITY ? "-0" : result;
}
function $0224dd4ba904099a$var$toString(value) {
    return value == null ? "" : $0224dd4ba904099a$var$baseToString(value);
}
function $0224dd4ba904099a$var$isString(value) {
    return typeof value === "string";
}
function $0224dd4ba904099a$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $0224dd4ba904099a$var$isBoolean(value) {
    return value === true || value === false || $0224dd4ba904099a$var$isObjectLike(value) && $0224dd4ba904099a$var$getTag(value) == "[object Boolean]";
}
function $0224dd4ba904099a$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $0224dd4ba904099a$var$isObjectLike(value) {
    return $0224dd4ba904099a$var$isObject(value) && value !== null;
}
function $0224dd4ba904099a$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $0224dd4ba904099a$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $0224dd4ba904099a$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $0224dd4ba904099a$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $0224dd4ba904099a$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $0224dd4ba904099a$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $0224dd4ba904099a$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $0224dd4ba904099a$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $0224dd4ba904099a$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $0224dd4ba904099a$var$hasOwn = Object.prototype.hasOwnProperty;
class $0224dd4ba904099a$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $0224dd4ba904099a$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $0224dd4ba904099a$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($0224dd4ba904099a$var$isString(key) || $0224dd4ba904099a$var$isArray(key)) {
        src = key;
        path = $0224dd4ba904099a$var$createKeyPath(key);
        id = $0224dd4ba904099a$var$createKeyId(key);
    } else {
        if (!$0224dd4ba904099a$var$hasOwn.call(key, "name")) throw new Error($0224dd4ba904099a$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($0224dd4ba904099a$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($0224dd4ba904099a$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $0224dd4ba904099a$var$createKeyPath(name);
        id = $0224dd4ba904099a$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $0224dd4ba904099a$var$createKeyPath(key) {
    return $0224dd4ba904099a$var$isArray(key) ? key : key.split(".");
}
function $0224dd4ba904099a$var$createKeyId(key) {
    return $0224dd4ba904099a$var$isArray(key) ? key.join(".") : key;
}
function $0224dd4ba904099a$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$0224dd4ba904099a$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$0224dd4ba904099a$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($0224dd4ba904099a$var$isString(value) || $0224dd4ba904099a$var$isNumber(value) || $0224dd4ba904099a$var$isBoolean(value))) list.push($0224dd4ba904099a$var$toString(value));
            else if ($0224dd4ba904099a$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $0224dd4ba904099a$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $0224dd4ba904099a$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $0224dd4ba904099a$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $0224dd4ba904099a$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $0224dd4ba904099a$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $0224dd4ba904099a$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $0224dd4ba904099a$var$Config = {
    ...$0224dd4ba904099a$var$BasicOptions,
    ...$0224dd4ba904099a$var$MatchOptions,
    ...$0224dd4ba904099a$var$FuzzyOptions,
    ...$0224dd4ba904099a$var$AdvancedOptions
};
const $0224dd4ba904099a$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $0224dd4ba904099a$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($0224dd4ba904099a$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $0224dd4ba904099a$var$FuseIndex {
    constructor({ getFn: getFn = $0224dd4ba904099a$var$Config.getFn, fieldNormWeight: fieldNormWeight = $0224dd4ba904099a$var$Config.fieldNormWeight } = {}){
        this.norm = $0224dd4ba904099a$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($0224dd4ba904099a$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($0224dd4ba904099a$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$0224dd4ba904099a$var$isDefined(doc) || $0224dd4ba904099a$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$0224dd4ba904099a$var$isDefined(value)) return;
            if ($0224dd4ba904099a$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$0224dd4ba904099a$var$isDefined(value)) continue;
                    if ($0224dd4ba904099a$var$isString(value) && !$0224dd4ba904099a$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($0224dd4ba904099a$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($0224dd4ba904099a$var$isString(value) && !$0224dd4ba904099a$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $0224dd4ba904099a$var$createIndex(keys, docs, { getFn: getFn = $0224dd4ba904099a$var$Config.getFn, fieldNormWeight: fieldNormWeight = $0224dd4ba904099a$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $0224dd4ba904099a$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($0224dd4ba904099a$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $0224dd4ba904099a$var$parseIndex(data, { getFn: getFn = $0224dd4ba904099a$var$Config.getFn, fieldNormWeight: fieldNormWeight = $0224dd4ba904099a$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $0224dd4ba904099a$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $0224dd4ba904099a$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $0224dd4ba904099a$var$Config.distance, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $0224dd4ba904099a$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $0224dd4ba904099a$var$MAX_BITS = 32;
function $0224dd4ba904099a$var$search(text, pattern, patternAlphabet, { location: location = $0224dd4ba904099a$var$Config.location, distance: distance = $0224dd4ba904099a$var$Config.distance, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $0224dd4ba904099a$var$MAX_BITS) throw new Error($0224dd4ba904099a$var$PATTERN_LENGTH_TOO_LARGE($0224dd4ba904099a$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $0224dd4ba904099a$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $0224dd4ba904099a$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $0224dd4ba904099a$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $0224dd4ba904099a$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $0224dd4ba904099a$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $0224dd4ba904099a$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $0224dd4ba904099a$var$BitapSearch {
    constructor(pattern, { location: location = $0224dd4ba904099a$var$Config.location, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, distance: distance = $0224dd4ba904099a$var$Config.distance, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $0224dd4ba904099a$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $0224dd4ba904099a$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $0224dd4ba904099a$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $0224dd4ba904099a$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $0224dd4ba904099a$var$MAX_BITS), i);
                i += $0224dd4ba904099a$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $0224dd4ba904099a$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $0224dd4ba904099a$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $0224dd4ba904099a$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $0224dd4ba904099a$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $0224dd4ba904099a$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $0224dd4ba904099a$var$ExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $0224dd4ba904099a$var$InverseExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $0224dd4ba904099a$var$PrefixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $0224dd4ba904099a$var$InversePrefixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $0224dd4ba904099a$var$SuffixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $0224dd4ba904099a$var$InverseSuffixExactMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $0224dd4ba904099a$var$FuzzyMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern, { location: location = $0224dd4ba904099a$var$Config.location, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, distance: distance = $0224dd4ba904099a$var$Config.distance, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $0224dd4ba904099a$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $0224dd4ba904099a$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $0224dd4ba904099a$var$IncludeMatch extends $0224dd4ba904099a$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $0224dd4ba904099a$var$searchers = [
    $0224dd4ba904099a$var$ExactMatch,
    $0224dd4ba904099a$var$IncludeMatch,
    $0224dd4ba904099a$var$PrefixExactMatch,
    $0224dd4ba904099a$var$InversePrefixExactMatch,
    $0224dd4ba904099a$var$InverseSuffixExactMatch,
    $0224dd4ba904099a$var$SuffixExactMatch,
    $0224dd4ba904099a$var$InverseExactMatch,
    $0224dd4ba904099a$var$FuzzyMatch
];
const $0224dd4ba904099a$var$searchersLen = $0224dd4ba904099a$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $0224dd4ba904099a$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $0224dd4ba904099a$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $0224dd4ba904099a$var$parseQuery(pattern, options = {}) {
    return pattern.split($0224dd4ba904099a$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($0224dd4ba904099a$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $0224dd4ba904099a$var$searchersLen){
                const searcher = $0224dd4ba904099a$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $0224dd4ba904099a$var$searchersLen){
                const searcher = $0224dd4ba904099a$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $0224dd4ba904099a$var$MultiMatchSet = new Set([
    $0224dd4ba904099a$var$FuzzyMatch.type,
    $0224dd4ba904099a$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $0224dd4ba904099a$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $0224dd4ba904099a$var$Config.isCaseSensitive, includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $0224dd4ba904099a$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $0224dd4ba904099a$var$Config.ignoreLocation, findAllMatches: findAllMatches = $0224dd4ba904099a$var$Config.findAllMatches, location: location = $0224dd4ba904099a$var$Config.location, threshold: threshold = $0224dd4ba904099a$var$Config.threshold, distance: distance = $0224dd4ba904099a$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $0224dd4ba904099a$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($0224dd4ba904099a$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $0224dd4ba904099a$var$registeredSearchers = [];
function $0224dd4ba904099a$var$register(...args) {
    $0224dd4ba904099a$var$registeredSearchers.push(...args);
}
function $0224dd4ba904099a$var$createSearcher(pattern, options) {
    for(let i = 0, len = $0224dd4ba904099a$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $0224dd4ba904099a$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $0224dd4ba904099a$var$BitapSearch(pattern, options);
}
const $0224dd4ba904099a$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $0224dd4ba904099a$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $0224dd4ba904099a$var$isExpression = (query)=>!!(query[$0224dd4ba904099a$var$LogicalOperator.AND] || query[$0224dd4ba904099a$var$LogicalOperator.OR]);
const $0224dd4ba904099a$var$isPath = (query)=>!!query[$0224dd4ba904099a$var$KeyType.PATH];
const $0224dd4ba904099a$var$isLeaf = (query)=>!$0224dd4ba904099a$var$isArray(query) && $0224dd4ba904099a$var$isObject(query) && !$0224dd4ba904099a$var$isExpression(query);
const $0224dd4ba904099a$var$convertToExplicit = (query)=>({
        [$0224dd4ba904099a$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $0224dd4ba904099a$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $0224dd4ba904099a$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$0224dd4ba904099a$var$isExpression(query)) return next($0224dd4ba904099a$var$convertToExplicit(query));
        if ($0224dd4ba904099a$var$isLeaf(query)) {
            const key = isQueryPath ? query[$0224dd4ba904099a$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$0224dd4ba904099a$var$KeyType.PATTERN] : query[key];
            if (!$0224dd4ba904099a$var$isString(pattern)) throw new Error($0224dd4ba904099a$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $0224dd4ba904099a$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $0224dd4ba904099a$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($0224dd4ba904099a$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$0224dd4ba904099a$var$isExpression(query)) query = $0224dd4ba904099a$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $0224dd4ba904099a$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $0224dd4ba904099a$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $0224dd4ba904099a$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$0224dd4ba904099a$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$0224dd4ba904099a$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $0224dd4ba904099a$var$transformScore(result, data) {
    data.score = result.score;
}
function $0224dd4ba904099a$var$format(results, docs, { includeMatches: includeMatches = $0224dd4ba904099a$var$Config.includeMatches, includeScore: includeScore = $0224dd4ba904099a$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($0224dd4ba904099a$var$transformMatches);
    if (includeScore) transformers.push($0224dd4ba904099a$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $0224dd4ba904099a$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$0224dd4ba904099a$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $0224dd4ba904099a$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $0224dd4ba904099a$var$FuseIndex)) throw new Error($0224dd4ba904099a$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $0224dd4ba904099a$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$0224dd4ba904099a$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $0224dd4ba904099a$var$isString(query) ? $0224dd4ba904099a$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $0224dd4ba904099a$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($0224dd4ba904099a$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $0224dd4ba904099a$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $0224dd4ba904099a$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$0224dd4ba904099a$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $0224dd4ba904099a$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $0224dd4ba904099a$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($0224dd4ba904099a$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $0224dd4ba904099a$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$0224dd4ba904099a$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$0224dd4ba904099a$var$isDefined(value)) return [];
        let matches = [];
        if ($0224dd4ba904099a$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$0224dd4ba904099a$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$0224dd4ba904099a$export$2e2bcd8739ae039.version = "6.6.2";
$0224dd4ba904099a$export$2e2bcd8739ae039.createIndex = $0224dd4ba904099a$var$createIndex;
$0224dd4ba904099a$export$2e2bcd8739ae039.parseIndex = $0224dd4ba904099a$var$parseIndex;
$0224dd4ba904099a$export$2e2bcd8739ae039.config = $0224dd4ba904099a$var$Config;
$0224dd4ba904099a$export$2e2bcd8739ae039.parseQuery = $0224dd4ba904099a$var$parse;
$0224dd4ba904099a$var$register($0224dd4ba904099a$var$ExtendedSearch);

});


parcelRegister("hDUKP", function(module, exports) {

$parcel$export(module.exports, "render", () => $cd821a62e688bf3c$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $bvAw5 = parcelRequire("bvAw5");
var $ltDz5 = parcelRequire("ltDz5");
var $k72mp = parcelRequire("k72mp");
const $cd821a62e688bf3c$var$_hoisted_1 = {
    class: "searchDropdown-wrapper search-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_2 = [
    "action"
];
const $cd821a62e688bf3c$var$_hoisted_3 = [
    "disabled"
];
const $cd821a62e688bf3c$var$_hoisted_4 = {
    key: 0,
    class: "vue-search-loading-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_5 = {
    key: 1,
    class: "searchDropdown vertical-scroll"
};
const $cd821a62e688bf3c$var$_hoisted_6 = {
    class: "searchDropdown-list"
};
const $cd821a62e688bf3c$var$_hoisted_7 = [
    "href"
];
const $cd821a62e688bf3c$var$_hoisted_8 = {
    key: 0,
    class: "searchDropdown-list-item-image-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_9 = [
    "src",
    "alt"
];
const $cd821a62e688bf3c$var$_hoisted_10 = {
    class: "searchDropdown-list-item-content"
};
const $cd821a62e688bf3c$var$_hoisted_11 = {
    class: "searchDropdown-list-item-content-inner"
};
const $cd821a62e688bf3c$var$_hoisted_12 = {
    class: "searchDropdown-list-item-subheading"
};
const $cd821a62e688bf3c$var$_hoisted_13 = {
    key: 0,
    class: "searchDropdown-list-item-subheading-attr condition"
};
const $cd821a62e688bf3c$var$_hoisted_14 = {
    key: 1,
    class: "searchDropdown-list-item-subheading-attr"
};
const $cd821a62e688bf3c$var$_hoisted_15 = {
    class: "searchDropdown-list-item-heading"
};
const $cd821a62e688bf3c$var$_hoisted_16 = {
    key: 0
};
const $cd821a62e688bf3c$var$_hoisted_17 = {
    key: 1
};
const $cd821a62e688bf3c$var$_hoisted_18 = {
    key: 2
};
const $cd821a62e688bf3c$var$_hoisted_19 = {
    key: 3
};
const $cd821a62e688bf3c$var$_hoisted_20 = {
    class: "price-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_21 = {
    class: "price",
    "aria-hidden": "true"
};
const $cd821a62e688bf3c$var$_hoisted_22 = {
    key: 0,
    class: "sale-price"
};
const $cd821a62e688bf3c$var$_hoisted_23 = {
    key: 0,
    title: "On The Road price"
};
const $cd821a62e688bf3c$var$_hoisted_24 = {
    key: 1,
    class: "regular-price"
};
const $cd821a62e688bf3c$var$_hoisted_25 = {
    key: 0,
    title: "On The Road price"
};
const $cd821a62e688bf3c$var$_hoisted_26 = {
    key: 0,
    class: "visually-hidden"
};
const $cd821a62e688bf3c$var$_hoisted_27 = {
    key: 0,
    class: "finance-wrapper"
};
const $cd821a62e688bf3c$var$_hoisted_28 = {
    class: "finance-price"
};
const $cd821a62e688bf3c$var$_hoisted_29 = {
    key: 0,
    title: "Hire Purchase (per month)"
};
const $cd821a62e688bf3c$var$_hoisted_30 = {
    class: "visually-hidden"
};
function $cd821a62e688bf3c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("div", null, [
        (0, $bvAw5.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_1, [
            (0, $bvAw5.createElementVNode)("form", {
                id: "searchform",
                action: $data.shopURL,
                method: "get"
            }, [
                (0, $bvAw5.withDirectives)((0, $bvAw5.createElementVNode)("input", {
                    type: "search",
                    name: "s",
                    placeholder: "Search",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>this.searchQuery = $event),
                    onKeydown: _cache[1] || (_cache[1] = (0, $k72mp.withKeys)((...args)=>$options.clearSearchQuery && $options.clearSearchQuery(...args), [
                        "esc"
                    ])),
                    onKeyup: _cache[2] || (_cache[2] = (...args)=>$options.filterSearchResults && $options.filterSearchResults(...args)),
                    disabled: this.searchIsLoading,
                    autocomplete: "off"
                }, null, 40, $cd821a62e688bf3c$var$_hoisted_3), [
                    [
                        (0, $k72mp.vModelText),
                        this.searchQuery
                    ]
                ]),
                _cache[4] || (_cache[4] = (0, $bvAw5.createElementVNode)("input", {
                    type: "hidden",
                    name: "post_type",
                    value: "product"
                }, null, -1))
            ], 8, $cd821a62e688bf3c$var$_hoisted_2),
            this.searchQuery ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = (0, $k72mp.withModifiers)((...args)=>$options.clearSearchQuery && $options.clearSearchQuery(...args), [
                    "prevent"
                ])),
                class: "searchInput-icon clear unstyled-button"
            })) : (0, $bvAw5.createCommentVNode)("", true)
        ]),
        this.searchIsLoading ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("div", $cd821a62e688bf3c$var$_hoisted_4, [
            (0, $bvAw5.renderSlot)(_ctx.$slots, "default")
        ])) : (0, $bvAw5.createCommentVNode)("", true),
        $data.filteredSearchResults.length > 0 ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("div", $cd821a62e688bf3c$var$_hoisted_5, [
            (0, $bvAw5.createElementVNode)("ul", $cd821a62e688bf3c$var$_hoisted_6, [
                ((0, $bvAw5.openBlock)(true), (0, $bvAw5.createElementBlock)((0, $bvAw5.Fragment), null, (0, $bvAw5.renderList)($data.filteredSearchResults, (post, index)=>{
                    return (0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("li", {
                        class: "searchDropdown-list-item",
                        key: post.item.id
                    }, [
                        (0, $bvAw5.createElementVNode)("a", {
                            class: "searchDropdown-list-item-link",
                            href: post.item.permalink
                        }, [
                            post.item.image ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("div", $cd821a62e688bf3c$var$_hoisted_8, [
                                (0, $bvAw5.createElementVNode)("img", {
                                    loading: "lazy",
                                    class: "searchDropdown-list-item-image",
                                    src: post.item.image,
                                    width: "170",
                                    alt: post.item.name
                                }, null, 8, $cd821a62e688bf3c$var$_hoisted_9)
                            ])) : (0, $bvAw5.createCommentVNode)("", true),
                            (0, $bvAw5.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_10, [
                                (0, $bvAw5.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_11, [
                                    (0, $bvAw5.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_12, [
                                        post.item.condition.name ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("p", $cd821a62e688bf3c$var$_hoisted_13, (0, $ltDz5.toDisplayString)(post.item.condition.name + " "), 1)) : (0, $bvAw5.createCommentVNode)("", true),
                                        post.item.make ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("p", $cd821a62e688bf3c$var$_hoisted_14, (0, $ltDz5.toDisplayString)(post.item.make + " "), 1)) : (0, $bvAw5.createCommentVNode)("", true)
                                    ]),
                                    (0, $bvAw5.createElementVNode)("h3", $cd821a62e688bf3c$var$_hoisted_15, [
                                        post.item.brand ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("span", $cd821a62e688bf3c$var$_hoisted_16, (0, $ltDz5.toDisplayString)(post.item.brand + " "), 1)) : (0, $bvAw5.createCommentVNode)("", true),
                                        post.item.range ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("span", $cd821a62e688bf3c$var$_hoisted_17, (0, $ltDz5.toDisplayString)(post.item.range + " "), 1)) : (0, $bvAw5.createCommentVNode)("", true),
                                        post.item.model ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("span", $cd821a62e688bf3c$var$_hoisted_18, (0, $ltDz5.toDisplayString)(post.item.model + " "), 1)) : (0, $bvAw5.createCommentVNode)("", true),
                                        post.item.year ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("span", $cd821a62e688bf3c$var$_hoisted_19, (0, $ltDz5.toDisplayString)(post.item.year + " "), 1)) : (0, $bvAw5.createCommentVNode)("", true)
                                    ]),
                                    (0, $bvAw5.createElementVNode)("div", $cd821a62e688bf3c$var$_hoisted_20, [
                                        (0, $bvAw5.createElementVNode)("p", $cd821a62e688bf3c$var$_hoisted_21, [
                                            post.item.sale_price && post.item.regular_price ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("span", $cd821a62e688bf3c$var$_hoisted_22, [
                                                (0, $bvAw5.createElementVNode)("s", null, "Was \xa3" + (0, $ltDz5.toDisplayString)(new Intl.NumberFormat("en-GB").format(post.item.regular_price)), 1),
                                                (0, $bvAw5.createElementVNode)("strong", null, [
                                                    (0, $bvAw5.createTextVNode)(" \xa3" + (0, $ltDz5.toDisplayString)(new Intl.NumberFormat("en-GB").format(post.item.sale_price)) + " ", 1),
                                                    post.item.condition.name == "New" ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("abbr", $cd821a62e688bf3c$var$_hoisted_23, " OTR")) : (0, $bvAw5.createCommentVNode)("", true)
                                                ])
                                            ])) : (0, $bvAw5.createCommentVNode)("", true),
                                            !post.item.sale_price && post.item.regular_price > 0 ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("span", $cd821a62e688bf3c$var$_hoisted_24, [
                                                (0, $bvAw5.createElementVNode)("strong", null, [
                                                    (0, $bvAw5.createTextVNode)(" \xa3" + (0, $ltDz5.toDisplayString)(new Intl.NumberFormat("en-GB").format(post.item.price)) + " ", 1),
                                                    post.item.condition.name == "New" ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("abbr", $cd821a62e688bf3c$var$_hoisted_25, " OTR")) : (0, $bvAw5.createCommentVNode)("", true)
                                                ])
                                            ])) : (0, $bvAw5.createCommentVNode)("", true)
                                        ]),
                                        post.item.sale_price && post.item.regular_price ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("p", $cd821a62e688bf3c$var$_hoisted_26, "Was \xa3" + (0, $ltDz5.toDisplayString)(new Intl.NumberFormat("en-GB").format(post.item.regular_price)) + ", now \xa3" + (0, $ltDz5.toDisplayString)(new Intl.NumberFormat("en-GB").format(post.item.sale_price)) + " (On The Road price)", 1)) : (0, $bvAw5.createCommentVNode)("", true)
                                    ]),
                                    post.item.price_per_month ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("div", $cd821a62e688bf3c$var$_hoisted_27, [
                                        (0, $bvAw5.createElementVNode)("strong", $cd821a62e688bf3c$var$_hoisted_28, [
                                            (0, $bvAw5.createTextVNode)("\xa3" + (0, $ltDz5.toDisplayString)(new Intl.NumberFormat("en-GB").format(post.item.price_per_month)), 1),
                                            post.item.condition.name == "Used" ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("abbr", $cd821a62e688bf3c$var$_hoisted_29, " /month HP")) : (0, $bvAw5.createCommentVNode)("", true)
                                        ]),
                                        (0, $bvAw5.createElementVNode)("p", $cd821a62e688bf3c$var$_hoisted_30, "\xa3" + (0, $ltDz5.toDisplayString)(new Intl.NumberFormat("en-GB").format(post.item.price_per_month)) + " a month on hire purchase", 1)
                                    ])) : (0, $bvAw5.createCommentVNode)("", true)
                                ])
                            ])
                        ], 8, $cd821a62e688bf3c$var$_hoisted_7)
                    ]);
                }), 128))
            ])
        ])) : (0, $bvAw5.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("16hh2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cd3c039abc726c6$export$2e2bcd8739ae039);
let $0cd3c039abc726c6$var$NOOP = ()=>{};
var $0cd3c039abc726c6$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("gSRBC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c4ab457b19b2cb9b$export$2e2bcd8739ae039);

var $3I1WV = parcelRequire("3I1WV");
const $c4ab457b19b2cb9b$var$unique = (value, index, self)=>{
    return self.indexOf(value) === index;
};
var $c4ab457b19b2cb9b$export$2e2bcd8739ae039 = {
    name: "VueWooProductNavBar",
    mounted () {
        this.fetchData();
    },
    data () {
        return {
            store: $3I1WV.store,
            allProducts: [],
            productTypeCount: 0,
            productsLoading: true,
            allConditions: [],
            selectedCondition: "",
            allBerths: [],
            selectedBerths: "",
            shopURL: wp_field_vars.wc_shop_url,
            // theFormat: '', //this is meant to be a function if we do use it
            scaleClass: "",
            completed: false
        };
    },
    methods: {
        fetchData: async function() {
            const products = await fetch(`/wp-json/goeuro/v1/products?skip_cache=1`).then((response)=>response.json()).then((response)=>{
                this.productsLoading = false;
                this.productTypeCount = response.length;
                response.map((item)=>{
                    this.allProducts.push(item);
                });
            });
            this.getAllConditions();
            this.getAllBerths();
        },
        getAllConditions: function() {
            const products = this.allProducts.filter((item)=>item.condition != null);
            let conditionsArr = products.map((product)=>product.condition);
            let uniqueConditions = [];
            conditionsArr.forEach((condition)=>{
                if (!uniqueConditions.some((item)=>item.name === condition.name)) uniqueConditions.push(condition);
            });
            this.allConditions = uniqueConditions.sort((a, b)=>a.name.localeCompare(b.name));
        },
        getAllBerths: function() {
            const products = this.allProducts.filter((item)=>item.berths != "");
            let berthsArr = products.map((product)=>product.berths);
            let uniqueberths = berthsArr.filter($c4ab457b19b2cb9b$var$unique);
            this.allBerths = uniqueberths.sort((a, b)=>a - b);
        },
        handleConditionSelect: function(event) {
            this.selectedCondition = event.target.value;
            let result = this.allProducts;
            if (this.selectedCondition) result = result.filter((item)=>item.condition.slug == this.selectedCondition);
            if (this.selectedBerths) result = result.filter((item)=>item.berths == this.selectedBerths);
            this.productTypeCount = result.length;
        },
        handleBerthSelect: function(event) {
            this.selectedBerths = event.target.value;
            let result = this.allProducts;
            if (this.selectedCondition) result = result.filter((item)=>item.condition.slug == this.selectedCondition);
            if (this.selectedBerths) result = result.filter((item)=>item.berths == this.selectedBerths);
            this.productTypeCount = result.length;
        }
    }
};

});

parcelRegister("h7zDt", function(module, exports) {

$parcel$export(module.exports, "render", () => $c76ebba01291f93c$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $bvAw5 = parcelRequire("bvAw5");
var $ltDz5 = parcelRequire("ltDz5");
const $c76ebba01291f93c$var$_hoisted_1 = {
    class: "productBar-nav-wrapper"
};
const $c76ebba01291f93c$var$_hoisted_2 = [
    "action"
];
const $c76ebba01291f93c$var$_hoisted_3 = {
    class: "select-wrapper"
};
const $c76ebba01291f93c$var$_hoisted_4 = [
    "disabled"
];
const $c76ebba01291f93c$var$_hoisted_5 = [
    "value"
];
const $c76ebba01291f93c$var$_hoisted_6 = [
    "value"
];
const $c76ebba01291f93c$var$_hoisted_7 = {
    class: "select-wrapper"
};
const $c76ebba01291f93c$var$_hoisted_8 = [
    "disabled"
];
const $c76ebba01291f93c$var$_hoisted_9 = [
    "value"
];
const $c76ebba01291f93c$var$_hoisted_10 = [
    "value"
];
const $c76ebba01291f93c$var$_hoisted_11 = [
    "disabled"
];
const $c76ebba01291f93c$var$_hoisted_12 = {
    class: "tabular-nums-wrapper"
};
const $c76ebba01291f93c$var$_hoisted_13 = {
    class: "tabular-nums"
};
const $c76ebba01291f93c$var$_hoisted_14 = {
    key: 0,
    class: "loader-wrapper"
};
function $c76ebba01291f93c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_number = (0, $bvAw5.resolveComponent)("number");
    return (0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("div", $c76ebba01291f93c$var$_hoisted_1, [
        (0, $bvAw5.createElementVNode)("form", {
            method: "GET",
            action: $data.shopURL,
            class: "productBar-nav"
        }, [
            (0, $bvAw5.createElementVNode)("div", $c76ebba01291f93c$var$_hoisted_3, [
                (0, $bvAw5.createElementVNode)("select", {
                    onChange: _cache[0] || (_cache[0] = (...args)=>$options.handleConditionSelect && $options.handleConditionSelect(...args)),
                    disabled: $data.productsLoading
                }, [
                    _cache[2] || (_cache[2] = (0, $bvAw5.createElementVNode)("option", {
                        disabled: "",
                        selected: ""
                    }, "New or used?", -1)),
                    ((0, $bvAw5.openBlock)(true), (0, $bvAw5.createElementBlock)((0, $bvAw5.Fragment), null, (0, $bvAw5.renderList)($data.allConditions, (condition)=>{
                        return (0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("option", {
                            value: condition.slug
                        }, (0, $ltDz5.toDisplayString)(condition.name), 9, $c76ebba01291f93c$var$_hoisted_5);
                    }), 256))
                ], 40, $c76ebba01291f93c$var$_hoisted_4),
                (0, $bvAw5.createElementVNode)("input", {
                    hidden: "",
                    name: "_condition",
                    value: this.selectedCondition
                }, null, 8, $c76ebba01291f93c$var$_hoisted_6)
            ]),
            (0, $bvAw5.createElementVNode)("div", $c76ebba01291f93c$var$_hoisted_7, [
                (0, $bvAw5.createElementVNode)("select", {
                    onChange: _cache[1] || (_cache[1] = (...args)=>$options.handleBerthSelect && $options.handleBerthSelect(...args)),
                    disabled: $data.productsLoading
                }, [
                    _cache[3] || (_cache[3] = (0, $bvAw5.createElementVNode)("option", {
                        disabled: "",
                        selected: ""
                    }, "How many berths?", -1)),
                    ((0, $bvAw5.openBlock)(true), (0, $bvAw5.createElementBlock)((0, $bvAw5.Fragment), null, (0, $bvAw5.renderList)($data.allBerths, (berth)=>{
                        return (0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("option", {
                            value: berth
                        }, (0, $ltDz5.toDisplayString)(berth), 9, $c76ebba01291f93c$var$_hoisted_9);
                    }), 256))
                ], 40, $c76ebba01291f93c$var$_hoisted_8),
                (0, $bvAw5.createElementVNode)("input", {
                    hidden: "",
                    name: "_berths",
                    value: this.selectedBerths
                }, null, 8, $c76ebba01291f93c$var$_hoisted_10)
            ]),
            (0, $bvAw5.createElementVNode)("button", {
                type: "submit",
                class: "button primary",
                disabled: $data.productsLoading
            }, [
                (0, $bvAw5.createElementVNode)("span", $c76ebba01291f93c$var$_hoisted_12, [
                    _cache[4] || (_cache[4] = (0, $bvAw5.createTextVNode)(" View all\xa0 ")),
                    (0, $bvAw5.createElementVNode)("span", $c76ebba01291f93c$var$_hoisted_13, [
                        (0, $bvAw5.createVNode)(_component_number, {
                            ref: "number1",
                            class: (0, $ltDz5.normalizeClass)({
                                scaleBig: $data.scaleClass
                            }),
                            from: this.productTypeCount,
                            to: this.productTypeCount,
                            duration: 0.15,
                            onComplete: $data.completed
                        }, null, 8, [
                            "class",
                            "from",
                            "to",
                            "onComplete"
                        ])
                    ]),
                    _cache[5] || (_cache[5] = (0, $bvAw5.createTextVNode)(" \xa0Motorhomes "))
                ]),
                $data.productsLoading ? ((0, $bvAw5.openBlock)(), (0, $bvAw5.createElementBlock)("span", $c76ebba01291f93c$var$_hoisted_14, _cache[6] || (_cache[6] = [
                    (0, $bvAw5.createElementVNode)("span", {
                        class: "loader"
                    }, null, -1)
                ]))) : (0, $bvAw5.createCommentVNode)("", true)
            ], 8, $c76ebba01291f93c$var$_hoisted_11)
        ], 8, $c76ebba01291f93c$var$_hoisted_2)
    ]);
}

});

parcelRegister("gkOOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $be45ed9a82fcbaf8$export$2e2bcd8739ae039);
let $be45ed9a82fcbaf8$var$NOOP = ()=>{};
var $be45ed9a82fcbaf8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ey4ci");
var $k72mp = parcelRequire("k72mp");
let $fdb37e6edc8b94b1$var$script;



let $fdb37e6edc8b94b1$var$initialize = ()=>{
    $fdb37e6edc8b94b1$var$script = (parcelRequire("jHdY8"));
    if ($fdb37e6edc8b94b1$var$script.__esModule) $fdb37e6edc8b94b1$var$script = $fdb37e6edc8b94b1$var$script.default;
    $fdb37e6edc8b94b1$var$script.render = (parcelRequire("g7H9T")).render;
    (parcelRequire("3f06B")).default($fdb37e6edc8b94b1$var$script);
    $fdb37e6edc8b94b1$var$script.__scopeId = "data-v-628f7c";
    $fdb37e6edc8b94b1$var$script.__file = "Number.vue";
};
$fdb37e6edc8b94b1$var$initialize();
var $fdb37e6edc8b94b1$export$2e2bcd8739ae039 = $fdb37e6edc8b94b1$var$script;


const $a5f084e3f068e7de$var$VueNumber = {
    install: function(Vue) {
        Vue.component("number", (0, $fdb37e6edc8b94b1$export$2e2bcd8739ae039));
    }
};
var $a5f084e3f068e7de$export$2e2bcd8739ae039 = $a5f084e3f068e7de$var$VueNumber;
if (typeof window !== "undefined" && window.Vue) window.Vue.use($a5f084e3f068e7de$var$VueNumber);


let $552fee0b0f851a0b$var$script;



let $552fee0b0f851a0b$var$initialize = ()=>{
    $552fee0b0f851a0b$var$script = (parcelRequire("8vTj4"));
    if ($552fee0b0f851a0b$var$script.__esModule) $552fee0b0f851a0b$var$script = $552fee0b0f851a0b$var$script.default;
    $552fee0b0f851a0b$var$script.render = (parcelRequire("hDUKP")).render;
    (parcelRequire("16hh2")).default($552fee0b0f851a0b$var$script);
    $552fee0b0f851a0b$var$script.__scopeId = "data-v-80e8dd";
    $552fee0b0f851a0b$var$script.__file = "VueWooSearch.vue";
};
$552fee0b0f851a0b$var$initialize();
var $552fee0b0f851a0b$export$2e2bcd8739ae039 = $552fee0b0f851a0b$var$script;


let $f62db91a744409b0$var$script;



let $f62db91a744409b0$var$initialize = ()=>{
    $f62db91a744409b0$var$script = (parcelRequire("gSRBC"));
    if ($f62db91a744409b0$var$script.__esModule) $f62db91a744409b0$var$script = $f62db91a744409b0$var$script.default;
    $f62db91a744409b0$var$script.render = (parcelRequire("h7zDt")).render;
    (parcelRequire("gkOOl")).default($f62db91a744409b0$var$script);
    $f62db91a744409b0$var$script.__scopeId = "data-v-9b1838";
    $f62db91a744409b0$var$script.__file = "VueWooProductNavBar.vue";
};
$f62db91a744409b0$var$initialize();
var $f62db91a744409b0$export$2e2bcd8739ae039 = $f62db91a744409b0$var$script;


const $050cabe060aa1d86$var$searchApp = (0, $k72mp.createApp)((0, $552fee0b0f851a0b$export$2e2bcd8739ae039));
const $050cabe060aa1d86$var$productNavApp = (0, $k72mp.createApp)((0, $f62db91a744409b0$export$2e2bcd8739ae039));
// const productList = createApp(VueWooProducts)
$050cabe060aa1d86$var$productNavApp.use((0, $a5f084e3f068e7de$export$2e2bcd8739ae039));
$050cabe060aa1d86$var$searchApp.mount("#shopSearch");
$050cabe060aa1d86$var$productNavApp.mount("#productNav");

})();
//# sourceMappingURL=index.js.map
